import '../index.css';import { jsxs as x, jsx as t, Fragment as Se } from "react/jsx-runtime";
import { faGraduationCap as Rn } from "@fortawesome/pro-regular-svg-icons/faGraduationCap";
import { faSchoolFlag as Nn } from "@fortawesome/pro-regular-svg-icons/faSchoolFlag";
import { faSuitcase as Tn } from "@fortawesome/pro-regular-svg-icons/faSuitcase";
import { faUser as Wn } from "@fortawesome/pro-solid-svg-icons/faUser";
import An from "@mui/material/Avatar";
import L from "classnames";
import je, { useState as ke, useRef as it, useEffect as gt, forwardRef as Ce } from "react";
import Ct from "@mui/material/useMediaQuery";
import { Typography as zn, Tooltip as En, Box as On, Drawer as Hn, Dialog as Gn, TextField as jn, MenuItem as Un, ListItemIcon as Xt, Divider as Xn, Menu as qn, Popover as Yn } from "@mui/material";
import { createTheme as Zn, ThemeProvider as Kn } from "@mui/material/styles";
import { faArrowDownToLine as Vn } from "@fortawesome/pro-regular-svg-icons/faArrowDownToLine";
import { faLoader as Jn } from "@fortawesome/pro-regular-svg-icons/faLoader";
import { faLock as Qn } from "@fortawesome/pro-regular-svg-icons/faLock";
import { faPencil as Pn } from "@fortawesome/pro-regular-svg-icons/faPencil";
import { faPlus as eo } from "@fortawesome/pro-regular-svg-icons/faPlus";
import { faTrashCan as to } from "@fortawesome/pro-regular-svg-icons/faTrashCan";
import { faArrowRight as no } from "@fortawesome/pro-solid-svg-icons/faArrowRight";
import { faChevronDown as oo } from "@fortawesome/pro-solid-svg-icons/faChevronDown";
import { faChevronRight as ao } from "@fortawesome/pro-solid-svg-icons/faChevronRight";
import { Link as lt, useNavigate as ro } from "react-router-dom";
import { faCaretDown as io } from "@fortawesome/pro-solid-svg-icons/faCaretDown";
import { dayjsLocalizer as lo, Calendar as co } from "react-big-calendar";
import { FontAwesomeIcon as so } from "@fortawesome/react-fontawesome";
import { faChevronLeft as qt } from "@fortawesome/pro-regular-svg-icons/faChevronLeft";
import { faLightbulbOn as kt } from "@fortawesome/pro-solid-svg-icons/faLightbulbOn";
import { faCircleCheck as Yt } from "@fortawesome/pro-solid-svg-icons/faCircleCheck";
import { faCircleInfo as Zt } from "@fortawesome/pro-solid-svg-icons/faCircleInfo";
import { faHandWave as Kt } from "@fortawesome/pro-solid-svg-icons/faHandWave";
import { faHourglassHalf as Vt } from "@fortawesome/pro-solid-svg-icons/faHourglassHalf";
import { faLock as Jt } from "@fortawesome/pro-solid-svg-icons/faLock";
import { faOctagonExclamation as Qt } from "@fortawesome/pro-solid-svg-icons/faOctagonExclamation";
import { faTriangleExclamation as Pt } from "@fortawesome/pro-solid-svg-icons/faTriangleExclamation";
import { faCheck as uo } from "@fortawesome/pro-regular-svg-icons/faCheck";
import { faCircleInfo as mo } from "@fortawesome/pro-regular-svg-icons/faCircleInfo";
import { faMinus as fo } from "@fortawesome/pro-solid-svg-icons/faMinus";
import ho from "@mui/material/Checkbox";
import go from "@mui/material/FormControlLabel";
import po from "@mui/material/Divider";
import { faXmark as pt } from "@fortawesome/pro-regular-svg-icons/faXmark";
import _o from "@mui/material/IconButton";
import Co from "@mui/material/Paper";
import _n from "react-spinkit";
import bo from "@mui/material/LinearProgress";
import yo from "@mui/material/ToggleButtonGroup";
import en from "@mui/material/ToggleButton";
import pe from "@mui/material/Skeleton";
import Lo from "@mui/material/Tabs";
import So from "@mui/material/Tab";
import { faLoader as xo } from "@fortawesome/pro-solid-svg-icons/faLoader";
import { faEye as vo } from "@fortawesome/pro-regular-svg-icons/faEye";
import { faEyeSlash as wo } from "@fortawesome/pro-regular-svg-icons/faEyeSlash";
import ko from "@mui/material/InputAdornment";
import { faAngleDown as Mo } from "@fortawesome/pro-regular-svg-icons/faAngleDown";
import $o from "@mui/material/Switch";
import { faInfoCircle as Do } from "@fortawesome/pro-regular-svg-icons/faInfoCircle";
import { faCheck as Fo } from "@fortawesome/pro-solid-svg-icons/faCheck";
import { faMagnifyingGlass as Io } from "@fortawesome/pro-regular-svg-icons/faMagnifyingGlass";
var Cn = /* @__PURE__ */ ((e) => (e.Circular = "circular", e.Rounded = "rounded", e.Square = "square", e))(Cn || {});
const Bo = "_container_rphbo_1", Ro = "_textContainer_rphbo_8", No = "_text_rphbo_8", To = "_overflowText_rphbo_16", ct = {
  container: Bo,
  textContainer: Ro,
  text: No,
  overflowText: To
}, Wo = (e = "") => {
  if (typeof e != "string" || !e.trim())
    return "";
  const n = e.trim().split(/\s+/);
  return n.length === 1 ? n[0].slice(0, 2).toUpperCase() : (n[0][0] + n[n.length - 1][0]).toUpperCase();
}, Su = ({
  avatarLink: e = "",
  name: o,
  description: n = "",
  tooltipText: a = "",
  avatarVariant: r = Cn.Circular,
  isAlum: i = !1,
  forceTooltip: s = !1
}) => {
  const l = Wo(o), c = !!e || !!l;
  return /* @__PURE__ */ x(k, { alignItems: "center", className: ct.container, columnGap: 1, children: [
    c && /* @__PURE__ */ t(Oo, { size: "sm", src: e, variant: r, children: l }),
    /* @__PURE__ */ x(
      k,
      {
        className: ct.textContainer,
        flexDirection: "column",
        flexGrow: 1,
        justifyContent: "flex-start",
        children: [
          !!o && /* @__PURE__ */ t(z, { variant: "bodySm500", children: o }),
          !!n && /* @__PURE__ */ x(k, { alignItems: "center", columnGap: 0.5, children: [
            i && /* @__PURE__ */ t(
              E,
              {
                color: "contentTertiary",
                "data-testid": "grad-cap",
                icon: Rn,
                size: "xs"
              }
            ),
            /* @__PURE__ */ t("div", { className: ct.text, children: /* @__PURE__ */ t(
              gl,
              {
                centered: !1,
                color: "contentTertiary",
                containerClassName: ct.overflowText,
                forceTooltip: s,
                isClickable: !1,
                offset: 10,
                text: n,
                tooltipProps: {
                  placement: "bottom",
                  title: a
                },
                useMinContent: !1,
                variant: "captionReg400"
              }
            ) })
          ] })
        ]
      }
    )
  ] });
}, Mt = {
  lg: {
    width: 48,
    height: 48,
    icon: "lg"
  },
  md: {
    width: 40,
    height: 40,
    /**
     * 'md' is not a valid size for FontAwesomeIcon.
     * When undefined is passed to FontAwesomeIcon as a size value,
     * the icon will default to the current font size of its parent element.
     */
    icon: void 0
  },
  sm: {
    width: 32,
    height: 32,
    icon: "sm"
  },
  xs: {
    width: 24,
    height: 24,
    icon: "xs"
  }
}, Ao = ({
  size: e = "md",
  children: o,
  fallback: n,
  alt: a
}) => {
  var i;
  if (o)
    return o;
  const r = ((i = Mt[e]) == null ? void 0 : i.icon) ?? Mt.md.icon;
  switch (n) {
    case "person":
      return /* @__PURE__ */ t(
        E,
        {
          alt: a,
          color: "contentInverted",
          icon: Wn,
          size: r
        }
      );
    case "school":
      return /* @__PURE__ */ t(
        E,
        {
          alt: a,
          color: "contentInverted",
          icon: Nn,
          size: r
        }
      );
    case "employer":
      return /* @__PURE__ */ t(
        E,
        {
          alt: a,
          color: "contentInverted",
          icon: Tn,
          size: r
        }
      );
    default:
      return null;
  }
}, zo = "_root_no82u_1", Eo = "_text_no82u_5", tn = {
  root: zo,
  text: Eo
}, Oo = ({
  children: e = void 0,
  fallback: o = "person",
  size: n = "md",
  ...a
}) => /* @__PURE__ */ t(
  An,
  {
    className: L(tn.root, { [tn.text]: !!e }),
    sx: Mt[n],
    ...a,
    children: Ao({ size: n, fallback: o, children: e, alt: a.alt })
  }
), m = {
  white: "#FFFFFF",
  black: "#000000",
  scrim: "rgba(30, 26, 18, 0.4)",
  brand50: "#FEFEF4",
  brand100: "#FDFBD2",
  brand200: "#FBF7A5",
  brand300: "#F9F478",
  brand400: "#F9F478",
  brand500: "#F5EC1E",
  brand600: "#DCD41B",
  brand700: "#ABA515",
  brand800: "#7A7506",
  brand900: "#4A4709",
  ink50: "#F4F4F3",
  ink100: "#E8E8E7",
  ink200: "#D2D1D0",
  ink300: "#BBBAB8",
  ink400: "#A5A3A0",
  ink500: "#8E8C88",
  ink600: "#787671",
  ink700: "#625F59",
  ink800: "#4B4841",
  ink900: "#1E1A12",
  sun50: "#FFFBEB",
  sun100: "#FFF7D7",
  sun200: "#FFEFB1",
  sun300: "#FFE88A",
  sun400: "#FFDF5E",
  sun500: "#FFD52E",
  sun600: "#EDC421",
  sun700: "#BF9A08",
  sun800: "#BF9A08",
  sun900: "#8E7203",
  red50: "#FFF5F0",
  red100: "#FCE4D7",
  red200: "#FAC3AF",
  red300: "#F09785",
  red400: "#E16E63",
  red500: "#CD3535",
  red600: "#B02632",
  red700: "#931A2F",
  red800: "#76102B",
  red900: "#620A28",
  orange50: "#FFFCF2",
  orange100: "#FEF2CC",
  orange200: "#FEE29A",
  orange300: "#FECC67",
  orange400: "#FDB841",
  orange500: "#FC9603",
  orange600: "#D87702",
  orange700: "#B55C01",
  orange800: "#924400",
  orange900: "#652B00",
  green50: "#FCFFF6",
  green100: "#EEFCD4",
  green200: "#D8FAAA",
  green300: "#BAF27D",
  green400: "#9BE65B",
  green500: "#6FD62A",
  green600: "#53B81E",
  green700: "#3A9A15",
  green800: "#267C0D",
  green900: "#105D01",
  teal50: "#F3FFFE",
  teal100: "#D9FBF7",
  teal200: "#B5F8F5",
  teal300: "#8CE7EA",
  teal400: "#6ACAD6",
  teal500: "#3EA4BB",
  teal600: "#2D82A0",
  teal700: "#1F6486",
  teal800: "#13486C",
  teal900: "#0B3359",
  blue50: "#F4F9FF",
  blue100: "#D4E8FE",
  blue200: "#AACEFE",
  blue300: "#7FB1FE",
  blue400: "#5F99FE",
  blue500: "#1963FD",
  blue600: "#1F56DA",
  blue700: "#153FB6",
  blue800: "#0D2B93",
  blue900: "#001467",
  purple50: "#FDF6FF",
  purple100: "#F8D5FF",
  purple200: "#ECABFF",
  purple300: "#DC82FF",
  purple400: "#CA63FF",
  purple500: "#AD2FFF",
  purple600: "#8722DB",
  purple700: "#6517B7",
  purple800: "#470E93",
  purple900: "#250066"
}, Ho = {
  default: m.white,
  hover: m.ink50,
  pressed: m.ink100,
  selected: m.ink100,
  defaultSecondary: m.ink50,
  accentDefault: m.ink50,
  scrollbar: m.ink400,
  primaryDefault: m.blue500,
  primaryHover: m.blue400,
  primaryPressed: m.blue300,
  secondaryDefault: m.ink900,
  secondaryHover: m.ink800,
  secondaryPressed: m.ink700,
  brandDefault: m.brand500,
  brandHover: m.brand600,
  brandPressed: m.brand700,
  disabledDefault: m.ink200,
  disabledOnDisabledSurface: m.ink500,
  criticalPrimaryDefault: m.red600,
  criticalPrimaryHover: m.red700,
  criticalPrimaryPressed: m.red800,
  criticalSecondaryHover: m.red50,
  criticalSecondaryPressed: m.red100,
  statusCriticalAccent: m.red700,
  statusCriticalSubtle: m.red100,
  statusSuccessDefault: m.green800,
  statusSuccessHover: m.green700,
  statusSuccessPressed: m.green600,
  statusSuccessSubtle: m.green100,
  statusInfoDefault: m.blue600,
  statusInfoSubtle: m.blue100,
  statusInfoSubtlest: m.blue50,
  statusWarningDefault: m.orange700,
  statusWarningSubtle: m.orange100,
  statusNoteDefault: m.purple600,
  statusNoteSubtle: m.purple100,
  statusProgressDefault: m.sun900,
  statusProgressHover: m.sun800,
  statusProgressPressed: m.sun700,
  statusProgressSubtle: m.sun100
}, Go = {
  white: m.white,
  black: m.black,
  default: m.ink900,
  secondary: m.ink700,
  tertiary: m.ink500,
  inverted: m.white,
  disabledDefault: m.ink200,
  disabledOnDisabledSurface: m.ink500,
  disabledOnBrandSurface: m.brand700,
  criticalDefault: m.red500,
  criticalHover: m.red600,
  criticalPressed: m.red700,
  linkDefault: m.blue500,
  linkHover: m.blue400,
  linkPressed: m.blue700,
  statusCriticalAccent: m.red700,
  statusSuccess: m.green800,
  statusInfo: m.blue600,
  statusWarning: m.orange700,
  statusNote: m.purple600,
  statusProgress: m.sun900
}, jo = {
  default: m.ink50,
  defaultSecondary: m.ink100,
  scrim: m.scrim
}, Uo = {
  default: m.ink100,
  defaultHover: m.ink500,
  defaultSelected: m.ink900,
  secondary: m.ink200,
  accent: m.ink900,
  brandDefault: m.brand600,
  brandHover: m.brand700,
  brandPressed: m.brand800,
  disabled: m.ink200,
  criticalDefault: m.red600,
  criticalHover: m.red700,
  criticalPressed: m.red800,
  statusCriticalAccent: m.red600,
  statusSuccess: m.green700,
  statusInfo: m.blue500,
  statusWarning: m.orange600,
  statusNote: m.purple600,
  statusProgress: m.sun900,
  focus: m.purple500
}, Xo = {
  critical: m.red500,
  criticalLight: m.red300,
  criticalBackground: m.red100,
  warning: m.orange500,
  warningLight: m.orange300,
  warningBackground: m.orange100,
  progress: m.sun500,
  progressLight: m.sun200,
  progressBackground: m.sun100,
  success: m.green500,
  successLight: m.green300,
  successBackground: m.green100,
  info: m.blue500,
  infoLight: m.blue300,
  infoBackground: m.blue100,
  note: m.purple500,
  noteLight: m.purple200,
  noteBackground: m.purple100,
  neutral: m.ink800,
  neutralLight: m.ink400,
  neutralBackground: m.ink100
}, xe = {
  blackV2: "#1e1a12",
  font: "#363636",
  brandClever: "#4271f6",
  brandOneroster: "#0f4d87",
  blue: "#4397ea",
  blueBg: "#f5fbff",
  blueDark: "#2386e7",
  blueXtraDark: "#1477d8",
  blueContrastDark: "#124577",
  blueExtraLight: "#e6f3fa",
  blueLight: "#c4e1f2",
  blueMedium: "#68aaee",
  blueSteel: "#728dac",
  blueSteelDark: "#5f7ea0",
  blueSteelXtraDark: "#516d8f",
  blueSteelContrastDark: "#3a4e66",
  blueSteelExtraLight: "#e8eff5",
  blueSteelLight: "#cbdaeb",
  blueSteelMedium: "#8da7c4",
  gray: "#999",
  grayBg: "#f6f6f6",
  grayDark: "#6f6f6f",
  grayDarkV2: "#71726e",
  grayXtraDark: "#595959",
  grayExtraLight: "#eee",
  grayLight: "#dbdbdb",
  grayMedium: "#bebdbd",
  green: "#5aa43d",
  greenBg: "#fbfff4",
  greenDark: "#429617",
  greenXtraDark: "#268900",
  greenContrastDark: "#1c6400",
  greenExtraLight: "#f1f6e6",
  greenLight: "#ddedc9",
  greenMedium: "#7db866",
  indigo: "#7180d6",
  indigoDark: "#5d6ed0",
  indigoXtraDark: "#5364c6",
  indigoContrastDark: "#394799",
  indigoExtraLight: "#e6e9f8",
  indigoLight: "#b7c3ff",
  indigoMedium: "#8c99e3",
  orange: "#ff8000",
  orangeDark: "#f07000",
  orangeXtraDark: "#d66000",
  orangeContrastDark: "#99430d",
  orangeExtraLight: "#feedd5",
  orangeLight: "#ffd9b8",
  orangeMedium: "#fc9b5f",
  purple: "#9974dc",
  purpleDark: "#8d64d8",
  purpleXtraDark: "#8861cf",
  purpleContrastDark: "#583cbd",
  purpleExtraLight: "#ede8f8",
  purpleLight: "#d9c4ff",
  purpleMedium: "#ae8fea",
  red: "#e46658",
  redDark: "#d85446",
  redXtraDark: "#d24536",
  redContrastDark: "#9e2518",
  redExtraLight: "#ffe9e9",
  redLight: "#ffb3ab",
  redMedium: "#f67c6f",
  teal: "#16a2a2",
  tealDark: "#149090",
  tealDarkV2: "#2b7383",
  tealXtraDark: "#128484",
  tealContrastDark: "#0a5656",
  tealExtraLight: "#e3f4f2",
  tealLight: "#cceaea",
  tealLightV2: "#ecf5f7",
  tealMedium: "#62bcbc",
  violet: "#c863d9",
  violetDark: "#c253d5",
  violetXtraDark: "#ba3dd0",
  violetContrastDark: "#752383",
  violetExtraLight: "#f5e9f7",
  violetLight: "#f6c8ff",
  violetMedium: "#d68ce3",
  pink: "#d85a8c",
  pinkDark: "#cc3e76",
  pinkXtraDark: "#ba2c65",
  pinkContrastDark: "#811d45",
  pinkExtraLight: "#ffebf3",
  pinkLight: "#ffcce0",
  pinkMedium: "#fbb1cf",
  yellow: "#fad961",
  yellowV2: "#f5ec1e",
  yellowDark: "#f5c614",
  yellowXtraDark: "#eebc04",
  yellowContrastDark: "#986f15",
  yellowContrastLight: "#ffffef",
  yellowExtraLight: "#fff7da",
  yellowLight: "#ffefb7",
  yellowLightV2: "#fbfbca",
  yellowMedium: "#fbdf78",
  yellowTextDark: "#b28d02",
  ...m
}, qo = {
  base: "'Bricolage Grotesque', 'Segoe UI', 'HelveticaNeue-Light', sans-serif",
  baseV2: "'Bricolage Grotesque', 'Segoe UI', 'HelveticaNeue-Light', sans-serif",
  body: "'Geist', 'Segoe UI', 'HelveticaNeue-Light', sans-serif",
  code: "'Geist Mono', 'Segoe UI', 'HelveticaNeue-Light', sans-serif",
  signature: "'Sofia', cursive",
  emoji: "emoji"
}, Yo = {
  robotoLight: 300,
  robotoRegular: 400,
  robotoMedium: 500,
  robotoBold: 700,
  robotoBlack: 900,
  halisThin: 100,
  halisLight: 300,
  halisBook: 400,
  halisRegular: 500,
  halisMedium: 600,
  halisBold: 700,
  halisBlack: 800,
  thin: 100,
  extraLight: 200,
  light: 300,
  normal: 400,
  medium: 500,
  semiBold: 600,
  bold: 700,
  extraBold: 800,
  black: 900
}, Z = {
  0: "0px",
  25: "2px",
  50: "4px",
  75: "6px",
  100: "8px",
  150: "12px",
  200: "16px",
  250: "20px",
  300: "24px",
  400: "32px",
  full: "999px"
}, tt = {
  100: "0px 2px 4px 0px rgba(20, 27, 40, 0.12), 0px 1px 2px 0px rgba(20, 27, 40, 0.08)",
  200: "0px 4px 8px -2px rgba(20, 27, 40, 0.16), 0px 2px 4px -2px rgba(20, 27, 40, 0.08)",
  300: "0px 12px 16px -4px rgba(20, 27, 40, 0.16), 0px 4px 6px -2px rgba(20, 27, 40, 0.08)",
  400: "0px 16px 48px -8px rgba(20, 26, 40, 0.24)"
}, nn = "74px", Zo = {
  iconXxs: "10px",
  iconXs: "12px",
  iconXtSm: "14px",
  iconSm: "16px",
  iconMd: "20px",
  iconLg: "24px",
  iconXl: "32px",
  iconXxl: "40px",
  fontSizeTitleLg: "64px",
  fontSizeTitle: "26px",
  fontSizeTitleSm: "24px",
  fontSizeTitleXs: "22px",
  fontSizeLg: "20px",
  fontSizeMd: "18px",
  fontSizeSm: "16px",
  fontSizeXs: "14px",
  fontSizeXxs: "12px",
  fontSizeXxxs: "10px",
  fontSizeEmoji: "32px",
  appbarHeight: nn,
  sidebarWidth: "64px",
  subnavHeight: "48px",
  containerBorderWidth: "2px",
  containerBorderRadiusLarge: Z[400],
  containerBorderRadiusMedium: Z[200],
  containerBorderRadius: Z[100],
  containerBorderRadiusXtSmall: Z[75],
  containerBorderRadiusSmall: Z[50],
  containerBorderRadiusTop: `${Z[100]} ${Z[100]} 0 0`,
  containerBorderRadiusBottom: `0 0 ${Z[100]} ${Z[100]}`,
  containerBorderRadiusLeft: `${Z[100]} 0 0 ${Z[100]}`,
  containerBorderRadiusRight: `0 ${Z[100]} ${Z[100]} 0`,
  containerBorderRadiusTopLeft: `${Z[100]} 0 0 0`,
  containerBorderRadiusTopRight: `0 ${Z[100]} 0 0`,
  containerBorderRadiusBottomLeft: `0 0 0 ${Z[100]}`,
  containerBorderRadiusBottomRight: `0 0 ${Z[100]} 0`,
  contentHeight: `calc(100vh - ${nn})`,
  chatBorderRadiusTopLeft: `${Z[25]} ${Z[200]} ${Z[200]} ${Z[200]}`,
  shadow: tt[200],
  shadowTop: "0 -2px 10px 0 rgba(0, 0, 0, 0.15)",
  shadowExtraLight: "0 1px 5px rgba(0, 0, 0, 0.12)",
  shadowLight: tt[100],
  shadowMedium: tt[300],
  shadowStrong: tt[400],
  shadowInset: "inset 0 0 5px 0 rgba(0, 0, 0, 0.1)",
  shadowBottom: "0px 10px 10px -6px rgba(0, 0, 0, 0.15)",
  shadowBlue: "0px 0px 0px 2px rgba(18, 69, 119, 0.40)",
  shadowGray: "0px 0px 0px 2px rgba(190, 189, 189, 0.40)",
  shadowRed: "0px 0px 0px 2px rgba(158, 37, 24, 0.40)",
  shadowFont: "0px 2px 0px 0px #363636"
}, me = {
  0: "0px",
  25: "2px",
  50: "4px",
  75: "6px",
  100: "8px",
  150: "12px",
  200: "16px",
  250: "20px",
  300: "24px",
  400: "32px",
  450: "36px",
  500: "40px",
  600: "48px",
  700: "56px",
  800: "64px",
  900: "72px",
  1e3: "80px",
  1050: "88px",
  1100: "96px",
  1150: "104px",
  1200: "112px",
  1300: "160px",
  1400: "200px",
  1500: "280px",
  1600: "360px",
  1700: "400px",
  1800: "480px",
  1900: "520px"
}, Ko = {
  tt: me[0],
  tiny: me[25],
  xxs: me[50],
  xs: me[100],
  xtSm: me[100],
  input: me[100],
  sm: me[150],
  md: me[200],
  xtMd: me[300],
  lg: me[400],
  xl: me[500],
  xxl: me[600]
}, ve = {
  0: "0px",
  15: "0.6px",
  25: "1px",
  50: "2px",
  75: "4px"
}, Vo = {
  defaultGray: `${ve[50]} solid ${xe.gray}`,
  defaultGrayLight: `${ve[25]} solid ${xe.grayLight}`,
  defaultGrayMedium: `${ve[25]} solid ${xe.grayMedium}`,
  defaultGrayExtraLight: `${ve[25]} solid ${xe.grayExtraLight}`,
  defaultBlue: `${ve[25]} solid ${xe.blue}`,
  defaultBlueDark: `${ve[50]} solid ${xe.blueDark}`,
  defaultRed: `${ve[50]} solid ${xe.red}`,
  focusBlue: `${ve[50]} solid ${xe.blue}`,
  white: `${ve[25]} solid ${xe.white}`
}, Jo = {
  widthXs: "520px",
  widthSm: "640px",
  widthMd: "760px",
  widthLg: "880px",
  widthXl: "960px"
}, nt = {
  mobileMin: "320px",
  mobileMax: "560px",
  tabletMin: "561px",
  tabletMax: "1020px",
  desktopMin: "1021px"
}, Qo = {
  blue: "3px solid rgba(20, 119, 216, 0.75)",
  gray: "3px solid rgba(89, 89, 89, 0.75)",
  red: "3px solid rgba(210, 70, 54, 0.75)",
  green: "3px solid rgba(38, 137, 0, 0.76)"
}, f = {
  color: xe,
  surface: Ho,
  content: Go,
  graph: Xo,
  background: jo,
  borderColor: Uo,
  fontFamily: qo,
  schoolinks: Zo,
  spacing: Ko,
  border: Vo,
  modal: Jo,
  breakpoint: nt,
  focusOutline: Qo,
  elevation: tt,
  radius: Z,
  borderWidth: ve,
  space: me,
  fontWeight: Yo
}, Po = {
  mobile: `(max-width: ${nt.mobileMax})`,
  tablet: `(min-width: ${nt.tabletMin}) and (max-width: ${nt.tabletMax})`,
  desktop: `(min-width: ${nt.desktopMin})`
}, Nt = (e = Po) => {
  const o = Ct(e.mobile), n = Ct(e.tablet), a = Ct(e.desktop);
  return { isMobile: o, isTablet: n, isDesktop: a };
};
var I = /* @__PURE__ */ ((e) => (e.h1 = "h1", e.h2 = "h2", e.h3 = "h3", e.h4 = "h4", e.h5 = "h5", e.h6 = "h6", e.h6Mobile = "h6Mobile", e.lead700 = "lead700", e.lead500 = "lead500", e.lead400 = "lead400", e.titleReg700 = "titleReg700", e.titleReg500 = "titleReg500", e.titleSm700 = "titleSm700", e.titleSm500 = "titleSm500", e.bodyReg700 = "bodyReg700", e.bodyReg600 = "bodyReg600", e.bodyReg500 = "bodyReg500", e.bodyReg400 = "bodyReg400", e.bodySm700 = "bodySm700", e.bodySm600 = "bodySm600", e.bodySm500 = "bodySm500", e.bodySm400 = "bodySm400", e.linkLg700 = "linkLg700", e.linkLg600 = "linkLg600", e.linkReg700 = "linkReg700", e.linkReg600 = "linkReg600", e.linkSm700 = "linkSm700", e.linkSm600 = "linkSm600", e.linkXs700 = "linkXs700", e.linkXs600 = "linkXs600", e.captionReg700 = "captionReg700", e.captionReg600 = "captionReg600", e.captionReg500 = "captionReg500", e.captionReg400 = "captionReg400", e.captionSm700 = "captionSm700", e.captionSm500 = "captionSm500", e.captionSm400 = "captionSm400", e.stats1 = "stats1", e.stats2 = "stats2", e.stats3 = "stats3", e.stats4 = "stats4", e.stats5 = "stats5", e.stats6 = "stats6", e.stats7 = "stats7", e.stats7Mobile = "stats7Mobile", e.mono = "mono", e.cursive = "cursive", e))(I || {});
const on = {
  h1: I.h2,
  h2: I.h3,
  h3: I.h4,
  h4: I.h5,
  h5: I.h6,
  h6: I.h6Mobile,
  stats1: I.stats2,
  stats2: I.stats3,
  stats3: I.stats4,
  stats4: I.stats5,
  stats5: I.stats6,
  stats6: I.stats7,
  stats7: I.stats7Mobile
}, an = {
  lead: I.lead400,
  leadBold: I.lead700,
  titleMd: I.titleReg500,
  titleMd500: I.titleReg500,
  titleMd700: I.titleReg700,
  titleMdBold: I.titleReg700,
  titleSm: I.titleSm500,
  titleSmBold: I.titleSm700,
  bodyMd400: I.bodyReg400,
  bodyMd500: I.bodyReg500,
  bodyMd600: I.bodyReg600,
  bodyMd700: I.bodyReg700,
  bodyMd: I.bodyReg400,
  bodyMdBold: I.bodyReg700,
  bodySm400: I.bodySm400,
  bodySm500: I.bodySm500,
  bodySm600: I.bodySm600,
  bodySm700: I.bodySm700,
  bodySm: I.bodySm400,
  bodySmBold: I.bodySm700,
  meta: I.captionReg400,
  meta400: I.captionReg400,
  meta700: I.captionReg700,
  metaBold: I.captionReg700,
  body1: I.bodyReg400,
  body2: I.bodySm400,
  subtitle1: I.titleReg500,
  subtitle2: I.titleSm500,
  caption: I.captionReg400,
  label: I.captionReg500,
  tiny: I.captionSm500,
  overline: I.captionSm500,
  button: I.bodyReg400
}, ea = (e) => typeof e == "string" && document.createElement(e) instanceof HTMLUnknownElement ? "p" : e, ta = (e, o) => {
  const n = Object.keys(an);
  return e in I ? o && on[e] ? on[e] : e : n.includes(e) ? an[e] : I.bodyReg500;
}, rn = {}, na = (e) => e.replace(/([a-z])([A-Z])/g, "$1 $2").replace(/(\d)([a-zA-Z])/g, "$1 $2").replace(/([a-zA-Z])(\d)/g, "$1 $2").replace(/[^a-zA-Z0-9]+/g, " ").trim().toLowerCase().replace(/\s+/g, "-"), xu = (e) => e.replace(/([a-z])([A-Z])/g, "$1 $2").replace(/[^a-zA-Z0-9]+/g, " ").trim().toLowerCase().replace(
  /(?:\s+|^)(\w)/g,
  (o, n, a) => a === 0 ? n : n.toUpperCase()
).replace(/\s+/g, ""), bn = (e, o = "") => typeof e == "string" ? e : ["boolean", "number"].includes(typeof e) ? String(e) : o, oa = `
/* 
* This file is auto-generated by running "yarn run build" (not "yarn run dev"). 
* Do not edit this file directly as changes will be overwritten.
* Add or update variables in src/utils/variables.js.
*/`, aa = (e) => {
  const o = [];
  for (const n in e) {
    const a = na(n), r = e[n];
    for (const i in r) {
      const s = i.replace(/([a-z])([A-Z0-9])/g, "$1-$2").toLowerCase(), l = `--${a}-${s}`, c = r[i];
      o.push(`${l}: ${c};`);
    }
  }
  return `${oa}
:root {
${o.map((n) => `  ${n}`).join(`
`)}
}
`;
}, vu = () => {
  let e = !1;
  return {
    name: "generate-css-vars",
    apply: "build",
    config(o) {
      var n;
      (n = o.build) != null && n.watch && (e = !0);
    },
    buildStart() {
      if (e)
        return;
      console.log("Generating CSS variables...");
      const o = aa(f), n = rn.resolve("./src/utils/variables.css");
      rn.writeFileSync(n, o, "utf-8"), console.log(`CSS variables written to ${n}`);
    }
  };
}, ra = {
  h1: {
    fontSize: 40,
    fontFamily: f.fontFamily.base,
    fontWeight: f.fontWeight.semiBold,
    fontStyle: "normal",
    lineHeight: "48px"
  },
  h2: {
    fontSize: 32,
    fontFamily: f.fontFamily.base,
    fontWeight: f.fontWeight.semiBold,
    fontStyle: "normal",
    lineHeight: "38px"
  },
  h3: {
    fontSize: 28,
    fontFamily: f.fontFamily.base,
    fontWeight: f.fontWeight.semiBold,
    fontStyle: "normal",
    lineHeight: "32px"
  },
  h4: {
    fontSize: 24,
    fontFamily: f.fontFamily.base,
    fontWeight: f.fontWeight.semiBold,
    fontStyle: "normal",
    lineHeight: "28px"
  },
  h5: {
    fontSize: 22,
    fontFamily: f.fontFamily.base,
    fontWeight: f.fontWeight.semiBold,
    fontStyle: "normal",
    lineHeight: "26px"
  },
  h6: {
    fontSize: 20,
    fontFamily: f.fontFamily.base,
    fontWeight: f.fontWeight.semiBold,
    fontStyle: "normal",
    lineHeight: "24px"
  },
  h6Mobile: {
    fontSize: 18,
    fontFamily: f.fontFamily.base,
    fontWeight: f.fontWeight.semiBold,
    fontStyle: "normal",
    lineHeight: "24px"
  },
  lead700: {
    fontSize: 18,
    fontFamily: f.fontFamily.body,
    fontWeight: f.fontWeight.bold,
    fontStyle: "normal",
    lineHeight: "24px"
  },
  lead500: {
    fontSize: 18,
    fontFamily: f.fontFamily.body,
    fontWeight: f.fontWeight.medium,
    fontStyle: "normal",
    lineHeight: "24px"
  },
  lead400: {
    fontSize: 18,
    fontFamily: f.fontFamily.body,
    fontWeight: f.fontWeight.normal,
    fontStyle: "normal",
    lineHeight: "24px"
  },
  titleReg700: {
    fontSize: 18,
    fontFamily: f.fontFamily.body,
    fontWeight: f.fontWeight.bold,
    fontStyle: "normal",
    lineHeight: "24px"
  },
  titleReg500: {
    fontSize: 18,
    fontFamily: f.fontFamily.body,
    fontWeight: f.fontWeight.medium,
    fontStyle: "normal",
    lineHeight: "24px"
  },
  titleSm700: {
    fontSize: 16,
    fontFamily: f.fontFamily.body,
    fontWeight: f.fontWeight.bold,
    fontStyle: "normal",
    lineHeight: "24px"
  },
  titleSm500: {
    fontSize: 16,
    fontFamily: f.fontFamily.body,
    fontWeight: f.fontWeight.medium,
    fontStyle: "normal",
    lineHeight: "24px"
  },
  bodyReg700: {
    fontSize: 16,
    fontFamily: f.fontFamily.body,
    fontWeight: f.fontWeight.bold,
    fontStyle: "normal",
    lineHeight: "24px"
  },
  bodyReg600: {
    fontSize: 16,
    fontFamily: f.fontFamily.body,
    fontWeight: f.fontWeight.semiBold,
    fontStyle: "normal",
    lineHeight: "24px"
  },
  bodyReg500: {
    fontSize: 16,
    fontFamily: f.fontFamily.body,
    fontWeight: f.fontWeight.medium,
    fontStyle: "normal",
    lineHeight: "24px"
  },
  bodyReg400: {
    fontSize: 16,
    fontFamily: f.fontFamily.body,
    fontWeight: f.fontWeight.normal,
    fontStyle: "normal",
    lineHeight: "24px"
  },
  bodySm700: {
    fontSize: 14,
    fontFamily: f.fontFamily.body,
    fontWeight: f.fontWeight.bold,
    fontStyle: "normal",
    lineHeight: "20px"
  },
  bodySm600: {
    fontSize: 14,
    fontFamily: f.fontFamily.body,
    fontWeight: f.fontWeight.semiBold,
    fontStyle: "normal",
    lineHeight: "20px"
  },
  bodySm500: {
    fontSize: 14,
    fontFamily: f.fontFamily.body,
    fontWeight: f.fontWeight.medium,
    fontStyle: "normal",
    lineHeight: "20px"
  },
  bodySm400: {
    fontSize: 14,
    fontFamily: f.fontFamily.body,
    fontWeight: f.fontWeight.normal,
    fontStyle: "normal",
    lineHeight: "20px"
  },
  linkLg700: {
    fontSize: 18,
    fontFamily: f.fontFamily.body,
    fontWeight: f.fontWeight.bold,
    fontStyle: "normal",
    lineHeight: "24px"
  },
  linkLg600: {
    fontSize: 18,
    fontFamily: f.fontFamily.body,
    fontWeight: f.fontWeight.semiBold,
    fontStyle: "normal",
    lineHeight: "24px"
  },
  linkReg700: {
    fontSize: 16,
    fontFamily: f.fontFamily.body,
    fontWeight: f.fontWeight.bold,
    fontStyle: "normal",
    lineHeight: "24px"
  },
  linkReg600: {
    fontSize: 16,
    fontFamily: f.fontFamily.body,
    fontWeight: f.fontWeight.semiBold,
    fontStyle: "normal",
    lineHeight: "24px"
  },
  linkSm700: {
    fontSize: 14,
    fontFamily: f.fontFamily.body,
    fontWeight: f.fontWeight.bold,
    fontStyle: "normal",
    lineHeight: "20px"
  },
  linkSm600: {
    fontSize: 14,
    fontFamily: f.fontFamily.body,
    fontWeight: f.fontWeight.semiBold,
    fontStyle: "normal",
    lineHeight: "20px"
  },
  linkXs700: {
    fontSize: 12,
    fontFamily: f.fontFamily.body,
    fontWeight: f.fontWeight.bold,
    fontStyle: "normal",
    lineHeight: "16px"
  },
  linkXs600: {
    fontSize: 12,
    fontFamily: f.fontFamily.body,
    fontWeight: f.fontWeight.semiBold,
    fontStyle: "normal",
    lineHeight: "16px"
  },
  captionReg700: {
    fontSize: 12,
    fontFamily: f.fontFamily.body,
    fontWeight: f.fontWeight.bold,
    fontStyle: "normal",
    lineHeight: "16px"
  },
  captionReg600: {
    fontSize: 12,
    fontFamily: f.fontFamily.body,
    fontWeight: f.fontWeight.semiBold,
    fontStyle: "normal",
    lineHeight: "16px"
  },
  captionReg500: {
    fontSize: 12,
    fontFamily: f.fontFamily.body,
    fontWeight: f.fontWeight.medium,
    fontStyle: "normal",
    lineHeight: "16px"
  },
  captionReg400: {
    fontSize: 12,
    fontFamily: f.fontFamily.body,
    fontWeight: f.fontWeight.normal,
    fontStyle: "normal",
    lineHeight: "16px"
  },
  captionSm700: {
    fontSize: 10,
    fontFamily: f.fontFamily.body,
    fontWeight: f.fontWeight.bold,
    fontStyle: "normal",
    lineHeight: "16px"
  },
  captionSm500: {
    fontSize: 10,
    fontFamily: f.fontFamily.body,
    fontWeight: f.fontWeight.medium,
    fontStyle: "normal",
    lineHeight: "16px"
  },
  captionSm400: {
    fontSize: 10,
    fontFamily: f.fontFamily.body,
    fontWeight: f.fontWeight.normal,
    fontStyle: "normal",
    lineHeight: "16px"
  },
  stats1: {
    fontSize: 48,
    fontFamily: f.fontFamily.body,
    fontWeight: f.fontWeight.bold,
    fontStyle: "normal",
    lineHeight: "56px"
  },
  stats2: {
    fontSize: 40,
    fontFamily: f.fontFamily.body,
    fontWeight: f.fontWeight.bold,
    fontStyle: "normal",
    lineHeight: "48px"
  },
  stats3: {
    fontSize: 32,
    fontFamily: f.fontFamily.body,
    fontWeight: f.fontWeight.bold,
    fontStyle: "normal",
    lineHeight: "38px"
  },
  stats4: {
    fontSize: 28,
    fontFamily: f.fontFamily.body,
    fontWeight: f.fontWeight.bold,
    fontStyle: "normal",
    lineHeight: "32px"
  },
  stats5: {
    fontSize: 24,
    fontFamily: f.fontFamily.body,
    fontWeight: f.fontWeight.bold,
    fontStyle: "normal",
    lineHeight: "28px"
  },
  stats6: {
    fontSize: 22,
    fontFamily: f.fontFamily.body,
    fontWeight: f.fontWeight.bold,
    fontStyle: "normal",
    lineHeight: "26px"
  },
  stats7: {
    fontSize: 20,
    fontFamily: f.fontFamily.body,
    fontWeight: f.fontWeight.bold,
    fontStyle: "normal",
    lineHeight: "24px"
  },
  stats7Mobile: {
    fontSize: 18,
    fontFamily: f.fontFamily.body,
    fontWeight: f.fontWeight.bold,
    fontStyle: "normal",
    lineHeight: "24px"
  },
  cursive: {
    fontSize: 16,
    fontFamily: f.fontFamily.signature,
    fontWeight: f.fontWeight.normal,
    fontStyle: "normal",
    lineHeight: "24px"
  },
  mono: {
    fontSize: 14,
    fontFamily: f.fontFamily.code,
    fontWeight: f.fontWeight.normal,
    fontStyle: "normal",
    lineHeight: "30px"
  }
}, { color: oe, content: ia } = f, la = Zn({
  typography: ra,
  palette: {
    primary: {
      main: oe.blue,
      light: oe.blue,
      dark: oe.blueDark,
      contrastText: oe.white
    },
    secondary: {
      main: oe.blue,
      light: oe.blue,
      dark: oe.blueDark,
      contrastText: oe.white
    },
    action: {
      hover: oe.blueExtraLight,
      selected: oe.blueExtraLight
    },
    error: {
      main: ia.criticalDefault
    }
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 320,
      // mobile
      md: 561,
      // tablet
      lg: 1021,
      // desktop
      xl: 1600
    }
  },
  components: {
    // Customization
    /*
      Body font properties updated to v4 to prevent UI bugs.
      Related documentation.
      https://mui.com/guides/migration-v4/#cssbaseline
    */
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          fontSize: "0.875rem",
          lineHeight: "1.43",
          letterSpacing: "0.01071em"
        }
      }
    },
    MuiChip: {
      styleOverrides: {
        root: {
          backgroundColor: "linear-gradient(0deg, rgba(2, 136, 209, 0.15), rgba(2, 136, 209, 0.15)), var(--color-white)"
        },
        icon: {
          marginRight: 4
        },
        deleteIcon: {
          marginLeft: 4
        },
        colorPrimary: {
          backgroundColor: oe.blueExtraLight,
          color: oe.font,
          "& > svg": {
            color: oe.font
          }
        },
        deleteIconColorPrimary: {
          "&:hover": {
            color: oe.font
          }
        },
        deletableColorPrimary: {
          "&:focus": {
            backgroundColor: oe.blueDark
          }
        }
      }
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          paddingTop: 11,
          paddingBottom: 11
        }
      }
    },
    MuiAutocomplete: {
      styleOverrides: {
        popper: {
          zIndex: 1400
          // has to be bigger than the MuiModal zIndex
        }
      }
    },
    // existing overrides
    MuiModal: {
      styleOverrides: {
        root: {
          // lowered from 1350 to 1300 so we can see date pickers in modals
          zIndex: 1300
        }
      }
    },
    MuiDialog: {
      defaultProps: {
        maxWidth: !1
      }
    },
    MuiDrawer: {
      styleOverrides: {
        root: {
          zIndex: 1300
        }
      }
    },
    MuiTableRow: {
      styleOverrides: {
        root: {
          "&$selected": {
            backgroundColor: "rgba(2,136,209,0.05)"
          },
          "&$hover:hover": {
            backgroundColor: "rgba(2,136,209,0.05)"
          }
        }
      }
    },
    MuiTablePagination: {
      defaultProps: {
        getItemAriaLabel: (e) => e === "next" ? "Next Page" : e === "previous" ? "Previous Page" : ""
      },
      styleOverrides: {
        selectLabel: {
          margin: 0
        },
        displayedRows: {
          margin: 0
        }
      }
    },
    MuiStepIcon: {
      styleOverrides: {
        root: {
          color: "#bbb !important",
          "&$active": {
            color: `${oe.blue} !important`
          },
          "&$completed": {
            color: `${oe.blue} !important`
          }
        },
        active: {},
        completed: {}
      }
    },
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          fontSize: 12
        }
      }
    },
    MuiSvgIcon: {
      styleOverrides: {
        root: {
          fill: void 0
        }
      }
    },
    MuiTypography: {
      styleOverrides: {
        root: {
          "& > .textLink, & > .textLinkButton": {
            textDecoration: "underline"
          }
        }
      }
    },
    MuiButtonBase: {
      defaultProps: {
        disableRipple: !0
      }
    },
    MuiYearPicker: {
      styleOverrides: {
        root: {
          "& .PrivatePickersYear-yearButton": {
            fontFamily: "Geist, sans-serif",
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
          }
        }
      }
    },
    PrivatePickersYear: {
      styleOverrides: {
        yearButton: {
          fontFamily: "Geist, sans-serif",
          display: "flex",
          alignItems: "center",
          justifyContent: "center"
        }
      }
    }
  }
}), yn = f.content.default, ca = /^#([a-fA-F0-9]{6}|[a-fA-F0-9]{3})$/g, sa = () => {
  const e = {
    content: f.content,
    surface: f.surface,
    graph: f.graph,
    background: f.background
  }, o = {};
  for (const n in e)
    if (Object.hasOwn(e, n)) {
      const a = e[n];
      for (const r in a)
        if (Object.hasOwn(a, r)) {
          const i = r.charAt(0).toUpperCase() + r.slice(1);
          o[`${n}${i}`] = a[r];
        }
    }
  return o;
}, _t = (e = "", o = "") => {
  const n = sa(), a = {
    ...f.color,
    ...f.content,
    // For backward compatibility with unprefixed content colors like 'default'
    ...n
  };
  return e in a ? a[e] : ca.test(e) ? e : (e && console.warn(`Wrong color name '${e}' provided, using fallback color.`), o || yn);
}, da = "_italic_kwzg6_8", ua = "_bold_kwzg6_12", ma = "_underlined_kwzg6_16", bt = {
  italic: da,
  bold: ua,
  underlined: ma
}, z = je.forwardRef(
  ({
    className: e,
    color: o = yn,
    component: n = "p",
    isBold: a,
    isItalic: r,
    isUnderlined: i,
    testId: s,
    variant: l = "bodyReg500",
    ...c
  }, d) => {
    const { isMobile: g } = Nt(), p = ta(l, g);
    return /* @__PURE__ */ t(
      zn,
      {
        ref: d,
        "data-testid": s,
        sx: { color: _t(o) },
        className: L(e, {
          [bt.italic]: r,
          [bt.bold]: a,
          [bt.underlined]: i
        }),
        variant: p,
        component: ea(n),
        ...c
      }
    );
  }
);
var te = /* @__PURE__ */ ((e) => (e.Critical = "critical", e.Neutral = "neutral", e.Warning = "warning", e.Success = "success", e.Info = "info", e.Note = "note", e.Progress = "progress", e.Disabled = "disabled", e))(te || {});
const Ln = (e) => Object.values(te).includes(
  e
) ? e : {
  blue: te.Info,
  "blue-steel": te.Info,
  gray: te.Neutral,
  green: te.Success,
  orange: te.Warning,
  red: te.Critical,
  teal: te.Info,
  yellow: te.Progress,
  disabled: te.Disabled
}[e] || te.Success, fa = "_badgeContainer_162po_3", ha = "_label_162po_9", ga = "_large_162po_17", pa = "_badge_162po_3", _a = "_small_162po_29", Ca = "_neutral_162po_46", ba = "_warning_162po_47", ya = "_progress_162po_48", La = "_critical_162po_49", Sa = "_info_162po_50", xa = "_success_162po_51", va = "_note_162po_52", wa = "_outlined_162po_61", ka = "_filled_162po_66", Ma = "_text_162po_71", $a = "_disabled_162po_184", Da = "_transparent_162po_206", Le = {
  badgeContainer: fa,
  label: ha,
  large: ga,
  badge: pa,
  small: _a,
  default: "_default_162po_35",
  neutral: Ca,
  warning: ba,
  progress: ya,
  critical: La,
  info: Sa,
  success: xa,
  note: va,
  outlined: wa,
  filled: ka,
  text: Ma,
  disabled: $a,
  transparent: Da
}, Je = ({
  label: e,
  style: o,
  classes: n,
  number: a = 0,
  color: r = te.Neutral,
  size: i = "default",
  variant: s = "filled",
  disableEmpty: l = !0,
  isDisabled: c = !1,
  badgeClassName: d
}) => {
  const g = s === "filled", p = s === "outlined", _ = s === "text", C = Ln(r), h = Le[C], v = i === "small" ? "captionSm700" : i === "large" ? "bodySm600" : "captionReg700";
  return /* @__PURE__ */ x("div", { className: L(Le.badgeContainer, n == null ? void 0 : n.root), style: o, children: [
    /* @__PURE__ */ t(
      "div",
      {
        className: L(
          Le.badge,
          h,
          Le[i],
          {
            [Le.transparent]: !g,
            [Le.disabled]: c || r === "disabled" || l && !a,
            [Le.outlined]: p,
            [Le.text]: _,
            [Le.filled]: g
          },
          d
        ),
        "data-testid": "badgeNumberContainer",
        children: /* @__PURE__ */ t(z, { "data-testid": "badgeNumber", variant: v, children: a })
      }
    ),
    e ? /* @__PURE__ */ t("div", { className: L(Le.label, Le[i]), "data-testid": "badgeLabel", children: e }) : null
  ] });
};
var K = /* @__PURE__ */ ((e) => (e.Default = "default", e.Secondary = "secondary", e.Critical = "critical", e))(K || {}), fe = /* @__PURE__ */ ((e) => (e.Small = "small", e.Medium = "medium", e.Large = "large", e.Default = "default", e))(fe || {}), ne = /* @__PURE__ */ ((e) => (e.Text = "text", e.Filled = "filled", e.Outlined = "outlined", e))(ne || {});
const Fa = "_button_acim8_1", Ia = "_compactButton_acim8_2", Ba = "_disabled_acim8_20", Ra = "_loading_acim8_57", Na = "_badge_acim8_63", Ta = "_withWhiteBackground_acim8_275", Wa = "_buttonLabel_acim8_293", Aa = "_badgeContainer_acim8_297", za = "_compactLabel_acim8_339", Ea = "_shadowButton_acim8_344", Oa = "_outlined_acim8_486", Ha = "_rightIcon_acim8_490", Ga = "_icon_acim8_494", ja = "_noLabel_acim8_495", Ua = "_noLabelContainer_acim8_517", Xa = "_label_acim8_521", qa = "_confirmationPopoverPaper_acim8_540", Ya = "_maxWidth_acim8_545", O = {
  button: Fa,
  compactButton: Ia,
  disabled: Ba,
  "size-small": "_size-small_acim8_24",
  "size-default": "_size-default_acim8_25",
  "size-medium": "_size-medium_acim8_32",
  "size-large": "_size-large_acim8_33",
  "color-default": "_color-default_acim8_56",
  loading: Ra,
  badge: Na,
  "color-secondary": "_color-secondary_acim8_76",
  "color-critical": "_color-critical_acim8_96",
  "variant-filled": "_variant-filled_acim8_116",
  "variant-outlined": "_variant-outlined_acim8_179",
  "variant-text": "_variant-text_acim8_228",
  withWhiteBackground: Ta,
  buttonLabel: Wa,
  badgeContainer: Aa,
  "text-color-default": "_text-color-default_acim8_303",
  "text-color-secondary": "_text-color-secondary_acim8_307",
  "text-color-critical": "_text-color-critical_acim8_311",
  compactLabel: za,
  shadowButton: Ea,
  outlined: Oa,
  rightIcon: Ha,
  icon: Ga,
  noLabel: ja,
  noLabelContainer: Ua,
  label: Xa,
  confirmationPopoverPaper: qa,
  maxWidth: Ya
}, Za = ({
  badgeCount: e,
  color: o,
  component: n,
  handleClick: a,
  hasIconLeft: r,
  hasIconRight: i,
  hasNoWrap: s,
  hasWhiteBackground: l,
  iconToRender: c,
  isLoading: d,
  label: g,
  showBadge: p,
  size: _ = fe.Default,
  tooltipProps: C,
  variant: h = ne.Text,
  ...u
}) => {
  const [v, S] = ke(void 0), D = it(null);
  return gt(() => {
    D.current && !d && g && S(D.current.getBoundingClientRect().width);
  }, [d, g]), /* @__PURE__ */ t(ge, { title: (C == null ? void 0 : C.title) ?? "", ...C, children: /* @__PURE__ */ x(
    n,
    {
      "data-testid": "base-button",
      ref: D,
      ...u,
      className: L(
        u.className,
        O.button,
        O[`size-${_}`],
        O[`color-${o}`],
        O[`variant-${h}`],
        {
          [O.disabled]: u.disabled,
          [O.loading]: d,
          [O.withWhiteBackground]: l
        }
      ),
      style: {
        whiteSpace: s ? "nowrap" : void 0,
        minWidth: d && v ? `${v}px` : void 0,
        ...u.style
      },
      onClick: a,
      children: [
        (r || d) && c,
        !!g && /* @__PURE__ */ t("span", { className: O.buttonLabel, children: g }),
        i && !d && c,
        p && /* @__PURE__ */ t(
          Je,
          {
            color: te.Neutral,
            number: e ?? 0,
            classes: { root: O.badgeContainer },
            badgeClassName: O.badge
          }
        )
      ]
    }
  ) });
}, Ka = ({
  badgeCount: e,
  color: o,
  component: n,
  handleClick: a,
  hasNoWrap: r,
  hasWhiteBackground: i,
  iconToRender: s,
  innerLabel: l,
  isCompactSelect: c,
  isLoading: d,
  label: g,
  size: p = fe.Default,
  showBadge: _,
  textVariant: C,
  tooltipProps: h,
  variant: u = ne.Text,
  ...v
}) => /* @__PURE__ */ t(ge, { title: (h == null ? void 0 : h.title) ?? "", ...h, children: /* @__PURE__ */ x(k, { alignItems: "center", flexDirection: "column", width: "fit-content", children: [
  /* @__PURE__ */ x(
    n,
    {
      "data-testid": "compact-button",
      ...v,
      className: L(
        O.compactButton,
        v.className,
        O[`size-${p}`],
        O[`color-${o}`],
        O[`variant-${u}`],
        {
          [O.disabled]: v.disabled,
          [O.loading]: d,
          [O.withWhiteBackground]: i
        }
      ),
      onClick: a,
      style: {
        whiteSpace: r ? "nowrap" : void 0,
        ...v.style
      },
      children: [
        l && /* @__PURE__ */ t(
          z,
          {
            className: u === "filled" ? void 0 : O[`text-color-${o}`],
            color: u === "filled" ? "contentWhite" : void 0,
            variant: C,
            children: l
          }
        ),
        s,
        c && /* @__PURE__ */ t(E, { icon: io }),
        _ && /* @__PURE__ */ t(
          Je,
          {
            badgeClassName: O.badge,
            classes: { root: O.badgeContainer },
            color: te.Neutral,
            number: e ?? 0
          }
        )
      ]
    }
  ),
  g && /* @__PURE__ */ t(
    z,
    {
      className: L(O.compactLabel, O[`text-color-${o}`]),
      mt: 0.5,
      variant: "captionReg500",
      children: g
    }
  )
] }) }), Va = ({ title: e }) => typeof e == "string" ? /* @__PURE__ */ t(Se, { children: e }) : e, Ja = "_tooltip_1lmjc_3", Qa = "_arrow_1lmjc_14", ln = {
  tooltip: Ja,
  arrow: Qa
}, ge = ({
  title: e = "",
  arrow: o = !0,
  tooltipClass: n = "",
  children: a,
  ...r
}) => {
  const { classes: i = {} } = r;
  return /* @__PURE__ */ t(
    En,
    {
      ...r,
      classes: {
        ...i,
        tooltip: L(ln.tooltip, n),
        arrow: ln.arrow
      },
      title: e || e === 0 ? /* @__PURE__ */ t(Va, { title: e }) : "",
      enterTouchDelay: 0,
      arrow: o,
      children: a
    }
  );
}, Pa = ({
  classes: e,
  color: o = K.Default,
  component: n,
  handleClick: a,
  hasIconRight: r,
  iconToRender: i,
  isLoading: s,
  label: l,
  size: c = fe.Large,
  tooltipProps: d,
  variant: g = ne.Outlined,
  ...p
}) => /* @__PURE__ */ t(ge, { title: (d == null ? void 0 : d.title) ?? "", ...d, children: /* @__PURE__ */ x(
  n,
  {
    "data-testid": "shadow-button",
    ...p,
    className: L(
      O.shadowButton,
      O[`color-${o}`],
      O[`size-${c}`],
      O[`variant-${g}`],
      {
        [O.rightIcon]: r,
        [O.disabled]: p.disabled,
        [O.noLabelContainer]: !l,
        [O.loading]: s
      },
      p.className
    ),
    onClick: a,
    children: [
      i ? /* @__PURE__ */ t("span", { className: L(O.icon, { [O.noLabel]: !l }, e == null ? void 0 : e.icon), children: i }) : null,
      l ? /* @__PURE__ */ t("span", { className: L(O.label, e == null ? void 0 : e.label), children: l }) : null
    ]
  }
) }), Ye = (e) => /^http(s)?:\/\//.test(e) || /mailto:([^?]*)/.test(e), he = ({
  badgeCount: e,
  children: o,
  classes: n,
  color: a = K.Default,
  compactVariant: r,
  newTab: i,
  confirmationPopoverProps: s,
  hasIconLeft: l,
  innerLabel: c,
  hasIconRight: d,
  hasWhiteBackground: g,
  href: p,
  icon: _,
  hasNoWrap: C,
  isLoading: h,
  label: u,
  size: v = fe.Default,
  textVariant: S,
  tooltipProps: D,
  variant: M,
  withShadow: R,
  ...B
}) => {
  const H = r === "select", X = r === "default", U = M === ne.Outlined, G = M === ne.Filled, N = !!e && (U || X), ue = g !== void 0 ? g : U, {
    confirmationOpenColor: Me,
    confirmationButtonColor: F,
    confirmationText: y,
    confirmationPopover: b,
    confirmationButtonText: $,
    confirmationPopoverCancelButtonText: w,
    confirmationContent: W,
    placement: A,
    hideArrow: j,
    menuClasses: q,
    menuProps: V,
    wrapperClass: ee,
    paperClass: le,
    anchorButtonClass: Te,
    onCloseCallback: $e
  } = s ?? {}, We = {
    blue: K.Default,
    gray: K.Secondary,
    red: K.Critical
  }, De = {
    [K.Default]: "surfacePrimaryDefault",
    [K.Secondary]: "surfaceSecondaryDefault",
    [K.Critical]: "surfaceCriticalPrimaryDefault"
  }, Y = () => G ? "contentWhite" : De[a] ?? "surfacePrimaryDefault", be = 180, Ae = {
    arrow: /* @__PURE__ */ t(
      E,
      {
        color: Y(),
        icon: no,
        rotation: l ? be : void 0
      }
    ),
    chevron: /* @__PURE__ */ t(
      E,
      {
        color: Y(),
        icon: d || l ? ao : oo,
        rotation: l ? be : void 0
      }
    ),
    download: /* @__PURE__ */ t(E, { color: Y(), icon: Vn }),
    edit: /* @__PURE__ */ t(
      E,
      {
        color: Y(),
        "data-testid": "edit-icon",
        icon: Pn
      }
    ),
    lock: /* @__PURE__ */ t(E, { color: Y(), icon: Qn }),
    plus: /* @__PURE__ */ t(E, { color: Y(), icon: eo }),
    trash: /* @__PURE__ */ t(E, { color: Y(), icon: to })
  }, Ot = h ? /* @__PURE__ */ t(E, { "data-testid": "loader-icon", icon: Jn, spin: !0 }) : Object.keys(Ae).includes(_) ? Ae[_] : _, Ht = (ae, ye) => {
    var ze;
    if (!(h || B.disabled)) {
      if (y || b) {
        ae.stopPropagation(), ye == null || ye();
        return;
      }
      (ze = B.onClick) == null || ze.call(B, ae);
    }
  }, Gt = (() => {
    if (!p || B.disabled)
      return {
        component: "button",
        to: "",
        type: B.type ?? "button"
      };
    const ae = i || Ye(p) ? { rel: "noopener noreferrer", target: "_blank" } : {};
    return Ye(p) ? { component: "a", href: p, to: "", ...ae } : { component: lt, to: p, ...ae };
  })(), jt = Object.values(K).includes(a) ? a : We[a] ? We[a] : K.Default, Ut = ({
    anchorElementProps: ae
  } = {}) => {
    if (R)
      return /* @__PURE__ */ t(
        Pa,
        {
          "aria-label": B["aria-label"] ?? u,
          classes: n,
          color: Me ?? jt,
          disabled: B.disabled || h,
          handleClick: Ht,
          hasIconLeft: l,
          hasIconRight: d,
          iconToRender: Ot,
          isLoading: h,
          label: h ? void 0 : u,
          size: v,
          tooltipProps: D,
          variant: M,
          ...B,
          ...Gt
        }
      );
    const ye = {
      "aria-label": B["aria-label"] ?? u,
      badgeCount: e,
      color: Me ?? jt,
      disabled: B.disabled || h,
      handleClick: (ze) => Ht(
        ze,
        ae != null && ae.onClick ? () => ae.onClick(
          ze
        ) : void 0
      ),
      hasNoWrap: C,
      hasWhiteBackground: ue,
      iconToRender: Ot,
      isLoading: h,
      showBadge: N,
      size: v,
      tooltipProps: D,
      variant: M,
      ...B,
      ...Gt
    };
    return H || X ? /* @__PURE__ */ t(
      Ka,
      {
        innerLabel: c,
        isCompactSelect: H,
        label: u,
        textVariant: S,
        ...ye
      }
    ) : /* @__PURE__ */ t(
      Za,
      {
        hasIconLeft: l,
        hasIconRight: d,
        label: h ? "" : u,
        ...ye
      }
    );
  };
  return s ? /* @__PURE__ */ t(
    Et,
    {
      anchorButtonClass: Te,
      anchorContent: ({
        anchorElementProps: ae
      }) => Ut({ anchorElementProps: ae }),
      hideArrow: j,
      menuClasses: q,
      menuProps: V,
      onCloseCallback: $e,
      paperClass: L(O.confirmationPopoverPaper, le, {
        [O.maxWidth]: !b
      }),
      placement: A,
      popoverContent: ({ setAnchor: ae }) => b ? b({
        closePopover: () => ae(null)
      }) : /* @__PURE__ */ x("div", { children: [
        y && /* @__PURE__ */ t(z, { mb: 1.5, variant: "bodySm400", children: y }),
        W,
        /* @__PURE__ */ x(
          k,
          {
            alignItems: "center",
            justifyContent: "space-between",
            width: "100%",
            children: [
              /* @__PURE__ */ t(
                he,
                {
                  color: K.Default,
                  label: w ?? "Cancel",
                  onClick: (ye) => {
                    ye.stopPropagation(), ae(null);
                  },
                  size: fe.Small,
                  variant: ne.Text
                }
              ),
              /* @__PURE__ */ t(
                he,
                {
                  color: F ?? K.Critical,
                  label: $ ?? "Delete",
                  onClick: (ye) => {
                    var ze;
                    ye.stopPropagation(), (ze = B.onClick) == null || ze.call(B, ye), ae(null);
                  },
                  size: fe.Small,
                  variant: ne.Outlined
                }
              )
            ]
          }
        )
      ] }),
      tooltipProps: s == null ? void 0 : s.tooltipProps,
      withCustomAnchor: !0,
      wrapperClass: ee
    }
  ) : Ut();
};
function er(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var mt = { exports: {} }, tr = mt.exports, cn;
function nr() {
  return cn || (cn = 1, function(e, o) {
    (function(n, a) {
      e.exports = a();
    })(tr, function() {
      var n = 1e3, a = 6e4, r = 36e5, i = "millisecond", s = "second", l = "minute", c = "hour", d = "day", g = "week", p = "month", _ = "quarter", C = "year", h = "date", u = "Invalid Date", v = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, S = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, D = { name: "en", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), ordinal: function(F) {
        var y = ["th", "st", "nd", "rd"], b = F % 100;
        return "[" + F + (y[(b - 20) % 10] || y[b] || y[0]) + "]";
      } }, M = function(F, y, b) {
        var $ = String(F);
        return !$ || $.length >= y ? F : "" + Array(y + 1 - $.length).join(b) + F;
      }, R = { s: M, z: function(F) {
        var y = -F.utcOffset(), b = Math.abs(y), $ = Math.floor(b / 60), w = b % 60;
        return (y <= 0 ? "+" : "-") + M($, 2, "0") + ":" + M(w, 2, "0");
      }, m: function F(y, b) {
        if (y.date() < b.date()) return -F(b, y);
        var $ = 12 * (b.year() - y.year()) + (b.month() - y.month()), w = y.clone().add($, p), W = b - w < 0, A = y.clone().add($ + (W ? -1 : 1), p);
        return +(-($ + (b - w) / (W ? w - A : A - w)) || 0);
      }, a: function(F) {
        return F < 0 ? Math.ceil(F) || 0 : Math.floor(F);
      }, p: function(F) {
        return { M: p, y: C, w: g, d, D: h, h: c, m: l, s, ms: i, Q: _ }[F] || String(F || "").toLowerCase().replace(/s$/, "");
      }, u: function(F) {
        return F === void 0;
      } }, B = "en", H = {};
      H[B] = D;
      var X = "$isDayjsObject", U = function(F) {
        return F instanceof ue || !(!F || !F[X]);
      }, G = function F(y, b, $) {
        var w;
        if (!y) return B;
        if (typeof y == "string") {
          var W = y.toLowerCase();
          H[W] && (w = W), b && (H[W] = b, w = W);
          var A = y.split("-");
          if (!w && A.length > 1) return F(A[0]);
        } else {
          var j = y.name;
          H[j] = y, w = j;
        }
        return !$ && w && (B = w), w || !$ && B;
      }, T = function(F, y) {
        if (U(F)) return F.clone();
        var b = typeof y == "object" ? y : {};
        return b.date = F, b.args = arguments, new ue(b);
      }, N = R;
      N.l = G, N.i = U, N.w = function(F, y) {
        return T(F, { locale: y.$L, utc: y.$u, x: y.$x, $offset: y.$offset });
      };
      var ue = function() {
        function F(b) {
          this.$L = G(b.locale, null, !0), this.parse(b), this.$x = this.$x || b.x || {}, this[X] = !0;
        }
        var y = F.prototype;
        return y.parse = function(b) {
          this.$d = function($) {
            var w = $.date, W = $.utc;
            if (w === null) return /* @__PURE__ */ new Date(NaN);
            if (N.u(w)) return /* @__PURE__ */ new Date();
            if (w instanceof Date) return new Date(w);
            if (typeof w == "string" && !/Z$/i.test(w)) {
              var A = w.match(v);
              if (A) {
                var j = A[2] - 1 || 0, q = (A[7] || "0").substring(0, 3);
                return W ? new Date(Date.UTC(A[1], j, A[3] || 1, A[4] || 0, A[5] || 0, A[6] || 0, q)) : new Date(A[1], j, A[3] || 1, A[4] || 0, A[5] || 0, A[6] || 0, q);
              }
            }
            return new Date(w);
          }(b), this.init();
        }, y.init = function() {
          var b = this.$d;
          this.$y = b.getFullYear(), this.$M = b.getMonth(), this.$D = b.getDate(), this.$W = b.getDay(), this.$H = b.getHours(), this.$m = b.getMinutes(), this.$s = b.getSeconds(), this.$ms = b.getMilliseconds();
        }, y.$utils = function() {
          return N;
        }, y.isValid = function() {
          return this.$d.toString() !== u;
        }, y.isSame = function(b, $) {
          var w = T(b);
          return this.startOf($) <= w && w <= this.endOf($);
        }, y.isAfter = function(b, $) {
          return T(b) < this.startOf($);
        }, y.isBefore = function(b, $) {
          return this.endOf($) < T(b);
        }, y.$g = function(b, $, w) {
          return N.u(b) ? this[$] : this.set(w, b);
        }, y.unix = function() {
          return Math.floor(this.valueOf() / 1e3);
        }, y.valueOf = function() {
          return this.$d.getTime();
        }, y.startOf = function(b, $) {
          var w = this, W = !!N.u($) || $, A = N.p(b), j = function(De, Y) {
            var be = N.w(w.$u ? Date.UTC(w.$y, Y, De) : new Date(w.$y, Y, De), w);
            return W ? be : be.endOf(d);
          }, q = function(De, Y) {
            return N.w(w.toDate()[De].apply(w.toDate("s"), (W ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(Y)), w);
          }, V = this.$W, ee = this.$M, le = this.$D, Te = "set" + (this.$u ? "UTC" : "");
          switch (A) {
            case C:
              return W ? j(1, 0) : j(31, 11);
            case p:
              return W ? j(1, ee) : j(0, ee + 1);
            case g:
              var $e = this.$locale().weekStart || 0, We = (V < $e ? V + 7 : V) - $e;
              return j(W ? le - We : le + (6 - We), ee);
            case d:
            case h:
              return q(Te + "Hours", 0);
            case c:
              return q(Te + "Minutes", 1);
            case l:
              return q(Te + "Seconds", 2);
            case s:
              return q(Te + "Milliseconds", 3);
            default:
              return this.clone();
          }
        }, y.endOf = function(b) {
          return this.startOf(b, !1);
        }, y.$set = function(b, $) {
          var w, W = N.p(b), A = "set" + (this.$u ? "UTC" : ""), j = (w = {}, w[d] = A + "Date", w[h] = A + "Date", w[p] = A + "Month", w[C] = A + "FullYear", w[c] = A + "Hours", w[l] = A + "Minutes", w[s] = A + "Seconds", w[i] = A + "Milliseconds", w)[W], q = W === d ? this.$D + ($ - this.$W) : $;
          if (W === p || W === C) {
            var V = this.clone().set(h, 1);
            V.$d[j](q), V.init(), this.$d = V.set(h, Math.min(this.$D, V.daysInMonth())).$d;
          } else j && this.$d[j](q);
          return this.init(), this;
        }, y.set = function(b, $) {
          return this.clone().$set(b, $);
        }, y.get = function(b) {
          return this[N.p(b)]();
        }, y.add = function(b, $) {
          var w, W = this;
          b = Number(b);
          var A = N.p($), j = function(ee) {
            var le = T(W);
            return N.w(le.date(le.date() + Math.round(ee * b)), W);
          };
          if (A === p) return this.set(p, this.$M + b);
          if (A === C) return this.set(C, this.$y + b);
          if (A === d) return j(1);
          if (A === g) return j(7);
          var q = (w = {}, w[l] = a, w[c] = r, w[s] = n, w)[A] || 1, V = this.$d.getTime() + b * q;
          return N.w(V, this);
        }, y.subtract = function(b, $) {
          return this.add(-1 * b, $);
        }, y.format = function(b) {
          var $ = this, w = this.$locale();
          if (!this.isValid()) return w.invalidDate || u;
          var W = b || "YYYY-MM-DDTHH:mm:ssZ", A = N.z(this), j = this.$H, q = this.$m, V = this.$M, ee = w.weekdays, le = w.months, Te = w.meridiem, $e = function(Y, be, Ae, Pe) {
            return Y && (Y[be] || Y($, W)) || Ae[be].slice(0, Pe);
          }, We = function(Y) {
            return N.s(j % 12 || 12, Y, "0");
          }, De = Te || function(Y, be, Ae) {
            var Pe = Y < 12 ? "AM" : "PM";
            return Ae ? Pe.toLowerCase() : Pe;
          };
          return W.replace(S, function(Y, be) {
            return be || function(Ae) {
              switch (Ae) {
                case "YY":
                  return String($.$y).slice(-2);
                case "YYYY":
                  return N.s($.$y, 4, "0");
                case "M":
                  return V + 1;
                case "MM":
                  return N.s(V + 1, 2, "0");
                case "MMM":
                  return $e(w.monthsShort, V, le, 3);
                case "MMMM":
                  return $e(le, V);
                case "D":
                  return $.$D;
                case "DD":
                  return N.s($.$D, 2, "0");
                case "d":
                  return String($.$W);
                case "dd":
                  return $e(w.weekdaysMin, $.$W, ee, 2);
                case "ddd":
                  return $e(w.weekdaysShort, $.$W, ee, 3);
                case "dddd":
                  return ee[$.$W];
                case "H":
                  return String(j);
                case "HH":
                  return N.s(j, 2, "0");
                case "h":
                  return We(1);
                case "hh":
                  return We(2);
                case "a":
                  return De(j, q, !0);
                case "A":
                  return De(j, q, !1);
                case "m":
                  return String(q);
                case "mm":
                  return N.s(q, 2, "0");
                case "s":
                  return String($.$s);
                case "ss":
                  return N.s($.$s, 2, "0");
                case "SSS":
                  return N.s($.$ms, 3, "0");
                case "Z":
                  return A;
              }
              return null;
            }(Y) || A.replace(":", "");
          });
        }, y.utcOffset = function() {
          return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
        }, y.diff = function(b, $, w) {
          var W, A = this, j = N.p($), q = T(b), V = (q.utcOffset() - this.utcOffset()) * a, ee = this - q, le = function() {
            return N.m(A, q);
          };
          switch (j) {
            case C:
              W = le() / 12;
              break;
            case p:
              W = le();
              break;
            case _:
              W = le() / 3;
              break;
            case g:
              W = (ee - V) / 6048e5;
              break;
            case d:
              W = (ee - V) / 864e5;
              break;
            case c:
              W = ee / r;
              break;
            case l:
              W = ee / a;
              break;
            case s:
              W = ee / n;
              break;
            default:
              W = ee;
          }
          return w ? W : N.a(W);
        }, y.daysInMonth = function() {
          return this.endOf(p).$D;
        }, y.$locale = function() {
          return H[this.$L];
        }, y.locale = function(b, $) {
          if (!b) return this.$L;
          var w = this.clone(), W = G(b, $, !0);
          return W && (w.$L = W), w;
        }, y.clone = function() {
          return N.w(this.$d, this);
        }, y.toDate = function() {
          return new Date(this.valueOf());
        }, y.toJSON = function() {
          return this.isValid() ? this.toISOString() : null;
        }, y.toISOString = function() {
          return this.$d.toISOString();
        }, y.toString = function() {
          return this.$d.toUTCString();
        }, F;
      }(), Me = ue.prototype;
      return T.prototype = Me, [["$ms", i], ["$s", s], ["$m", l], ["$H", c], ["$W", d], ["$M", p], ["$y", C], ["$D", h]].forEach(function(F) {
        Me[F[1]] = function(y) {
          return this.$g(y, F[0], F[1]);
        };
      }), T.extend = function(F, y) {
        return F.$i || (F(y, ue, T), F.$i = !0), T;
      }, T.locale = G, T.isDayjs = U, T.unix = function(F) {
        return T(1e3 * F);
      }, T.en = H[B], T.Ls = H, T.p = {}, T;
    });
  }(mt)), mt.exports;
}
var or = nr();
const qe = /* @__PURE__ */ er(or), ar = ({ tag: e }) => ["a", "button"].includes(e), rr = "_buttonAdjustments_1vavw_5", ir = "_anchorAdjustments_1vavw_38", lr = "_pointer_1vavw_49", cr = "_fullWidth_1vavw_53", st = {
  buttonAdjustments: rr,
  anchorAdjustments: ir,
  pointer: lr,
  fullWidth: cr
}, Sn = Ce(
  ({
    tagName: e = "button",
    children: o,
    className: n,
    disabled: a,
    fullWidth: r,
    href: i,
    onClick: s = () => null,
    testId: l,
    ...c
  }, d) => {
    const g = (u) => {
      a || s(u);
    }, p = {
      ...c,
      ...e === "button" ? { type: "button" } : {}
    }, _ = !a && i ? i : void 0, C = i ? "a" : "button", h = ar({ tag: e }) ? e : C;
    return /* @__PURE__ */ t(
      h,
      {
        ref: d,
        className: L(n, {
          [st.buttonAdjustments]: h === "button",
          [st.anchorAdjustments]: h === "a",
          [st.pointer]: !a,
          [st.fullWidth]: r
        }),
        disabled: a,
        onClick: g,
        href: _,
        "data-testid": l,
        ...p,
        children: o
      }
    );
  }
), k = je.forwardRef(
  ({ children: e, className: o, ...n }, a) => /* @__PURE__ */ t(
    On,
    {
      "data-testid": "flexContainer",
      ref: a,
      className: o,
      display: "flex",
      ...n,
      children: e
    }
  )
), sr = "_defaultPadding_130p5_8", sn = {
  defaultPadding: sr,
  "size-2xs": "_size-2xs_130p5_13",
  "size-xs": "_size-xs_130p5_21",
  "size-sm": "_size-sm_130p5_29",
  "size-md": "_size-md_130p5_37",
  "size-1x": "_size-1x_130p5_38",
  "size-lg": "_size-lg_130p5_46",
  "size-xl": "_size-xl_130p5_54"
}, E = ({
  className: e,
  color: o = "contentDefault",
  onClick: n,
  fixedWidth: a = !1,
  inverse: r = !1,
  listItem: i = !1,
  spin: s = !1,
  swapOpacity: l = !1,
  "data-testid": c,
  ...d
}) => {
  const g = sn[`size-${d.size ?? "md"}`], p = _t(o);
  return /* @__PURE__ */ t(
    so,
    {
      className: L(e, g, sn.defaultPadding),
      color: p,
      "data-testid": c,
      fixedWidth: a,
      inverse: r,
      listItem: i,
      spin: s,
      swapOpacity: l,
      ...d
    }
  );
}, $t = ({
  event: e,
  align: o = "start",
  timezone: n,
  tooltipPlacement: a
}) => {
  var g;
  const r = (e == null ? void 0 : e.variant) === "filled", i = e.icon ? e.icon : null, s = Intl.DateTimeFormat("en-US", {
    hour: "numeric",
    hour12: !0,
    minute: "2-digit",
    timeZone: n || Intl.DateTimeFormat().resolvedOptions().timeZone
  }).format(e == null ? void 0 : e.start), l = `${e.title}, ${s}`, c = /* @__PURE__ */ x(Sn, { className: "rbc-event-title", children: [
    e.title,
    ", ",
    s
  ] }), d = a ? /* @__PURE__ */ t(
    ge,
    {
      placement: a,
      title: ((g = e == null ? void 0 : e.tooltipProps) == null ? void 0 : g.title) || l,
      children: c
    }
  ) : c;
  return /* @__PURE__ */ x(k, { alignItems: o, "data-testid": e.title, gap: 0.5, title: "", children: [
    i ? /* @__PURE__ */ t(
      E,
      {
        color: r ? "contentWhite" : e.color,
        icon: i
      }
    ) : null,
    /* @__PURE__ */ t("div", { className: "rbc-title-wrapper", children: d })
  ] });
}, dr = ({
  event: e,
  timezone: o,
  tooltipPlacement: n
}) => /* @__PURE__ */ t(
  $t,
  {
    align: "center",
    event: e,
    timezone: o,
    tooltipPlacement: n
  }
), ur = ({ event: e, children: o }) => /* @__PURE__ */ t(
  "div",
  {
    className: L("rbc-event-wrapper", e.color ?? "", {
      "rbc-event-filled": e.variant === "filled",
      "rbc-event-white-label": e.whiteLabel
    }),
    children: o
  }
);
[...Intl.supportedValuesOf("timeZone")];
var Dt = /* @__PURE__ */ ((e) => (e.Back = "back", e.Forward = "forward", e))(Dt || {});
const mr = ({
  disabled: e,
  viewMode: o,
  viewLabel: n,
  onMove: a,
  onMoveToday: r,
  onChangeView: i
}) => /* @__PURE__ */ x(
  k,
  {
    className: "rbc-toolbar",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 0.5,
    children: [
      /* @__PURE__ */ t(k, { className: "rbc-left-toolbar", children: /* @__PURE__ */ t(
        "button",
        {
          className: "rbc-btn-standalone rbc-btn-today",
          type: "button",
          onClick: r,
          disabled: e,
          children: "Today"
        }
      ) }),
      /* @__PURE__ */ x(k, { gap: 0.5, alignItems: "center", children: [
        /* @__PURE__ */ t(
          "button",
          {
            type: "button",
            className: "rbc-btn-standalone",
            "aria-label": "move back",
            disabled: e,
            onClick: () => {
              a(Dt.Back);
            },
            children: /* @__PURE__ */ t(E, { icon: qt })
          }
        ),
        /* @__PURE__ */ t("h2", { className: "rbc-toolbar-label", children: n }),
        /* @__PURE__ */ t(
          "button",
          {
            type: "button",
            className: "rbc-btn-standalone",
            "aria-label": "move forward",
            disabled: e,
            onClick: () => {
              a(Dt.Forward);
            },
            children: /* @__PURE__ */ t(E, { icon: qt, rotation: 180 })
          }
        )
      ] }),
      /* @__PURE__ */ t("div", { className: "rbc-btn-group rbc-right-toolbar", children: ["Month", "Week", "Day"].map((l) => /* @__PURE__ */ t(
        "button",
        {
          type: "button",
          disabled: e,
          onClick: () => {
            i(l.toLowerCase());
          },
          className: L({
            "rbc-active": o === l.toLowerCase()
          }),
          children: l
        },
        l
      )) })
    ]
  }
), fr = ({
  initialDate: e,
  initialViewMode: o = "month",
  onRangeChange: n,
  onViewChange: a
}) => {
  const [r, i] = ke(e), [s, l] = ke(o), [c, d] = ke(o);
  o !== c && (d(o), l(o));
  const g = {
    day: "d",
    week: "w",
    month: "M"
  }, p = (u) => {
    l(u), _(r, g[u]), a == null || a(u);
  }, _ = (u, v) => {
    const S = qe(u).startOf(v).toDate(), D = qe(u).endOf(v).toDate();
    n == null || n({ start: S, end: D });
  };
  return {
    currentDate: r,
    viewMode: s,
    onChangeView: p,
    onMove: (u) => {
      if (u === "back") {
        const S = qe(r).subtract(1, g[s]).toDate();
        i(S), _(S, g[s]);
        return;
      }
      const v = qe(r).add(1, g[s]).toDate();
      i(v), _(v, g[s]);
    },
    onMoveToday: () => {
      const u = qe().toDate();
      i(u), _(u, g[s]);
    }
  };
};
function hr(e, o) {
  const n = qe(o);
  switch (e) {
    case "week": {
      const a = n.clone().startOf("week"), r = n.clone().endOf("week");
      return `${a.format("MMMM DD")} - ${r.format(
        "DD, YYYY"
      )}`;
    }
    case "month":
      return n.format("MMMM, YYYY");
    case "day":
      return n.format("MMMM DD, YYYY");
    default:
      return "";
  }
}
const gr = lo(qe), wu = ({
  events: e,
  initialDate: o,
  initialViewMode: n = "month",
  height: a,
  selectable: r = !0,
  loading: i = !1,
  grow: s = !0,
  className: l,
  classes: c,
  onNavigate: d = () => {
  },
  onViewChange: g = () => {
  },
  onView: p = () => {
  },
  tooltipPlacement: _,
  timezone: C,
  onRangeChange: h,
  restricted: u = !1,
  ...v
}) => {
  const { isMobile: S } = Nt(), { currentDate: D, viewMode: M, onChangeView: R, onMove: B, onMoveToday: H } = fr({
    initialDate: o,
    initialViewMode: n,
    onRangeChange: h,
    onViewChange: g
  }), { containerClassName: X = "", rootClassName: U = "" } = c ?? {}, G = hr(M, D), T = S ? void 0 : _;
  return /* @__PURE__ */ x(
    "div",
    {
      className: L("rbc-calendar-container", X, {
        grow: s,
        loading: i,
        restricted: u
      }),
      children: [
        /* @__PURE__ */ t(
          mr,
          {
            disabled: !!i,
            onChangeView: R,
            onMove: B,
            onMoveToday: H,
            viewLabel: G,
            viewMode: M
          }
        ),
        /* @__PURE__ */ t(
          co,
          {
            className: L(U, {
              "rbc-week-view": M === "week"
            }),
            components: {
              day: {
                event: (N) => /* @__PURE__ */ t(
                  $t,
                  {
                    ...N,
                    timezone: C,
                    tooltipPlacement: T
                  }
                )
              },
              week: {
                event: (N) => /* @__PURE__ */ t(
                  $t,
                  {
                    ...N,
                    timezone: C,
                    tooltipPlacement: T
                  }
                )
              },
              month: {
                event: (N) => /* @__PURE__ */ t(
                  dr,
                  {
                    ...N,
                    timezone: C,
                    tooltipPlacement: T
                  }
                )
              },
              eventWrapper: ur
            },
            date: D,
            endAccessor: "end",
            events: e,
            localizer: gr,
            onNavigate: d,
            onView: p,
            selectable: r,
            startAccessor: "start",
            style: { height: a },
            toolbar: !1,
            view: M,
            views: ["month", "week", "day"],
            ...v
          }
        )
      ]
    }
  );
}, pr = "_container_17mpp_1", _r = "_fullWidth_17mpp_5", Cr = "_iconTextContainer_17mpp_9", br = "_defaultContainer_17mpp_13", yr = "_smallContainer_17mpp_17", Lr = "_warningContainer_17mpp_21", Sr = "_tipContainer_17mpp_29", xr = "_successContainer_17mpp_37", vr = "_errorContainer_17mpp_45", wr = "_pendingContainer_17mpp_53", kr = "_infoContainer_17mpp_61", Mr = "_miscContainer_17mpp_69", $r = "_lockedContainer_17mpp_77", Dr = "_infoNoteText_17mpp_85", Fr = "_clearIcon_17mpp_90", Ir = "_dismissIcon_17mpp_97", re = {
  container: pr,
  fullWidth: _r,
  iconTextContainer: Cr,
  defaultContainer: br,
  smallContainer: yr,
  warningContainer: Lr,
  tipContainer: Sr,
  successContainer: xr,
  errorContainer: vr,
  pendingContainer: wr,
  infoContainer: kr,
  miscContainer: Mr,
  lockedContainer: $r,
  infoNoteText: Dr,
  clearIcon: Fr,
  dismissIcon: Ir
}, Ft = Object.freeze({
  tip: {
    className: re.tipContainer,
    icon: /* @__PURE__ */ t(E, { icon: kt }),
    faIcon: kt
  },
  warning: {
    className: re.warningContainer,
    icon: /* @__PURE__ */ t(E, { icon: Pt }),
    faIcon: Pt
  },
  success: {
    className: re.successContainer,
    icon: /* @__PURE__ */ t(E, { icon: Yt }),
    faIcon: Yt
  },
  error: {
    className: re.errorContainer,
    icon: /* @__PURE__ */ t(E, { icon: Qt }),
    faIcon: Qt
  },
  pending: {
    className: re.pendingContainer,
    icon: /* @__PURE__ */ t(E, { icon: Vt }),
    faIcon: Vt
  },
  info: {
    className: re.infoContainer,
    icon: /* @__PURE__ */ t(E, { icon: Zt }),
    faIcon: Zt
  },
  misc: {
    className: re.miscContainer,
    icon: /* @__PURE__ */ t(E, { icon: Kt }),
    faIcon: Kt
  },
  locked: {
    className: re.lockedContainer,
    icon: /* @__PURE__ */ t(E, { icon: Jt }),
    faIcon: Jt
  }
}), dn = Object.freeze({
  default: re.defaultContainer,
  small: re.smallContainer
}), Br = "_root_lka7c_1", Rr = "_infoNote_lka7c_6", Nr = "_iconTextContainer_lka7c_10", yt = {
  root: Br,
  infoNote: Rr,
  iconTextContainer: Nr
}, Tr = ({ variant: e, label: o, icon: n, className: a }) => {
  var i;
  const r = n || /* @__PURE__ */ t(
    E,
    {
      icon: ((i = Ft[e]) == null ? void 0 : i.faIcon) || kt,
      size: "sm"
    }
  );
  return /* @__PURE__ */ t(k, { className: yt.root, children: /* @__PURE__ */ t(
    Gi,
    {
      className: L(yt.infoNote, a),
      customIcon: r,
      iconTextContainerClass: yt.iconTextContainer,
      size: "small",
      variant: e,
      children: /* @__PURE__ */ t(z, { variant: "captionSm500", children: o })
    }
  ) });
}, Wr = [
  "a",
  "abbr",
  "address",
  "area",
  "article",
  "aside",
  "audio",
  "b",
  "base",
  "bdi",
  "bdo",
  "blockquote",
  "body",
  "br",
  "button",
  "canvas",
  "caption",
  "cite",
  "code",
  "col",
  "colgroup",
  "data",
  "datalist",
  "dd",
  "del",
  "details",
  "dfn",
  "dialog",
  "div",
  "dl",
  "dt",
  "em",
  "embed",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "head",
  "header",
  "hgroup",
  "hr",
  "html",
  "i",
  "iframe",
  "img",
  "input",
  "ins",
  "kbd",
  "label",
  "legend",
  "li",
  "link",
  "main",
  "map",
  "mark",
  "menu",
  "meta",
  "meter",
  "nav",
  "noscript",
  "object",
  "ol",
  "optgroup",
  "option",
  "output",
  "p",
  "picture",
  "pre",
  "progress",
  "q",
  "rp",
  "rt",
  "ruby",
  "s",
  "samp",
  "script",
  "search",
  "section",
  "select",
  "slot",
  "small",
  "source",
  "span",
  "strong",
  "style",
  "sub",
  "summary",
  "sup",
  "table",
  "tbody",
  "td",
  "template",
  "textarea",
  "tfoot",
  "th",
  "thead",
  "time",
  "title",
  "tr",
  "track",
  "u",
  "ul",
  "var",
  "video",
  "wbr"
], Ar = (e) => Wr.includes(e), zr = (e) => e === void 0 ? "div" : typeof e == "string" ? Ar(e) ? e : "div" : e === lt ? e : "div", Er = (e) => e === "a" || e === "button" || xn(e), xn = (e) => e === lt, Or = "_root_10jao_1", Hr = "_rounded_10jao_71", Lt = {
  root: Or,
  "elevation-0": "_elevation-0_10jao_40",
  "elevation-100": "_elevation-100_10jao_44",
  "elevation-200": "_elevation-200_10jao_48",
  "elevation-300": "_elevation-300_10jao_52",
  "elevation-400": "_elevation-400_10jao_56",
  rounded: Hr
}, Tt = je.forwardRef(
  ({
    backgroundColor: e = "white",
    children: o,
    className: n = "",
    component: a = "div",
    href: r = "",
    onClick: i = () => null,
    elevation: s = 0,
    style: l = {},
    rounded: c = !0,
    width: d = "100%",
    newTab: g = !1,
    cardCapProps: p,
    "data-testid": _ = "card",
    "aria-label": C
  }, h) => {
    const u = r && (Ye(r) || g), v = !!p, S = zr(a), D = Er(S), M = xn(S), R = v ? /* @__PURE__ */ x(k, { flexDirection: "column", children: [
      v && /* @__PURE__ */ t(Tr, { ...p }),
      o
    ] }) : o, B = {
      className: L(n, Lt.root, {
        [Lt[`elevation-${s}`]]: s,
        [Lt.rounded]: c
      }),
      ref: h,
      style: {
        backgroundColor: _t(e),
        width: d,
        ...l
      },
      "data-testid": _,
      "aria-label": C
    };
    return M ? je.createElement(
      S,
      {
        ...B,
        onClick: i,
        rel: u ? "noreferrer" : void 0,
        target: u ? "_blank" : void 0,
        to: r
      },
      R
    ) : je.createElement(
      S,
      {
        ...B,
        ...D ? {
          onClick: i,
          rel: u ? "noreferrer" : void 0,
          target: u ? "_blank" : void 0,
          href: r
        } : {}
      },
      R
    );
  }
);
var Re = /* @__PURE__ */ ((e) => (e.Small = "small", e.Default = "default", e))(Re || {}), at = /* @__PURE__ */ ((e) => (e.Left = "left", e.Right = "right", e))(at || {}), Ve = /* @__PURE__ */ ((e) => (e.Unchecked = "unchecked", e.Checked = "checked", e.Indeterminate = "indeterminate", e))(Ve || {});
const Gr = "_root_c4681_2", jr = "_formControlLabel_c4681_8", Ur = "_descriptionText_c4681_14", Xr = "_iconContainer_c4681_19", qr = "_iconContainerSmall_c4681_27", Yr = "_customIcon_c4681_32", Zr = "_disabled_c4681_46", Kr = "_customIconSmall_c4681_51", Vr = "_customCheckedIcon_c4681_58", Jr = "_customCheckedIconContent_c4681_68", Qr = "_checkbox_c4681_77", Pr = "_checked_c4681_90", ei = "_indeterminate_c4681_91", ti = "_border_c4681_104", ni = "_error_c4681_110", oi = "_removeOffset_c4681_117", P = {
  root: Gr,
  formControlLabel: jr,
  descriptionText: Ur,
  iconContainer: Xr,
  iconContainerSmall: qr,
  customIcon: Yr,
  disabled: Zr,
  customIconSmall: Kr,
  customCheckedIcon: Vr,
  customCheckedIconContent: Jr,
  checkbox: Qr,
  checked: Pr,
  indeterminate: ei,
  border: ti,
  error: ni,
  removeOffset: oi
}, ai = ({ size: e, children: o, className: n }) => {
  const a = typeof o == "string", r = e === Re.Small ? "captionReg500" : "bodyReg500";
  return a ? /* @__PURE__ */ t(z, { variant: r, className: L(P.labelText, n), children: o }) : /* @__PURE__ */ t(Se, { children: o });
}, St = ({
  size: e,
  disabled: o,
  variant: n
}) => {
  const a = e === Re.Small, r = L(P.iconContainer, {
    [P.iconContainerSmall]: a
  }), i = n !== Ve.Unchecked, s = n === Ve.Checked ? uo : fo;
  return /* @__PURE__ */ t("span", { className: r, children: /* @__PURE__ */ t(
    "span",
    {
      className: L(P.customIcon, {
        [P.customIconSmall]: a,
        [P.disabled]: o,
        [P.customCheckedIcon]: i
      }),
      children: i && /* @__PURE__ */ t(
        E,
        {
          className: L(P.customCheckedIconContent, {
            [P.disabled]: o
          }),
          icon: s,
          size: a ? "xs" : "sm"
        }
      )
    }
  ) });
}, ri = ({
  size: e = Re.Default,
  label: o = "",
  value: n,
  checked: a,
  disabled: r = !1,
  onChange: i = () => {
  },
  hasBorder: s = !1,
  hasError: l = !1,
  errorText: c,
  classes: d = {},
  description: g = "",
  indeterminate: p = !1,
  "data-testid": _,
  badgeProps: C,
  badgePosition: h = at.Right,
  infoTooltipProps: u,
  "aria-label": v = "",
  removeOffset: S = !1,
  ...D
}) => {
  const M = e === Re.Small ? "captionSm500" : "bodySm400", R = (C == null ? void 0 : C.number) !== void 0, B = R && h === at.Right, H = R && h === at.Left, X = {
    color: (C == null ? void 0 : C.color) || te.Neutral,
    number: (C == null ? void 0 : C.number) || 0,
    variant: (C == null ? void 0 : C.variant) || "filled"
  }, U = {
    disabled: r,
    size: e
  };
  return /* @__PURE__ */ x(k, { flexDirection: "column", children: [
    /* @__PURE__ */ t(
      go,
      {
        classes: {
          label: P.formControlLabel,
          root: L(
            P.root,
            {
              [P.border]: s && o || l && c,
              [P.error]: l,
              [P.removeOffset]: S
            },
            d == null ? void 0 : d.root
          )
        },
        control: /* @__PURE__ */ t(
          ho,
          {
            "aria-label": v,
            checked: a,
            checkedIcon: /* @__PURE__ */ t(
              St,
              {
                ...U,
                variant: Ve.Checked
              }
            ),
            classes: {
              checked: P.checked,
              disabled: P.disabled,
              indeterminate: P.indeterminate,
              root: P.checkbox
            },
            disabled: r,
            icon: /* @__PURE__ */ t(
              St,
              {
                ...U,
                variant: Ve.Unchecked
              }
            ),
            indeterminate: p,
            indeterminateIcon: /* @__PURE__ */ t(
              St,
              {
                ...U,
                variant: Ve.Indeterminate
              }
            ),
            onChange: i,
            size: e === Re.Small ? "small" : "medium",
            value: n,
            ..._ && { "data-testid": _ },
            ...D
          }
        ),
        label: /* @__PURE__ */ x(Se, { children: [
          /* @__PURE__ */ x(
            k,
            {
              alignItems: "center",
              className: d == null ? void 0 : d.labelContainer,
              gap: 1,
              children: [
                H && /* @__PURE__ */ t(Je, { ...X }),
                /* @__PURE__ */ t(ai, { className: d == null ? void 0 : d.label, size: e, children: o }),
                B && /* @__PURE__ */ t(Je, { ...X }),
                (u == null ? void 0 : u.title) && /* @__PURE__ */ t(
                  ge,
                  {
                    arrow: !0,
                    placement: (u == null ? void 0 : u.placement) || "right",
                    title: u == null ? void 0 : u.title,
                    children: /* @__PURE__ */ t(
                      E,
                      {
                        icon: mo,
                        size: e === Re.Small ? "xs" : "sm"
                      }
                    )
                  }
                )
              ]
            }
          ),
          g && /* @__PURE__ */ t(
            z,
            {
              className: L(P.descriptionText, d == null ? void 0 : d.description),
              variant: M,
              children: g
            }
          )
        ] })
      }
    ),
    !!(l && c) && /* @__PURE__ */ t(z, { color: "contentCriticalDefault", mt: 1, variant: "captionReg400", children: c })
  ] });
}, ii = "_root_k88kk_4", li = "_branded_k88kk_9", ci = "_rounded_k88kk_14", si = "_thin_k88kk_25", di = "_children_k88kk_40", ui = "_horizontalWithChildren_k88kk_47", mi = "_leftText_k88kk_72", fi = "_rightText_k88kk_75", hi = "_verticalWithChildren_k88kk_82", Fe = {
  root: ii,
  branded: li,
  rounded: ci,
  thin: si,
  children: di,
  horizontalWithChildren: ui,
  leftText: mi,
  rightText: fi,
  verticalWithChildren: hi
}, ku = je.forwardRef(
  ({
    light: e,
    variant: o,
    lineOnly: n,
    flexItem: a,
    children: r,
    textAlign: i,
    className: s,
    orientation: l,
    rounded: c,
    size: d = "default",
    color: g = "neutral",
    ...p
  }, _) => {
    const C = i === "left", h = i === "right", u = !!r, v = l === "vertical", S = l !== "vertical", D = v || u ? "div" : "hr";
    return /* @__PURE__ */ t(
      po,
      {
        ref: _,
        className: L(
          Fe.root,
          {
            [Fe.leftText]: C,
            [Fe.rightText]: h,
            [Fe.branded]: g === "branded",
            [Fe.thin]: d === "thin",
            [Fe.rounded]: c,
            [Fe.horizontalWithChildren]: S && u,
            [Fe.verticalWithChildren]: v && u
          },
          s
        ),
        flexItem: a,
        light: e,
        orientation: l,
        textAlign: i,
        variant: o,
        component: D,
        classes: {
          wrapper: Fe.children
        },
        ...p,
        children: n ? null : r
      }
    );
  }
), gi = "_root_11ep6_1", pi = "_noPadding_11ep6_10", un = {
  root: gi,
  noPadding: pi
}, Wt = je.forwardRef(
  ({ children: e, removePadding: o = !1, ...n }, a) => /* @__PURE__ */ t(
    _o,
    {
      ref: a,
      disableRipple: !0,
      disableTouchRipple: !0,
      classes: {
        root: L(un.root, { [un.noPadding]: o })
      },
      ...n,
      children: e
    }
  )
), _i = "_root_1de5a_1", Ci = "_drawer_1de5a_5", bi = "_drawerLeft_1de5a_14", yi = "_drawerRight_1de5a_18", Li = "_permanent_1de5a_22", Si = "_header_1de5a_28", xi = "_sizeMob_1de5a_34", vi = "_sizeXs_1de5a_42", wi = "_sizeS_1de5a_46", ki = "_sizeM_1de5a_34", Mi = "_sizeL_1de5a_54", $i = "_sizeXl_1de5a_58", Di = "_fullScreen_1de5a_62", Fi = "_titleSection_1de5a_68", Ii = "_titleContent_1de5a_72", Bi = "_subnav_1de5a_77", Ri = "_content_1de5a_81", Ni = "_footer_1de5a_87", Ti = "_footerLeft_1de5a_95", Wi = "_footerRight_1de5a_99", J = {
  root: _i,
  drawer: Ci,
  drawerLeft: bi,
  drawerRight: yi,
  permanent: Li,
  header: Si,
  sizeMob: xi,
  sizeXs: vi,
  sizeS: wi,
  sizeM: ki,
  sizeL: Mi,
  sizeXl: $i,
  fullScreen: Di,
  titleSection: Fi,
  titleContent: Ii,
  subnav: Bi,
  content: Ri,
  footer: Ni,
  footerLeft: Ti,
  footerRight: Wi
};
var Oe = /* @__PURE__ */ ((e) => (e.MOB = "mob", e.XS = "xs", e.S = "s", e.M = "m", e.L = "l", e.XL = "xl", e))(Oe || {});
const Ai = Ce(
  ({
    title: e,
    description: o,
    onClose: n,
    subNavContent: a,
    children: r,
    size: i = Oe.M,
    fullScreen: s = !1,
    footerActions: l,
    renderCustomFooter: c,
    anchor: d = "right",
    ...g
  }, p) => {
    var v, S;
    const _ = {
      [Oe.MOB]: J.sizeMob,
      [Oe.XS]: J.sizeXs,
      [Oe.S]: J.sizeS,
      [Oe.M]: J.sizeM,
      [Oe.L]: J.sizeL,
      [Oe.XL]: J.sizeXl
    }[i], C = d === "left" ? J.drawerLeft : J.drawerRight, h = !!(l || c), u = () => {
      if (c)
        return c();
      if (!l)
        return null;
      const { cancel: D, secondary: M, primary: R } = l;
      return /* @__PURE__ */ x(
        k,
        {
          alignItems: "center",
          className: L(J.footer, g.footerClassName),
          justifyContent: "space-between",
          children: [
            /* @__PURE__ */ t("div", { className: J.footerLeft, children: D && /* @__PURE__ */ t(
              he,
              {
                onClick: n,
                ...D,
                color: D.color || K.Secondary,
                variant: D.variant || ne.Text
              },
              D.key || "cancel"
            ) }),
            /* @__PURE__ */ x(k, { alignItems: "center", className: J.footerRight, children: [
              M && /* @__PURE__ */ t(
                he,
                {
                  ...M,
                  color: M.color || K.Default,
                  variant: M.variant || ne.Outlined
                },
                M.key || "secondary"
              ),
              R && /* @__PURE__ */ t(
                he,
                {
                  ...R,
                  color: R.color || K.Default,
                  variant: R.variant || ne.Filled
                },
                R.key || "primary"
              )
            ] })
          ]
        }
      );
    };
    return /* @__PURE__ */ x(
      Hn,
      {
        anchor: d,
        onClose: n,
        ref: p,
        ...g,
        classes: {
          ...g.classes,
          root: L(J.root, (v = g.classes) == null ? void 0 : v.root),
          paper: L(
            J.drawer,
            _,
            C,
            {
              [J.fullScreen]: s,
              [J.permanent]: g.variant === "permanent"
            },
            (S = g.classes) == null ? void 0 : S.paper
          )
        },
        children: [
          /* @__PURE__ */ x("div", { className: L(J.header, g.headerClassName), children: [
            /* @__PURE__ */ x(k, { className: J.titleSection, flexDirection: "column", children: [
              /* @__PURE__ */ x(
                k,
                {
                  alignItems: "center",
                  className: J.titleContent,
                  justifyContent: "space-between",
                  children: [
                    typeof e == "string" ? /* @__PURE__ */ t(z, { component: "h2", variant: "h5", children: e }) : e,
                    typeof n == "function" && /* @__PURE__ */ t(
                      Wt,
                      {
                        "aria-label": "Close drawer",
                        onClick: n,
                        removePadding: !0,
                        children: /* @__PURE__ */ t(E, { icon: pt, size: "xl" })
                      }
                    )
                  ]
                }
              ),
              o && /* @__PURE__ */ t(z, { color: "contentSecondary", variant: "bodyReg400", children: o })
            ] }),
            a && /* @__PURE__ */ t("div", { className: J.subnav, children: a })
          ] }),
          /* @__PURE__ */ t(
            k,
            {
              className: L(J.content, g.contentClassName),
              flexDirection: "column",
              children: r
            }
          ),
          h && u()
        ]
      }
    );
  }
);
Ai.displayName = "Drawer";
const zi = "_emoji_7o1sm_13", Ei = {
  "size-M": "_size-M_7o1sm_1",
  "size-S": "_size-S_7o1sm_5",
  "size-XS": "_size-XS_7o1sm_9",
  emoji: zi
};
var ft = /* @__PURE__ */ ((e) => (e.M = "M", e.S = "S", e.XS = "XS", e))(ft || {});
const Mu = ({
  size: e = ft.M,
  title: o,
  description: n,
  emoji: a,
  actionButtonProps: r,
  secondaryActionButtonProps: i,
  className: s,
  "data-testid": l
}) => {
  const c = e === ft.XS, d = e === ft.M, g = d ? "titleReg700" : "titleSm700", p = d ? "bodyReg400" : "bodySm400", _ = c ? "row" : "column", C = d ? 3 : 2, h = d ? "stats2" : "stats1", u = !c && (r || i);
  return /* @__PURE__ */ x(
    k,
    {
      alignItems: "center",
      className: L(Ei[`size-${e}`], s),
      "data-testid": l || "emoji-empty-state",
      flexDirection: _,
      gap: C,
      justifyContent: "center",
      children: [
        a && /* @__PURE__ */ t(z, { "aria-label": "emoji", role: "img", variant: h, children: a }),
        /* @__PURE__ */ x(k, { alignItems: "center", flexDirection: "column", children: [
          /* @__PURE__ */ t(z, { color: "contentSecondary", component: "h2", variant: g, children: o }),
          n && /* @__PURE__ */ t(z, { color: "contentSecondary", variant: p, children: n })
        ] }),
        u && /* @__PURE__ */ x(k, { alignItems: "center", flexDirection: "column", children: [
          r && /* @__PURE__ */ t(
            he,
            {
              size: d ? fe.Default : fe.Small,
              variant: ne.Filled,
              ...r
            }
          ),
          i && /* @__PURE__ */ t(
            he,
            {
              size: d ? fe.Default : fe.Small,
              variant: ne.Text,
              ...i
            }
          )
        ] })
      ]
    }
  );
}, Oi = ({ size: e }) => e === "default" ? "bodySm500" : "captionReg500", Hi = ({ size: e, children: o }) => typeof o == "string" ? /* @__PURE__ */ t(
  z,
  {
    variant: Oi({ size: e }),
    className: re.infoNoteText,
    children: o
  }
) : /* @__PURE__ */ t(Se, { children: o }), Gi = ({
  containerClass: e = "",
  children: o,
  variant: n = "tip",
  size: a = "default",
  className: r = "",
  customIcon: i = null,
  onDismiss: s = void 0,
  fullWidth: l = !0,
  linkProps: c = void 0,
  iconTextContainerClass: d
}) => {
  const g = s !== void 0, p = Ft[n] ?? Ft.tip, _ = dn[a] ?? dn.default;
  return /* @__PURE__ */ x(
    k,
    {
      flexDirection: "row",
      justifyContent: "space-between",
      alignItems: "center",
      className: L(
        re.container,
        p.className,
        _,
        r,
        e,
        r,
        {
          [re.fullWidth]: l
        }
      ),
      children: [
        /* @__PURE__ */ x(k, { alignItems: "center", className: L(re.iconTextContainer, d), children: [
          i || p.icon,
          /* @__PURE__ */ t(Hi, { size: a, children: o })
        ] }),
        /* @__PURE__ */ x(k, { alignItems: "center", gap: 2, children: [
          c ? /* @__PURE__ */ t(
            Is,
            {
              ...c,
              forceUnderline: !c.forceNoUnderline,
              children: c.label
            }
          ) : null,
          g ? /* @__PURE__ */ t(
            Sn,
            {
              testId: "dismissIcon",
              "aria-label": "Dismiss",
              onClick: s,
              className: re.dismissIcon,
              children: /* @__PURE__ */ t(E, { className: re.clearIcon, icon: pt })
            }
          ) : null
        ] })
      ]
    }
  );
}, ji = "_loadingIcon_raaev_1", Ui = "_loadingOverlay_raaev_10", Xi = "_coverParent_raaev_26", qi = "_casefileVariant_raaev_33", dt = {
  loadingIcon: ji,
  loadingOverlay: Ui,
  coverParent: Xi,
  casefileVariant: qi
}, $u = ({
  className: e = "",
  iconColor: o = "contentSecondary",
  iconType: n = "line-scale",
  coverParent: a = !1,
  variant: r = "default",
  noFadeIn: i = !1,
  paperProps: s = {},
  ...l
}) => {
  const c = _t(o);
  return /* @__PURE__ */ t(
    Co,
    {
      classes: {
        root: L(dt.loadingOverlay, e, a && dt.coverParent, {
          [dt.casefileVariant]: r === "casefile"
        })
      },
      "data-testid": "loading-overlay",
      ...s,
      children: /* @__PURE__ */ t(
        _n,
        {
          className: dt.loadingIcon,
          color: c,
          fadeIn: i ? "none" : "half",
          name: n,
          ...l
        }
      )
    }
  );
};
var we = /* @__PURE__ */ ((e) => (e.MOB = "mob", e.XS = "xs", e.S = "s", e.M = "m", e.L = "l", e.XL = "xl", e))(we || {}), vn = /* @__PURE__ */ ((e) => (e.WARNING = "warning", e))(vn || {});
const Yi = "_root_169qw_1", Zi = "_paper_169qw_7", Ki = "_closeButton_169qw_18", Vi = "_header_169qw_22", Ji = "_headerNoBorder_169qw_28", Qi = "_sizeMob_169qw_32", Pi = "_sizeXs_169qw_40", el = "_sizeS_169qw_44", tl = "_sizeM_169qw_32", nl = "_sizeL_169qw_52", ol = "_sizeXl_169qw_56", al = "_titleSection_169qw_60", rl = "_titleContent_169qw_64", il = "_content_169qw_69", ll = "_footer_169qw_75", cl = "_mobFooter_169qw_83", sl = "_mobContent_169qw_84", dl = "_footerLeft_169qw_88", ul = "_footerRight_169qw_92", Q = {
  root: Yi,
  paper: Zi,
  closeButton: Ki,
  header: Vi,
  headerNoBorder: Ji,
  sizeMob: Qi,
  sizeXs: Pi,
  sizeS: el,
  sizeM: tl,
  sizeL: nl,
  sizeXl: ol,
  titleSection: al,
  titleContent: rl,
  content: il,
  footer: ll,
  mobFooter: cl,
  mobContent: sl,
  footerLeft: dl,
  footerRight: ul
}, At = Ce(
  ({
    title: e,
    description: o,
    onClose: n,
    children: a,
    size: r = we.M,
    footerActions: i,
    renderCustomFooter: s,
    hideHeaderBorder: l = !1,
    ...c
  }, d) => {
    var u, v;
    const g = {
      [we.MOB]: Q.sizeMob,
      [we.XS]: Q.sizeXs,
      [we.S]: Q.sizeS,
      [we.M]: Q.sizeM,
      [we.L]: Q.sizeL,
      [we.XL]: Q.sizeXl
    }[r], p = r === we.MOB, _ = !!(i || s), C = (S, D) => {
      D !== "backdropClick" && (n == null || n());
    }, h = () => {
      if (s)
        return s();
      if (!i)
        return null;
      const { cancel: S, secondary: D, primary: M } = i;
      return /* @__PURE__ */ x(
        k,
        {
          alignItems: "center",
          className: L(
            Q.footer,
            { [Q.mobFooter]: p },
            c.footerClassName
          ),
          justifyContent: "space-between",
          children: [
            /* @__PURE__ */ t("div", { className: Q.footerLeft, children: S && /* @__PURE__ */ t(
              he,
              {
                onClick: n,
                ...S,
                color: S.color || K.Critical,
                variant: S.variant || ne.Text
              },
              "cancel"
            ) }),
            /* @__PURE__ */ x(k, { alignItems: "center", className: Q.footerRight, children: [
              D && /* @__PURE__ */ t(
                he,
                {
                  ...D,
                  color: D.color || K.Secondary,
                  variant: D.variant || ne.Text
                },
                "secondary"
              ),
              M && /* @__PURE__ */ t(
                he,
                {
                  ...M,
                  color: M.color || K.Default,
                  variant: M.variant || ne.Filled
                },
                "primary"
              )
            ] })
          ]
        }
      );
    };
    return /* @__PURE__ */ x(
      Gn,
      {
        "data-tts-parent-id": c.dataTtsParentId,
        maxWidth: !1,
        onClose: C,
        ref: d,
        ...c,
        classes: {
          ...c.classes,
          root: L(Q.root, (u = c.classes) == null ? void 0 : u.root),
          paper: L(Q.paper, g, (v = c.classes) == null ? void 0 : v.paper)
        },
        children: [
          /* @__PURE__ */ t(
            "div",
            {
              className: L(
                Q.header,
                { [Q.headerNoBorder]: l },
                c.headerClassName
              ),
              children: /* @__PURE__ */ x(k, { className: Q.titleSection, flexDirection: "column", children: [
                /* @__PURE__ */ x(
                  k,
                  {
                    alignItems: "center",
                    className: Q.titleContent,
                    justifyContent: "space-between",
                    children: [
                      typeof e == "string" ? /* @__PURE__ */ t(z, { component: "h2", variant: p ? "h6" : "h5", children: e }) : /* @__PURE__ */ t("span", { children: e }),
                      typeof n == "function" && /* @__PURE__ */ t(
                        he,
                        {
                          "aria-label": "Close modal",
                          className: Q.closeButton,
                          color: K.Secondary,
                          compactVariant: "default",
                          confirmationPopoverProps: {
                            confirmationButtonText: "Yes, close",
                            ...c.closeConfirmationProps
                          },
                          "data-testid": "modal-close-button",
                          icon: /* @__PURE__ */ t(E, { icon: pt, size: "xl" }),
                          onClick: n
                        }
                      )
                    ]
                  }
                ),
                o && /* @__PURE__ */ t(z, { color: "contentTertiary", variant: "bodyReg400", children: o })
              ] })
            }
          ),
          /* @__PURE__ */ t(
            k,
            {
              className: L(
                Q.content,
                { [Q.mobContent]: p },
                c.contentClassName
              ),
              flexDirection: "column",
              children: a
            }
          ),
          _ && h()
        ]
      }
    );
  }
);
At.displayName = "BaseModal";
const wn = Ce(
  ({ message: e, secondaryMessage: o, size: n = we.XS, ...a }, r) => /* @__PURE__ */ t(At, { hideHeaderBorder: !0, ref: r, size: n, ...a, children: /* @__PURE__ */ x(k, { alignItems: "center", flexDirection: "column", gap: 2, pb: 4.5, children: [
    /* @__PURE__ */ t(z, { align: "center", variant: "stats2", children: "🛑" }),
    /* @__PURE__ */ x(
      k,
      {
        alignItems: "center",
        flexDirection: "column",
        gap: 1,
        justifyContent: "center",
        children: [
          /* @__PURE__ */ t(z, { align: "center", variant: "h5", children: e }),
          o && /* @__PURE__ */ t(z, { align: "center", variant: "bodyReg500", children: o })
        ]
      }
    )
  ] }) })
);
wn.displayName = "WarningModal";
const ml = Ce((e, o) => {
  const { variant: n, message: a, secondaryMessage: r, ...i } = e;
  switch (n) {
    case vn.WARNING:
      return /* @__PURE__ */ t(
        wn,
        {
          message: a ?? "Are you sure?",
          ref: o,
          secondaryMessage: r,
          ...i
        }
      );
    default:
      return /* @__PURE__ */ t(At, { ref: o, ...i });
  }
});
ml.displayName = "Modal";
const Du = ({ children: e }) => /* @__PURE__ */ t(Kn, { theme: la, children: e }), fl = "_container_1rgho_1", hl = "_centered_1rgho_9", mn = {
  container: fl,
  centered: hl
}, gl = ({
  centered: e,
  text: o = "",
  offset: n = 0,
  forceTooltip: a,
  tooltipProps: r,
  useMinContent: i,
  containerClassName: s,
  ...l
}) => {
  const c = it(null), [d, g] = ke(a);
  return gt(() => {
    c.current && c.current.offsetWidth !== void 0 && c.current.scrollWidth !== void 0 && c.current.offsetWidth < c.current.scrollWidth && g(!0);
  }, []), /* @__PURE__ */ t(
    ge,
    {
      ...r,
      title: d ? (r == null ? void 0 : r.title) || o : "",
      children: /* @__PURE__ */ t(
        "div",
        {
          className: L(mn.container, s, {
            [mn.centered]: e
          }),
          ref: c,
          style: {
            width: i ? "min-content" : `calc(100% - ${n}px)`
          },
          "data-testid": "overflow",
          children: /* @__PURE__ */ t(z, { ...l, component: "span", children: o })
        }
      )
    }
  );
};
var Ne = /* @__PURE__ */ ((e) => (e.DEFAULT = "default", e.LARGE = "large", e))(Ne || {}), It = /* @__PURE__ */ ((e) => (e.SEGMENTED = "segmented", e.CONTINUOUS = "continuous", e))(It || {});
const pl = "_continuousRoot_1gyl4_1", _l = "_continuousRootLarge_1gyl4_8", Cl = "_continuousBar_1gyl4_12", xt = {
  continuousRoot: pl,
  continuousRootLarge: _l,
  continuousBar: Cl
}, bl = ({
  size: e = Ne.DEFAULT,
  allowEmpty: o = !1,
  "aria-label": n = "",
  currentStep: a = 0,
  totalSteps: r = 1,
  classes: i = {}
}) => {
  const l = (o ? a : Math.max(a, 1)) / r * 100;
  return /* @__PURE__ */ t(k, { width: "100%", children: /* @__PURE__ */ t(
    bo,
    {
      variant: "determinate",
      value: Number.isFinite(l) ? l : 0,
      "aria-label": n,
      "data-testid": "progress-bar-continuous",
      classes: {
        determinate: L(
          xt.continuousRoot,
          {
            [xt.continuousRootLarge]: e === Ne.LARGE
          },
          i == null ? void 0 : i.continuousRoot
        ),
        bar: L(xt.continuousBar, i == null ? void 0 : i.continuousBar)
      }
    }
  ) });
}, yl = "_segmentedContainer_1v1el_1", Ll = "_segment_1v1el_1", Sl = "_largeSegment_1v1el_12", xl = "_completeSegment_1v1el_16", vl = "_currentSegment_1v1el_20", wl = "_errorSegment_1v1el_24", Ze = {
  segmentedContainer: yl,
  segment: Ll,
  largeSegment: Sl,
  completeSegment: xl,
  currentSegment: vl,
  errorSegment: wl
}, kl = ({
  completedSteps: e = [],
  currentStep: o = 0,
  errorSteps: n = [],
  size: a = Ne.DEFAULT,
  classes: r = {},
  totalSteps: i = 0,
  "aria-label": s = ""
}) => {
  const l = Array.from({ length: i }, (c, d) => d);
  return /* @__PURE__ */ t(
    k,
    {
      className: L(Ze.segmentedContainer, r == null ? void 0 : r.segmentedContainer),
      flexGrow: 1,
      columnGap: 1,
      alignItems: "center",
      "aria-label": s,
      "data-testid": "progress-bar-segmented",
      children: l.map((c) => /* @__PURE__ */ t(
        "div",
        {
          "data-testid": `segment-${c}`,
          className: L(
            Ze.segment,
            {
              [Ze.largeSegment]: a === Ne.LARGE,
              [Ze.completeSegment]: e.includes(c),
              [Ze.currentSegment]: o === c,
              [Ze.errorSegment]: n.includes(c)
            },
            r == null ? void 0 : r.segment
          )
        },
        c
      ))
    }
  );
}, Fu = ({
  bottomLabel: e,
  size: o = Ne.DEFAULT,
  topLabel: n,
  valueLabel: a,
  variant: r = It.SEGMENTED,
  classes: i = {},
  ...s
}) => {
  const l = r === It.SEGMENTED, d = {
    [Ne.DEFAULT]: "captionReg500",
    [Ne.LARGE]: "bodySm500"
  }[o], g = n || a;
  return /* @__PURE__ */ x(
    k,
    {
      className: i == null ? void 0 : i.rootContainer,
      flexDirection: "column",
      gap: o === Ne.LARGE ? 0.75 : 0.5,
      children: [
        g && /* @__PURE__ */ x(k, { justifyContent: "space-between", children: [
          n && /* @__PURE__ */ t(z, { variant: d, className: i == null ? void 0 : i.topLabel, children: n }),
          a && /* @__PURE__ */ t(z, { variant: d, className: i == null ? void 0 : i.valueLabel, children: a })
        ] }),
        /* @__PURE__ */ t(k, { flexGrow: 1, alignItems: "center", children: l ? /* @__PURE__ */ t(kl, { size: o, classes: i, ...s }) : /* @__PURE__ */ t(bl, { size: o, classes: i, ...s }) }),
        e && /* @__PURE__ */ t(z, { variant: d, className: i == null ? void 0 : i.bottomLabel, children: e })
      ]
    }
  );
};
var Ge = /* @__PURE__ */ ((e) => (e.Small = "small", e.Default = "default", e.Large = "large", e))(Ge || {}), He = /* @__PURE__ */ ((e) => (e.Start = "start", e.End = "end", e.Top = "top", e.Bottom = "bottom", e))(He || {});
const Ml = "_toggleButton_1waos_1", $l = "_disabled_1waos_9", Dl = "_selected_1waos_24", Fl = "_small_1waos_28", Il = "_large_1waos_32", Bl = "_toggleButtonFullWidth_1waos_36", Rl = "_toggleButtonText_1waos_40", Nl = "_toggleButtonTextSelected_1waos_44", Tl = "_toggleButtonTextDisabled_1waos_48", Ie = {
  toggleButton: Ml,
  disabled: $l,
  selected: Dl,
  small: Fl,
  large: Il,
  toggleButtonFullWidth: Bl,
  toggleButtonText: Rl,
  toggleButtonTextSelected: Nl,
  toggleButtonTextDisabled: Tl
}, Wl = ({
  icon: e,
  label: o,
  tooltip: n,
  confirmationPopover: a,
  value: r,
  isDisabled: i,
  isSelected: s,
  iconDirection: l,
  onChange: c,
  onClick: d,
  fullWidth: g,
  size: p,
  ..._
}) => {
  const C = p === Ge.Small, h = p === Ge.Large, u = {
    [Ge.Small]: "bodySm600",
    [Ge.Default]: "bodySm600",
    [Ge.Large]: "bodyReg600"
  }, v = [He.Top, He.Bottom].includes(
    l
  ) ? "column" : "row", S = [He.Start, He.Top].includes(
    l
  ), D = [He.End, He.Bottom].includes(
    l
  ), M = () => /* @__PURE__ */ t(ge, { placement: "top", title: n ?? "", children: /* @__PURE__ */ x(k, { alignItems: "center", gap: 1, flexDirection: v, children: [
    S && e,
    /* @__PURE__ */ t(
      z,
      {
        variant: u[p],
        className: L(Ie.toggleButtonText, {
          [Ie.toggleButtonTextSelected]: s,
          [Ie.toggleButtonTextDisabled]: i
        }),
        children: o
      }
    ),
    D && e
  ] }) }), R = {
    key: r,
    value: r,
    selected: s,
    disabled: i,
    classes: {
      root: L(Ie.toggleButton, {
        [Ie.toggleButtonFullWidth]: g,
        [Ie.small]: C,
        [Ie.large]: h
      }),
      selected: Ie.selected,
      disabled: Ie.disabled
    }
  }, {
    confirmationText: B,
    confirmationPopoverCancelButtonText: H,
    confirmationButtonText: X,
    confirmationButtonColor: U
  } = a || {};
  return a && !s ? /* @__PURE__ */ t(
    Et,
    {
      withCustomAnchor: !0,
      anchorContent: ({
        anchorElementProps: G
      }) => /* @__PURE__ */ t(
        en,
        {
          ..._,
          ...R,
          onClick: (T) => {
            var N;
            T.preventDefault(), T.stopPropagation(), (N = G == null ? void 0 : G.onClick) == null || N.call(
              G,
              T
            );
          },
          children: M()
        }
      ),
      popoverContent: ({ setAnchor: G }) => /* @__PURE__ */ x("div", { children: [
        B && /* @__PURE__ */ t(z, { variant: "bodySm400", mb: 1.5, children: B }),
        /* @__PURE__ */ x(
          k,
          {
            alignItems: "center",
            justifyContent: "space-between",
            width: "100%",
            children: [
              /* @__PURE__ */ t(
                he,
                {
                  label: H ?? "Cancel",
                  size: fe.Small,
                  color: K.Default,
                  variant: ne.Text,
                  onClick: (T) => {
                    if (s) {
                      T.preventDefault(), T.stopPropagation();
                      return;
                    }
                    T.stopPropagation(), G(null);
                  }
                }
              ),
              /* @__PURE__ */ t(
                he,
                {
                  label: X ?? "Confirm",
                  size: fe.Small,
                  variant: ne.Outlined,
                  color: U ?? K.Default,
                  onClick: async (T) => {
                    await (d == null ? void 0 : d(
                      T,
                      r
                    )), c == null || c(
                      T,
                      r
                    ), G(null);
                  }
                }
              )
            ]
          }
        )
      ] })
    },
    r
  ) : /* @__PURE__ */ t(
    en,
    {
      ..._,
      ...R,
      onClick: (G) => {
        if (s) {
          G.preventDefault(), G.stopPropagation();
          return;
        }
        d == null || d(G, r), c == null || c(G, r);
      },
      children: M()
    }
  );
}, Al = "_toggleButtonGroup_dedp6_1", zl = "_small_dedp6_8", fn = {
  toggleButtonGroup: Al,
  small: zl
}, Iu = ({
  value: e,
  buttons: o,
  onChange: n,
  size: a = Ge.Default,
  iconDirection: r = He.Start,
  disabled: i = !1,
  className: s,
  fullWidth: l = !1,
  ...c
}) => {
  const d = a === Ge.Small;
  return /* @__PURE__ */ t(
    yo,
    {
      value: e,
      onChange: n,
      disabled: i,
      className: L(
        fn.toggleButtonGroup,
        {
          [fn.small]: d
        },
        s
      ),
      fullWidth: l,
      exclusive: !0,
      ...c,
      children: o.map((g) => {
        const {
          buttonValue: p,
          disabled: _,
          icon: C,
          label: h,
          tooltip: u,
          confirmationPopover: v,
          onClick: S,
          ...D
        } = g;
        return /* @__PURE__ */ t(
          Wl,
          {
            icon: C,
            label: h,
            tooltip: u ?? "",
            confirmationPopover: v,
            iconDirection: r,
            isDisabled: i || !!_,
            isSelected: e === p,
            onChange: n,
            onClick: S,
            fullWidth: l,
            ...D,
            value: p,
            size: a
          },
          p
        );
      })
    }
  );
}, kn = () => /* @__PURE__ */ x(k, { flexDirection: "column", width: "100%", children: [
  /* @__PURE__ */ t(pe, { variant: "text", width: "25%" }),
  /* @__PURE__ */ t(pe, { variant: "text", width: "75%" }),
  /* @__PURE__ */ t(pe, { variant: "text", width: "60%" })
] }), El = "_root_31ksi_1", Ol = {
  root: El
}, Hl = ({ "data-testid": e }) => /* @__PURE__ */ t(Tt, { className: Ol.root, "data-testid": e, children: /* @__PURE__ */ x(k, { columnGap: 1, children: [
  /* @__PURE__ */ t(pe, { height: 40, width: 40, variant: "circular" }),
  /* @__PURE__ */ t(kn, {})
] }) }), Gl = "_root_31ksi_1", jl = {
  root: Gl
}, Ul = ({ "data-testid": e }) => /* @__PURE__ */ t(Tt, { className: jl.root, "data-testid": e, children: /* @__PURE__ */ t(kn, {}) }), Xl = ({ "data-testid": e }) => /* @__PURE__ */ x(k, { columnGap: 1, alignItems: "center", "data-testid": e, children: [
  /* @__PURE__ */ t(pe, { height: 32, width: 32, variant: "circular" }),
  /* @__PURE__ */ t(pe, { variant: "text", width: 80, height: 24 })
] }), ql = ({ "data-testid": e }) => /* @__PURE__ */ t(k, { justifyContent: "center", "data-testId": e, children: /* @__PURE__ */ t(_n, { color: f.color.grayLight }) }), Yl = "_card_1m238_1", Zl = "_metaData_1m238_5", Kl = "_errorMessage_1m238_10", vt = {
  card: Yl,
  metaData: Zl,
  errorMessage: Kl
}, Vl = ({
  errorMessage: e = "",
  "data-testid": o
}) => /* @__PURE__ */ t(Tt, { className: vt.card, "data-testid": o, children: /* @__PURE__ */ x(k, { flexDirection: "column", children: [
  e && /* @__PURE__ */ t(
    z,
    {
      className: vt.errorMessage,
      color: "contentStatusWarning",
      component: "h3",
      variant: "titleSm700",
      children: e
    }
  ),
  /* @__PURE__ */ t(pe, { height: 200, variant: "rectangular" }),
  /* @__PURE__ */ x(
    k,
    {
      alignItems: "center",
      className: vt.metaData,
      flexShrink: "0",
      justifyContent: "space-between",
      children: [
        /* @__PURE__ */ x(k, { alignItems: "center", columnGap: 1, flexGrow: 1, children: [
          /* @__PURE__ */ t(pe, { height: 32, variant: "circular", width: 32 }),
          /* @__PURE__ */ x(k, { flexDirection: "column", flexGrow: 1, children: [
            /* @__PURE__ */ t(pe, { height: 20, width: "75%" }),
            /* @__PURE__ */ t(pe, { height: 20, width: "90%" })
          ] })
        ] }),
        /* @__PURE__ */ t(k, { alignItems: "center", flexGrow: 1, justifyContent: "flex-end", children: /* @__PURE__ */ t(pe, { height: 40, width: "50%" }) })
      ]
    }
  )
] }) }), Jl = {
  listItem: Hl,
  listItemText: Ul,
  threeDots: ql,
  tableCellUser: Xl,
  videoCard: Vl
}, Bu = ({
  className: e = "",
  component: o = void 0,
  count: n = 1,
  "data-testid": a,
  ...r
}) => {
  const i = o ? Jl[o] : void 0;
  return Array(n).fill(0).map(
    (s) => i ? /* @__PURE__ */ t(i, { "data-testid": a }, s) : /* @__PURE__ */ t(
      pe,
      {
        className: e,
        "data-testid": a,
        ...r
      },
      s
    )
  );
};
var ot = /* @__PURE__ */ ((e) => (e.Small = "small", e.Default = "default", e.Large = "large", e))(ot || {}), Mn = /* @__PURE__ */ ((e) => (e.Transparent = "transparent", e.Filled = "filled", e))(Mn || {}), $n = /* @__PURE__ */ ((e) => (e.Outlined = "outlined", e.Filled = "filled", e))($n || {});
const Ql = "_container_1cr8e_1", Pl = "_large_1cr8e_9", ec = "_dot_1cr8e_13", tc = "_small_1cr8e_18", nc = "_critical_1cr8e_49", oc = "_dotOutlined_1cr8e_57", ac = "_statusLozengeText_1cr8e_66", rc = "_neutral_1cr8e_71", ic = "_warning_1cr8e_93", lc = "_success_1cr8e_115", cc = "_info_1cr8e_137", sc = "_note_1cr8e_159", dc = "_progress_1cr8e_181", uc = "_transparentBg_1cr8e_200", Ue = {
  container: Ql,
  large: Pl,
  dot: ec,
  small: tc,
  default: "_default_1cr8e_28",
  critical: nc,
  dotOutlined: oc,
  statusLozengeText: ac,
  neutral: rc,
  warning: ic,
  success: lc,
  info: cc,
  note: sc,
  progress: dc,
  transparentBg: uc
}, Ru = ({
  className: e = "",
  color: o = te.Success,
  "data-testid": n,
  dot: a = !1,
  dotVariant: r = $n.Filled,
  icon: i,
  label: s,
  size: l = ot.Default,
  variant: c = Mn.Filled
}) => {
  const d = Ln(o), g = Ue[d], p = Ue[l], _ = {
    [ot.Small]: "captionReg600",
    [ot.Default]: "bodySm600",
    [ot.Large]: "bodyReg600"
  };
  return /* @__PURE__ */ x(
    k,
    {
      alignItems: "center",
      className: L(Ue.container, g, p, e, {
        [Ue.transparentBg]: c === "transparent"
      }),
      "data-testid": n,
      children: [
        i,
        a && /* @__PURE__ */ t(
          "div",
          {
            "data-testid": "status-lozenge-dot",
            className: L(Ue.dot, {
              [Ue.dotOutlined]: r === "outlined"
            })
          }
        ),
        /* @__PURE__ */ t(z, { variant: _[l], className: Ue.statusLozengeText, children: s })
      ]
    }
  );
}, mc = "_segmentsContainer_f4woj_1", fc = "_segmentBar_f4woj_21", hc = "_segmentBarDefault_f4woj_26", gc = "_segmentBarSmall_f4woj_30", pc = "_success_f4woj_35", _c = "_critical_f4woj_39", Cc = "_warning_f4woj_43", bc = "_progress_f4woj_47", yc = "_info_f4woj_51", Lc = "_note_f4woj_55", Sc = "_neutral_f4woj_59", xc = "_segmentFilterLabel_f4woj_64", vc = "_segmentFilterLabelSmall_f4woj_68", Xe = {
  segmentsContainer: mc,
  segmentBar: fc,
  segmentBarDefault: hc,
  segmentBarSmall: gc,
  success: pc,
  critical: _c,
  warning: Cc,
  progress: bc,
  info: yc,
  note: Lc,
  neutral: Sc,
  segmentFilterLabel: xc,
  segmentFilterLabelSmall: vc
};
var Bt = /* @__PURE__ */ ((e) => (e.Key = "key", e.Filter = "filter", e))(Bt || {}), Rt = /* @__PURE__ */ ((e) => (e.Small = "small", e.Default = "default", e))(Rt || {});
const Nu = ({
  variant: e = Bt.Key,
  size: o = Rt.Default,
  segments: n = [],
  keyLabel: a,
  containerClass: r,
  showLegend: i = !0,
  onClick: s = () => {
  }
}) => {
  const { isDesktop: l } = Nt(), c = e === Bt.Filter, d = o === Rt.Small, g = Math.max(
    n.reduce((h, u) => h + u.count, 0),
    1
  ), p = n.map((h) => {
    const u = h.count / g * 100 || 0;
    return {
      ...h,
      percent: u
    };
  }), _ = (h) => h.percent ? /* @__PURE__ */ t(
    ge,
    {
      placement: "top",
      title: h.tooltip || "",
      children: /* @__PURE__ */ t(
        k,
        {
          "aria-label": h.label,
          className: L(
            Xe.segmentBar,
            Xe[h.color || te.Success],
            d ? Xe.segmentBarSmall : Xe.segmentBarDefault
          ),
          component: "button",
          onClick: () => s(h),
          width: `${h.percent}%`
        }
      )
    },
    h.label
  ) : null, C = (h) => {
    var B;
    const u = h.label || "", v = h.count || 0, S = h.legendTooltip !== void 0 ? h.legendTooltip : `${(B = h.percent) == null ? void 0 : B.toFixed(2)}%`, D = !!h.checked, M = h.onChange || (() => {
    }), R = d ? "captionReg500" : "bodyReg500";
    return /* @__PURE__ */ t(ge, { placement: "top", title: S, children: /* @__PURE__ */ t("div", { children: c ? /* @__PURE__ */ t(k, { columnGap: 0.5, children: /* @__PURE__ */ t(
      ri,
      {
        badgePosition: at.Left,
        badgeProps: {
          color: h.color,
          number: v
        },
        checked: D,
        classes: {
          label: L(Xe.segmentFilterLabel, {
            [Xe.segmentFilterLabelSmall]: d
          })
        },
        label: /* @__PURE__ */ t(z, { variant: R, children: u }),
        onChange: (H) => M(H.target.checked),
        size: d ? Re.Small : Re.Default
      }
    ) }) : /* @__PURE__ */ x(k, { alignItems: "center", gap: 0.5, children: [
      /* @__PURE__ */ t(Je, { color: h.color, number: v }),
      /* @__PURE__ */ t(z, { variant: R, children: u })
    ] }) }) }, h.label);
  };
  return /* @__PURE__ */ x(
    k,
    {
      alignItems: "center",
      className: r,
      flexDirection: "column",
      rowGap: 1,
      width: "100%",
      children: [
        /* @__PURE__ */ t(k, { className: Xe.segmentsContainer, columnGap: 0.25, children: p.map((h) => _(h)) }),
        /* @__PURE__ */ x(
          k,
          {
            alignItems: "center",
            columnGap: c ? 6 : 2,
            flexWrap: "wrap",
            justifyContent: c ? "center" : void 0,
            rowGap: 1,
            width: l ? "max-content" : void 0,
            children: [
              !c && a && /* @__PURE__ */ x(z, { color: "contentSecondary", variant: "captionReg500", children: [
                a,
                ":"
              ] }),
              i && p.map((h) => C(h))
            ]
          }
        )
      ]
    }
  );
};
var ht = /* @__PURE__ */ ((e) => (e.Vertical = "vertical", e.Horizontal = "horizontal", e))(ht || {}), Dn = /* @__PURE__ */ ((e) => (e.FullWidth = "fullWidth", e.Scrollable = "scrollable", e.Standard = "standard", e))(Dn || {}), Be = /* @__PURE__ */ ((e) => (e.Small = "small", e.Default = "default", e.Large = "large", e))(Be || {}), zt = /* @__PURE__ */ ((e) => (e.Top = "top", e.Bottom = "bottom", e.Start = "start", e.End = "end", e))(zt || {});
const wc = "_tab_1kn6s_1", kc = "_disabled_1kn6s_19", Mc = "_selected_1kn6s_29", $c = "_small_1kn6s_36", Dc = "_large_1kn6s_46", Fc = "_vertical_1kn6s_52", Ic = "_iconWrapper_1kn6s_67", Bc = "_selectedIcon_1kn6s_73", Rc = "_disabledIcon_1kn6s_77", Nc = "_smallIcon_1kn6s_81", Tc = "_defaultIcon_1kn6s_86", Wc = "_largeIcon_1kn6s_87", Ac = "_badge_1kn6s_93", ce = {
  tab: wc,
  disabled: kc,
  selected: Mc,
  small: $c,
  default: "_default_1kn6s_41",
  large: Dc,
  vertical: Fc,
  iconWrapper: Ic,
  selectedIcon: Bc,
  disabledIcon: Rc,
  smallIcon: Nc,
  defaultIcon: Tc,
  largeIcon: Wc,
  badge: Ac
}, zc = ({
  value: e,
  size: o = Be.Default,
  label: n,
  disabled: a = !1,
  tooltipProps: r,
  badgeProps: i,
  icon: s,
  iconPosition: l = zt.Start,
  classes: c = {},
  orientation: d,
  isSelected: g = !1,
  ...p
}) => {
  const _ = o === Be.Small, C = o === Be.Default, h = o === Be.Large, u = {
    [Be.Default]: I.bodySm500,
    [Be.Small]: I.captionReg500,
    [Be.Large]: I.bodyReg500
  }, v = L(
    ce.tab,
    {
      [ce.small]: _,
      [ce.default]: C,
      [ce.large]: h,
      [ce.disabled]: a,
      [ce.vertical]: d === ht.Vertical,
      [ce.selected]: g
    },
    c == null ? void 0 : c.root
  ), S = L(
    ce.iconWrapper,
    {
      [ce.smallIcon]: _,
      [ce.defaultIcon]: C,
      [ce.largeIcon]: h,
      [ce.selectedIcon]: g,
      [ce.disabledIcon]: a
    },
    c == null ? void 0 : c.iconWrapper
  ), D = /* @__PURE__ */ x(Se, { children: [
    typeof n == "string" ? /* @__PURE__ */ t(z, { variant: u[o], children: n }) : n,
    i && /* @__PURE__ */ t("div", { className: ce.badge, children: /* @__PURE__ */ t(Je, { ...i, size: o }) })
  ] }), M = (r == null ? void 0 : r.placement) || (d === ht.Horizontal ? "top" : "right");
  return /* @__PURE__ */ t(
    ge,
    {
      ...r,
      placement: M,
      title: (r == null ? void 0 : r.title) ?? "",
      children: /* @__PURE__ */ t(
        So,
        {
          value: e,
          disabled: a,
          classes: {
            ...c,
            root: v,
            iconWrapper: S
          },
          label: D,
          icon: s,
          iconPosition: l,
          ...p
        }
      )
    }
  );
}, Ec = "_tabs_1hrcg_1", Oc = "_flexContainer_1hrcg_6", Hc = "_indicator_1hrcg_11", Gc = "_indicatorHorizontal_1hrcg_15", jc = "_indicatorVertical_1hrcg_19", Uc = "_hideIndicator_1hrcg_26", Ke = {
  tabs: Ec,
  flexContainer: Oc,
  indicator: Hc,
  indicatorHorizontal: Gc,
  indicatorVertical: jc,
  hideIndicator: Uc
}, Tu = ({
  tabs: e,
  value: o,
  hideIndicator: n = !1,
  iconPosition: a = zt.Start,
  onTabSelect: r,
  orientation: i = ht.Horizontal,
  variant: s = Dn.Scrollable,
  size: l = Be.Default,
  tabClasses: c,
  classes: d,
  allowScrollButtonsMobile: g = !1,
  ...p
}) => {
  const _ = (u, v) => {
    r == null || r(v);
  }, C = {
    iconPosition: a,
    size: l,
    classes: c,
    orientation: i
  }, h = e.every((u) => u.value !== void 0) ? e.findIndex((u) => u.value === o) : o;
  return /* @__PURE__ */ t(
    Lo,
    {
      allowScrollButtonsMobile: g,
      value: o,
      onChange: _,
      variant: s,
      orientation: i,
      classes: {
        root: L(Ke.tabs, d == null ? void 0 : d.root),
        flexContainer: Ke.flexContainer,
        indicator: L(Ke.indicator, {
          [Ke.indicatorHorizontal]: i === "horizontal",
          [Ke.indicatorVertical]: i === "vertical",
          [Ke.hideIndicator]: n
        }),
        ...d
      },
      ...p,
      children: e == null ? void 0 : e.map((u, v) => u.hidden ? null : /* @__PURE__ */ t(
        zc,
        {
          isSelected: h === v,
          ...C,
          ...u
        },
        u.label || v
      ))
    }
  );
};
var rt = /* @__PURE__ */ ((e) => (e.SMALL = "small", e.DEFAULT = "default", e))(rt || {}), _e = /* @__PURE__ */ ((e) => (e.TEXT = "text", e.NUMBER = "number", e.PASSWORD = "password", e.EMAIL = "email", e.SEARCH = "search", e.PHONE = "tel", e.URL = "url", e))(_e || {});
const Xc = ({
  charCount: e,
  charLimit: o,
  error: n,
  hasCharLimitError: a,
  helperId: r,
  helperText: i,
  isSmall: s
}) => /* @__PURE__ */ x(Se, { children: [
  /* @__PURE__ */ t(
    z,
    {
      color: n ? "contentCriticalDefault" : void 0,
      component: "span",
      id: r,
      variant: s ? "captionSm500" : "captionReg500",
      children: i
    }
  ),
  o && /* @__PURE__ */ x(
    z,
    {
      color: n || a ? "contentCriticalDefault" : void 0,
      component: "span",
      variant: s ? "captionSm500" : "captionReg500",
      children: [
        e,
        "/",
        o
      ]
    }
  )
] }), qc = "_root_mmc7m_1", Yc = "_inputRoot_mmc7m_5", Zc = "_disabled_mmc7m_12", Kc = "_inputDisabled_mmc7m_12", Vc = "_input_mmc7m_5", Jc = "_inputNotchedOutline_mmc7m_18", Qc = "_singleLine_mmc7m_34", Pc = "_inputFocused_mmc7m_42", es = "_small_mmc7m_46", ts = "_fullWidth_mmc7m_66", ns = "_label_mmc7m_70", os = "_helperTextBox_mmc7m_75", as = "_compactCharLimit_mmc7m_81", rs = "_hideNumberArrows_mmc7m_88", is = "_startAdornment_mmc7m_101", ie = {
  root: qc,
  inputRoot: Yc,
  disabled: Zc,
  inputDisabled: Kc,
  input: Vc,
  inputNotchedOutline: Jc,
  singleLine: Qc,
  inputFocused: Pc,
  small: es,
  fullWidth: ts,
  label: ns,
  helperTextBox: os,
  compactCharLimit: as,
  hideNumberArrows: rs,
  startAdornment: is
}, Qe = Ce(
  ({
    charLimit: e,
    compactCharLimit: o,
    "data-testid": n,
    disabled: a,
    enableHardLimit: r,
    endAdornment: i,
    error: s,
    fullWidth: l,
    helperText: c,
    hideNumberArrows: d,
    id: g,
    inputRootClass: p,
    label: _,
    loading: C,
    required: h,
    rootClass: u,
    size: v = rt.DEFAULT,
    type: S,
    useFloatingLabel: D,
    value: M,
    ...R
  }, B) => {
    var y;
    const H = "helper-text", X = typeof M == "string" ? M.length : String(M || "").length, U = !!e && X > e, G = r ? String(M || "").slice(0, e) : M, T = v === rt.SMALL, N = !!(s || U), ue = C ? /* @__PURE__ */ t(
      E,
      {
        color: "contentSecondary",
        "data-testid": "loader-icon",
        icon: xo,
        spin: !0
      }
    ) : R == null ? void 0 : R.startAdornment, Me = {
      ...R.inputProps,
      "data-testid": n,
      ...r && e ? { maxLength: e } : {},
      autocomplete: "new-password",
      form: {
        autocomplete: "off"
      },
      size: (y = R.placeholder) == null ? void 0 : y.length
    }, F = T ? "captionReg500" : "bodySm500";
    return /* @__PURE__ */ x(
      k,
      {
        flexDirection: "column",
        gap: 0.5,
        width: l ? "100%" : void 0,
        children: [
          !D && /* @__PURE__ */ x(
            z,
            {
              component: "label",
              "data-testid": "input-label",
              htmlFor: g || _,
              variant: F,
              children: [
                _,
                h && /* @__PURE__ */ x(Se, { children: [
                  " ",
                  /* @__PURE__ */ t(
                    z,
                    {
                      color: "contentCriticalDefault",
                      component: "span",
                      variant: F,
                      children: "*"
                    }
                  )
                ] })
              ]
            }
          ),
          /* @__PURE__ */ t(
            jn,
            {
              "aria-describedby": c ? H : void 0,
              autoComplete: "new-password",
              disabled: a || C,
              error: N,
              FormHelperTextProps: {
                classes: {
                  root: L(ie.helperTextBox, {
                    [ie.compactCharLimit]: o
                  })
                }
              },
              helperText: !c && !e ? void 0 : /* @__PURE__ */ t(
                Xc,
                {
                  charCount: X,
                  charLimit: e,
                  error: s,
                  hasCharLimitError: U,
                  helperId: H,
                  helperText: c,
                  isSmall: T
                }
              ),
              id: g || _,
              inputProps: Me,
              label: D ? _ : void 0,
              ref: B,
              type: S,
              ...R,
              classes: {
                ...R.classes,
                root: L(ie.root, u, {
                  [ie.fullWidth]: l,
                  [ie.disabled]: a || C,
                  [ie.hideNumberArrows]: d && S === _e.NUMBER
                })
              },
              InputLabelProps: {
                classes: { root: L(ie.label) },
                ...R.InputLabelProps
              },
              InputProps: {
                ...R.InputProps,
                classes: {
                  adornedStart: ie.startAdornment,
                  disabled: ie.inputDisabled,
                  focused: ie.inputFocused,
                  input: L(ie.input, {
                    [ie.small]: T,
                    [ie.singleLine]: !(R != null && R.multiline)
                  }),
                  notchedOutline: ie.inputNotchedOutline,
                  root: L(ie.inputRoot, p)
                },
                endAdornment: i,
                startAdornment: ue
              },
              value: G,
              variant: "outlined"
            }
          )
        ]
      }
    );
  }
), ls = "https://", hn = [
  {
    name: "United States",
    countryCode2Letter: "US",
    phoneCode: "+1",
    flag: "🇺🇸"
  },
  {
    name: "Aruba",
    countryCode2Letter: "AW",
    phoneCode: "+297",
    flag: "🇦🇼"
  },
  {
    name: "Afghanistan",
    countryCode2Letter: "AF",
    phoneCode: "+93",
    flag: "🇦🇫"
  },
  {
    name: "Angola",
    countryCode2Letter: "AO",
    phoneCode: "+244",
    flag: "🇦🇴"
  },
  {
    name: "Anguilla",
    countryCode2Letter: "AI",
    phoneCode: "+1",
    flag: "🇦🇮"
  },
  {
    name: "Åland Islands",
    countryCode2Letter: "AX",
    phoneCode: "+358",
    flag: "🇦🇽"
  },
  {
    name: "Albania",
    countryCode2Letter: "AL",
    phoneCode: "+355",
    flag: "🇦🇱"
  },
  {
    name: "Andorra",
    countryCode2Letter: "AD",
    phoneCode: "+376",
    flag: "🇦🇩"
  },
  {
    name: "United Arab Emirates",
    countryCode2Letter: "AE",
    phoneCode: "+971",
    flag: "🇦🇪"
  },
  {
    name: "Argentina",
    countryCode2Letter: "AR",
    phoneCode: "+54",
    flag: "🇦🇷"
  },
  {
    name: "Armenia",
    countryCode2Letter: "AM",
    phoneCode: "+374",
    flag: "🇦🇲"
  },
  {
    name: "American Samoa",
    countryCode2Letter: "AS",
    phoneCode: "+1",
    flag: "🇦🇸"
  },
  {
    name: "Antarctica",
    countryCode2Letter: "AQ",
    phoneCode: "+672",
    flag: "🇦🇶"
  },
  {
    name: "French Southern Territories",
    countryCode2Letter: "TF",
    phoneCode: "+262",
    flag: "🇹🇫"
  },
  {
    name: "Antigua and Barbuda",
    countryCode2Letter: "AG",
    phoneCode: "+1",
    flag: "🇦🇬"
  },
  {
    name: "Australia",
    countryCode2Letter: "AU",
    phoneCode: "+61",
    flag: "🇦🇺"
  },
  {
    name: "Austria",
    countryCode2Letter: "AT",
    phoneCode: "+43",
    flag: "🇦🇹"
  },
  {
    name: "Azerbaijan",
    countryCode2Letter: "AZ",
    phoneCode: "+994",
    flag: "🇦🇿"
  },
  {
    name: "Burundi",
    countryCode2Letter: "BI",
    phoneCode: "+257",
    flag: "🇧🇮"
  },
  {
    name: "Belgium",
    countryCode2Letter: "BE",
    phoneCode: "+32",
    flag: "🇧🇪"
  },
  {
    name: "Benin",
    countryCode2Letter: "BJ",
    phoneCode: "+229",
    flag: "🇧🇯"
  },
  {
    name: "Bonaire, Sint Eustatius and Saba",
    countryCode2Letter: "BQ",
    phoneCode: "+599",
    flag: "🇧🇶"
  },
  {
    name: "Burkina Faso",
    countryCode2Letter: "BF",
    phoneCode: "+226",
    flag: "🇧🇫"
  },
  {
    name: "Bangladesh",
    countryCode2Letter: "BD",
    phoneCode: "+880",
    flag: "🇧🇩"
  },
  {
    name: "Bulgaria",
    countryCode2Letter: "BG",
    phoneCode: "+359",
    flag: "🇧🇬"
  },
  {
    name: "Bahrain",
    countryCode2Letter: "BH",
    phoneCode: "+973",
    flag: "🇧🇭"
  },
  {
    name: "Bahamas",
    countryCode2Letter: "BS",
    phoneCode: "+1",
    flag: "🇧🇸"
  },
  {
    name: "Bosnia and Herzegovina",
    countryCode2Letter: "BA",
    phoneCode: "+387",
    flag: "🇧🇦"
  },
  {
    name: "Saint Barthélemy",
    countryCode2Letter: "BL",
    phoneCode: "+590",
    flag: "🇧🇱"
  },
  {
    name: "Belarus",
    countryCode2Letter: "BY",
    phoneCode: "+375",
    flag: "🇧🇾"
  },
  {
    name: "Belize",
    countryCode2Letter: "BZ",
    phoneCode: "+501",
    flag: "🇧🇿"
  },
  {
    name: "Bermuda",
    countryCode2Letter: "BM",
    phoneCode: "+1",
    flag: "🇧🇲"
  },
  {
    name: "Bolivia, Plurinational State of",
    countryCode2Letter: "BO",
    phoneCode: "+591",
    flag: "🇧🇴"
  },
  {
    name: "Brazil",
    countryCode2Letter: "BR",
    phoneCode: "+55",
    flag: "🇧🇷"
  },
  {
    name: "Barbados",
    countryCode2Letter: "BB",
    phoneCode: "+1",
    flag: "🇧🇧"
  },
  {
    name: "Brunei Darussalam",
    countryCode2Letter: "BN",
    phoneCode: "+673",
    flag: "🇧🇳"
  },
  {
    name: "Bhutan",
    countryCode2Letter: "BT",
    phoneCode: "+975",
    flag: "🇧🇹"
  },
  {
    name: "Bouvet Island",
    countryCode2Letter: "BV",
    phoneCode: "+47",
    flag: "🇧🇻"
  },
  {
    name: "Botswana",
    countryCode2Letter: "BW",
    phoneCode: "+267",
    flag: "🇧🇼"
  },
  {
    name: "Central African Republic",
    countryCode2Letter: "CF",
    phoneCode: "+236",
    flag: "🇨🇫"
  },
  {
    name: "Canada",
    countryCode2Letter: "CA",
    phoneCode: "+1",
    flag: "🇨🇦"
  },
  {
    name: "Cocos (Keeling) Islands",
    countryCode2Letter: "CC",
    phoneCode: "+61",
    flag: "🇨🇨"
  },
  {
    name: "Switzerland",
    countryCode2Letter: "CH",
    phoneCode: "+41",
    flag: "🇨🇭"
  },
  {
    name: "Chile",
    countryCode2Letter: "CL",
    phoneCode: "+56",
    flag: "🇨🇱"
  },
  {
    name: "China",
    countryCode2Letter: "CN",
    phoneCode: "+86",
    flag: "🇨🇳"
  },
  {
    name: "Côte d'Ivoire",
    countryCode2Letter: "CI",
    phoneCode: "+225",
    flag: "🇨🇮"
  },
  {
    name: "Cameroon",
    countryCode2Letter: "CM",
    phoneCode: "+237",
    flag: "🇨🇲"
  },
  {
    name: "Congo, the Democratic Republic of the",
    countryCode2Letter: "CD",
    phoneCode: "+243",
    flag: "🇨🇩"
  },
  {
    name: "Congo",
    countryCode2Letter: "CG",
    phoneCode: "+242",
    flag: "🇨🇬"
  },
  {
    name: "Cook Islands",
    countryCode2Letter: "CK",
    phoneCode: "+682",
    flag: "🇨🇰"
  },
  {
    name: "Colombia",
    countryCode2Letter: "CO",
    phoneCode: "+57",
    flag: "🇨🇴"
  },
  {
    name: "Comoros",
    countryCode2Letter: "KM",
    phoneCode: "+269",
    flag: "🇰🇲"
  },
  {
    name: "Cape Verde",
    countryCode2Letter: "CV",
    phoneCode: "+238",
    flag: "🇨🇻"
  },
  {
    name: "Costa Rica",
    countryCode2Letter: "CR",
    phoneCode: "+506",
    flag: "🇨🇷"
  },
  {
    name: "Cuba",
    countryCode2Letter: "CU",
    phoneCode: "+53",
    flag: "🇨🇺"
  },
  {
    name: "Curaçao",
    countryCode2Letter: "CW",
    phoneCode: "+599",
    flag: "🇨🇼"
  },
  {
    name: "Christmas Island",
    countryCode2Letter: "CX",
    phoneCode: "+61",
    flag: "🇨🇽"
  },
  {
    name: "Cayman Islands",
    countryCode2Letter: "KY",
    phoneCode: "+1",
    flag: "🇰🇾"
  },
  {
    name: "Cyprus",
    countryCode2Letter: "CY",
    phoneCode: "+357",
    flag: "🇨🇾"
  },
  {
    name: "Czech Republic",
    countryCode2Letter: "CZ",
    phoneCode: "+420",
    flag: "🇨🇿"
  },
  {
    name: "Germany",
    countryCode2Letter: "DE",
    phoneCode: "+49",
    flag: "🇩🇪"
  },
  {
    name: "Djibouti",
    countryCode2Letter: "DJ",
    phoneCode: "+253",
    flag: "🇩🇯"
  },
  {
    name: "Dominica",
    countryCode2Letter: "DM",
    phoneCode: "+1",
    flag: "🇩🇲"
  },
  {
    name: "Denmark",
    countryCode2Letter: "DK",
    phoneCode: "+45",
    flag: "🇩🇰"
  },
  {
    name: "Dominican Republic",
    countryCode2Letter: "DO",
    phoneCode: "+1",
    flag: "🇩🇴"
  },
  {
    name: "Algeria",
    countryCode2Letter: "DZ",
    phoneCode: "+213",
    flag: "🇩🇿"
  },
  {
    name: "Ecuador",
    countryCode2Letter: "EC",
    phoneCode: "+593",
    flag: "🇪🇨"
  },
  {
    name: "Egypt",
    countryCode2Letter: "EG",
    phoneCode: "+20",
    flag: "🇪🇬"
  },
  {
    name: "Eritrea",
    countryCode2Letter: "ER",
    phoneCode: "+291",
    flag: "🇪🇷"
  },
  {
    name: "Western Sahara",
    countryCode2Letter: "EH",
    phoneCode: "+212",
    flag: "🇪🇭"
  },
  {
    name: "Spain",
    countryCode2Letter: "ES",
    phoneCode: "+34",
    flag: "🇪🇸"
  },
  {
    name: "Estonia",
    countryCode2Letter: "EE",
    phoneCode: "+372",
    flag: "🇪🇪"
  },
  {
    name: "Ethiopia",
    countryCode2Letter: "ET",
    phoneCode: "+251",
    flag: "🇪🇹"
  },
  {
    name: "Finland",
    countryCode2Letter: "FI",
    phoneCode: "+358",
    flag: "🇫🇮"
  },
  {
    name: "Fiji",
    countryCode2Letter: "FJ",
    phoneCode: "+679",
    flag: "🇫🇯"
  },
  {
    name: "Falkland Islands (Malvinas)",
    countryCode2Letter: "FK",
    phoneCode: "+500",
    flag: "🇫🇰"
  },
  {
    name: "France",
    countryCode2Letter: "FR",
    phoneCode: "+33",
    flag: "🇫🇷"
  },
  {
    name: "Faroe Islands",
    countryCode2Letter: "FO",
    phoneCode: "+298",
    flag: "🇫🇴"
  },
  {
    name: "Micronesia, Federated States of",
    countryCode2Letter: "FM",
    phoneCode: "+691",
    flag: "🇫🇲"
  },
  {
    name: "Gabon",
    countryCode2Letter: "GA",
    phoneCode: "+241",
    flag: "🇬🇦"
  },
  {
    name: "United Kingdom",
    countryCode2Letter: "GB",
    phoneCode: "+44",
    flag: "🇬🇧"
  },
  {
    name: "Georgia",
    countryCode2Letter: "GE",
    phoneCode: "+995",
    flag: "🇬🇪"
  },
  {
    name: "Guernsey",
    countryCode2Letter: "GG",
    phoneCode: "+44",
    flag: "🇬🇬"
  },
  {
    name: "Ghana",
    countryCode2Letter: "GH",
    phoneCode: "+233",
    flag: "🇬🇭"
  },
  {
    name: "Gibraltar",
    countryCode2Letter: "GI",
    phoneCode: "+350",
    flag: "🇬🇮"
  },
  {
    name: "Guinea",
    countryCode2Letter: "GN",
    phoneCode: "+224",
    flag: "🇬🇳"
  },
  {
    name: "Guadeloupe",
    countryCode2Letter: "GP",
    phoneCode: "+590",
    flag: "🇬🇵"
  },
  {
    name: "Gambia",
    countryCode2Letter: "GM",
    phoneCode: "+220",
    flag: "🇬🇲"
  },
  {
    name: "Guinea-Bissau",
    countryCode2Letter: "GW",
    phoneCode: "+245",
    flag: "🇬🇼"
  },
  {
    name: "Equatorial Guinea",
    countryCode2Letter: "GQ",
    phoneCode: "+240",
    flag: "🇬🇶"
  },
  {
    name: "Greece",
    countryCode2Letter: "GR",
    phoneCode: "+30",
    flag: "🇬🇷"
  },
  {
    name: "Grenada",
    countryCode2Letter: "GD",
    phoneCode: "+1",
    flag: "🇬🇩"
  },
  {
    name: "Greenland",
    countryCode2Letter: "GL",
    phoneCode: "+299",
    flag: "🇬🇱"
  },
  {
    name: "Guatemala",
    countryCode2Letter: "GT",
    phoneCode: "+502",
    flag: "🇬🇹"
  },
  {
    name: "French Guiana",
    countryCode2Letter: "GF",
    phoneCode: "+594",
    flag: "🇬🇫"
  },
  {
    name: "Guam",
    countryCode2Letter: "GU",
    phoneCode: "+1",
    flag: "🇬🇺"
  },
  {
    name: "Guyana",
    countryCode2Letter: "GY",
    phoneCode: "+592",
    flag: "🇬🇾"
  },
  {
    name: "Hong Kong",
    countryCode2Letter: "HK",
    phoneCode: "+852",
    flag: "🇭🇰"
  },
  {
    name: "Heard Island and McDonald Islands",
    countryCode2Letter: "HM",
    phoneCode: "+672",
    flag: "🇭🇲"
  },
  {
    name: "Honduras",
    countryCode2Letter: "HN",
    phoneCode: "+504",
    flag: "🇭🇳"
  },
  {
    name: "Croatia",
    countryCode2Letter: "HR",
    phoneCode: "+385",
    flag: "🇭🇷"
  },
  {
    name: "Haiti",
    countryCode2Letter: "HT",
    phoneCode: "+509",
    flag: "🇭🇹"
  },
  {
    name: "Hungary",
    countryCode2Letter: "HU",
    phoneCode: "+36",
    flag: "🇭🇺"
  },
  {
    name: "Indonesia",
    countryCode2Letter: "ID",
    phoneCode: "+62",
    flag: "🇮🇩"
  },
  {
    name: "Isle of Man",
    countryCode2Letter: "IM",
    phoneCode: "+44",
    flag: "🇮🇲"
  },
  {
    name: "India",
    countryCode2Letter: "IN",
    phoneCode: "+91",
    flag: "🇮🇳"
  },
  {
    name: "British Indian Ocean Territory",
    countryCode2Letter: "IO",
    phoneCode: "+246",
    flag: "🇮🇴"
  },
  {
    name: "Ireland",
    countryCode2Letter: "IE",
    phoneCode: "+353",
    flag: "🇮🇪"
  },
  {
    name: "Iran, Islamic Republic of",
    countryCode2Letter: "IR",
    phoneCode: "+98",
    flag: "🇮🇷"
  },
  {
    name: "Iraq",
    countryCode2Letter: "IQ",
    phoneCode: "+964",
    flag: "🇮🇶"
  },
  {
    name: "Iceland",
    countryCode2Letter: "IS",
    phoneCode: "+354",
    flag: "🇮🇸"
  },
  {
    name: "Israel",
    countryCode2Letter: "IL",
    phoneCode: "+972",
    flag: "🇮🇱"
  },
  {
    name: "Italy",
    countryCode2Letter: "IT",
    phoneCode: "+39",
    flag: "🇮🇹"
  },
  {
    name: "Jamaica",
    countryCode2Letter: "JM",
    phoneCode: "+1",
    flag: "🇯🇲"
  },
  {
    name: "Jersey",
    countryCode2Letter: "JE",
    phoneCode: "+44",
    flag: "🇯🇪"
  },
  {
    name: "Jordan",
    countryCode2Letter: "JO",
    phoneCode: "+962",
    flag: "🇯🇴"
  },
  {
    name: "Japan",
    countryCode2Letter: "JP",
    phoneCode: "+81",
    flag: "🇯🇵"
  },
  {
    name: "Kazakhstan",
    countryCode2Letter: "KZ",
    phoneCode: "+7",
    flag: "🇰🇿"
  },
  {
    name: "Kenya",
    countryCode2Letter: "KE",
    phoneCode: "+254",
    flag: "🇰🇪"
  },
  {
    name: "Kyrgyzstan",
    countryCode2Letter: "KG",
    phoneCode: "+996",
    flag: "🇰🇬"
  },
  {
    name: "Cambodia",
    countryCode2Letter: "KH",
    phoneCode: "+855",
    flag: "🇰🇭"
  },
  {
    name: "Kiribati",
    countryCode2Letter: "KI",
    phoneCode: "+686",
    flag: "🇰🇮"
  },
  {
    name: "Saint Kitts and Nevis",
    countryCode2Letter: "KN",
    phoneCode: "+1",
    flag: "🇰🇳"
  },
  {
    name: "Korea, Republic of",
    countryCode2Letter: "KR",
    phoneCode: "+82",
    flag: "🇰🇷"
  },
  {
    name: "Kuwait",
    countryCode2Letter: "KW",
    phoneCode: "+965",
    flag: "🇰🇼"
  },
  {
    name: "Lao People's Democratic Republic",
    countryCode2Letter: "LA",
    phoneCode: "+856",
    flag: "🇱🇦"
  },
  {
    name: "Lebanon",
    countryCode2Letter: "LB",
    phoneCode: "+961",
    flag: "🇱🇧"
  },
  {
    name: "Liberia",
    countryCode2Letter: "LR",
    phoneCode: "+231",
    flag: "🇱🇷"
  },
  {
    name: "Libya",
    countryCode2Letter: "LY",
    phoneCode: "+218",
    flag: "🇱🇾"
  },
  {
    name: "Saint Lucia",
    countryCode2Letter: "LC",
    phoneCode: "+1",
    flag: "🇱🇨"
  },
  {
    name: "Liechtenstein",
    countryCode2Letter: "LI",
    phoneCode: "+423",
    flag: "🇱🇮"
  },
  {
    name: "Sri Lanka",
    countryCode2Letter: "LK",
    phoneCode: "+94",
    flag: "🇱🇰"
  },
  {
    name: "Lesotho",
    countryCode2Letter: "LS",
    phoneCode: "+266",
    flag: "🇱🇸"
  },
  {
    name: "Lithuania",
    countryCode2Letter: "LT",
    phoneCode: "+370",
    flag: "🇱🇹"
  },
  {
    name: "Luxembourg",
    countryCode2Letter: "LU",
    phoneCode: "+352",
    flag: "🇱🇺"
  },
  {
    name: "Latvia",
    countryCode2Letter: "LV",
    phoneCode: "+371",
    flag: "🇱🇻"
  },
  {
    name: "Macao",
    countryCode2Letter: "MO",
    phoneCode: "+853",
    flag: "🇲🇴"
  },
  {
    name: "Saint Martin (French part)",
    countryCode2Letter: "MF",
    phoneCode: "+590",
    flag: "🇲🇫"
  },
  {
    name: "Morocco",
    countryCode2Letter: "MA",
    phoneCode: "+212",
    flag: "🇲🇦"
  },
  {
    name: "Monaco",
    countryCode2Letter: "MC",
    phoneCode: "+377",
    flag: "🇲🇨"
  },
  {
    name: "Moldova, Republic of",
    countryCode2Letter: "MD",
    phoneCode: "+373",
    flag: "🇲🇩"
  },
  {
    name: "Madagascar",
    countryCode2Letter: "MG",
    phoneCode: "+261",
    flag: "🇲🇬"
  },
  {
    name: "Maldives",
    countryCode2Letter: "MV",
    phoneCode: "+960",
    flag: "🇲🇻"
  },
  {
    name: "Mexico",
    countryCode2Letter: "MX",
    phoneCode: "+52",
    flag: "🇲🇽"
  },
  {
    name: "Marshall Islands",
    countryCode2Letter: "MH",
    phoneCode: "+692",
    flag: "🇲🇭"
  },
  {
    name: "Macedonia, the Former Yugoslav Republic of",
    countryCode2Letter: "MK",
    phoneCode: "+389",
    flag: "🇲🇰"
  },
  {
    name: "Mali",
    countryCode2Letter: "ML",
    phoneCode: "+223",
    flag: "🇲🇱"
  },
  {
    name: "Malta",
    countryCode2Letter: "MT",
    phoneCode: "+356",
    flag: "🇲🇹"
  },
  {
    name: "Myanmar",
    countryCode2Letter: "MM",
    phoneCode: "+95",
    flag: "🇲🇲"
  },
  {
    name: "Montenegro",
    countryCode2Letter: "ME",
    phoneCode: "+382",
    flag: "🇲🇪"
  },
  {
    name: "Mongolia",
    countryCode2Letter: "MN",
    phoneCode: "+976",
    flag: "🇲🇳"
  },
  {
    name: "Northern Mariana Islands",
    countryCode2Letter: "MP",
    phoneCode: "+1",
    flag: "🇲🇵"
  },
  {
    name: "Mozambique",
    countryCode2Letter: "MZ",
    phoneCode: "+258",
    flag: "🇲🇿"
  },
  {
    name: "Mauritania",
    countryCode2Letter: "MR",
    phoneCode: "+222",
    flag: "🇲🇷"
  },
  {
    name: "Montserrat",
    countryCode2Letter: "MS",
    phoneCode: "+1",
    flag: "🇲🇸"
  },
  {
    name: "Martinique",
    countryCode2Letter: "MQ",
    phoneCode: "+596",
    flag: "🇲🇶"
  },
  {
    name: "Mauritius",
    countryCode2Letter: "MU",
    phoneCode: "+230",
    flag: "🇲🇺"
  },
  {
    name: "Malawi",
    countryCode2Letter: "MW",
    phoneCode: "+265",
    flag: "🇲🇼"
  },
  {
    name: "Malaysia",
    countryCode2Letter: "MY",
    phoneCode: "+60",
    flag: "🇲🇾"
  },
  {
    name: "Mayotte",
    countryCode2Letter: "YT",
    phoneCode: "+262",
    flag: "🇾🇹"
  },
  {
    name: "Namibia",
    countryCode2Letter: "NA",
    phoneCode: "+264",
    flag: "🇳🇦"
  },
  {
    name: "New Caledonia",
    countryCode2Letter: "NC",
    phoneCode: "+687",
    flag: "🇳🇨"
  },
  {
    name: "Niger",
    countryCode2Letter: "NE",
    phoneCode: "+227",
    flag: "🇳🇪"
  },
  {
    name: "Norfolk Island",
    countryCode2Letter: "NF",
    phoneCode: "+672",
    flag: "🇳🇫"
  },
  {
    name: "Nigeria",
    countryCode2Letter: "NG",
    phoneCode: "+234",
    flag: "🇳🇬"
  },
  {
    name: "Nicaragua",
    countryCode2Letter: "NI",
    phoneCode: "+505",
    flag: "🇳🇮"
  },
  {
    name: "Niue",
    countryCode2Letter: "NU",
    phoneCode: "+683",
    flag: "🇳🇺"
  },
  {
    name: "Netherlands",
    countryCode2Letter: "NL",
    phoneCode: "+31",
    flag: "🇳🇱"
  },
  {
    name: "Norway",
    countryCode2Letter: "NO",
    phoneCode: "+47",
    flag: "🇳🇴"
  },
  {
    name: "Nepal",
    countryCode2Letter: "NP",
    phoneCode: "+977",
    flag: "🇳🇵"
  },
  {
    name: "Nauru",
    countryCode2Letter: "NR",
    phoneCode: "+674",
    flag: "🇳🇷"
  },
  {
    name: "New Zealand",
    countryCode2Letter: "NZ",
    phoneCode: "+64",
    flag: "🇳🇿"
  },
  {
    name: "Oman",
    countryCode2Letter: "OM",
    phoneCode: "+968",
    flag: "🇴🇲"
  },
  {
    name: "Pakistan",
    countryCode2Letter: "PK",
    phoneCode: "+92",
    flag: "🇵🇰"
  },
  {
    name: "Panama",
    countryCode2Letter: "PA",
    phoneCode: "+507",
    flag: "🇵🇦"
  },
  {
    name: "Pitcairn",
    countryCode2Letter: "PN",
    phoneCode: "+64",
    flag: "🇵🇳"
  },
  {
    name: "Peru",
    countryCode2Letter: "PE",
    phoneCode: "+51",
    flag: "🇵🇪"
  },
  {
    name: "Philippines",
    countryCode2Letter: "PH",
    phoneCode: "+63",
    flag: "🇵🇭"
  },
  {
    name: "Palau",
    countryCode2Letter: "PW",
    phoneCode: "+680",
    flag: "🇵🇼"
  },
  {
    name: "Papua New Guinea",
    countryCode2Letter: "PG",
    phoneCode: "+675",
    flag: "🇵🇬"
  },
  {
    name: "Poland",
    countryCode2Letter: "PL",
    phoneCode: "+48",
    flag: "🇵🇱"
  },
  {
    name: "Puerto Rico",
    countryCode2Letter: "PR",
    phoneCode: "+1",
    flag: "🇵🇷"
  },
  {
    name: "Korea, Democratic People's Republic of",
    countryCode2Letter: "KP",
    phoneCode: "+850",
    flag: "🇰🇵"
  },
  {
    name: "Portugal",
    countryCode2Letter: "PT",
    phoneCode: "+351",
    flag: "🇵🇹"
  },
  {
    name: "Paraguay",
    countryCode2Letter: "PY",
    phoneCode: "+595",
    flag: "🇵🇾"
  },
  {
    name: "Palestine, State of",
    countryCode2Letter: "PS",
    phoneCode: "+970",
    flag: "🇵🇸"
  },
  {
    name: "French Polynesia",
    countryCode2Letter: "PF",
    phoneCode: "+689",
    flag: "🇵🇫"
  },
  {
    name: "Qatar",
    countryCode2Letter: "QA",
    phoneCode: "+974",
    flag: "🇶🇦"
  },
  {
    name: "Réunion",
    countryCode2Letter: "RE",
    phoneCode: "+262",
    flag: "🇷🇪"
  },
  {
    name: "Romania",
    countryCode2Letter: "RO",
    phoneCode: "+40",
    flag: "🇷🇴"
  },
  {
    name: "Russian Federation",
    countryCode2Letter: "RU",
    phoneCode: "+7",
    flag: "🇷🇺"
  },
  {
    name: "Rwanda",
    countryCode2Letter: "RW",
    phoneCode: "+250",
    flag: "🇷🇼"
  },
  {
    name: "Saudi Arabia",
    countryCode2Letter: "SA",
    phoneCode: "+966",
    flag: "🇸🇦"
  },
  {
    name: "Sudan",
    countryCode2Letter: "SD",
    phoneCode: "+249",
    flag: "🇸🇩"
  },
  {
    name: "Senegal",
    countryCode2Letter: "SN",
    phoneCode: "+221",
    flag: "🇸🇳"
  },
  {
    name: "Singapore",
    countryCode2Letter: "SG",
    phoneCode: "+65",
    flag: "🇸🇬"
  },
  {
    name: "South Georgia and the South Sandwich Islands",
    countryCode2Letter: "GS",
    phoneCode: "+500",
    flag: "🇬🇸"
  },
  {
    name: "Saint Helena, Ascension and Tristan da Cunha",
    countryCode2Letter: "SH",
    phoneCode: "+290",
    flag: "🇸🇭"
  },
  {
    name: "Svalbard and Jan Mayen",
    countryCode2Letter: "SJ",
    phoneCode: "+47",
    flag: "🇸🇯"
  },
  {
    name: "Solomon Islands",
    countryCode2Letter: "SB",
    phoneCode: "+677",
    flag: "🇸🇧"
  },
  {
    name: "Sierra Leone",
    countryCode2Letter: "SL",
    phoneCode: "+232",
    flag: "🇸🇱"
  },
  {
    name: "El Salvador",
    countryCode2Letter: "SV",
    phoneCode: "+503",
    flag: "🇸🇻"
  },
  {
    name: "San Marino",
    countryCode2Letter: "SM",
    phoneCode: "+378",
    flag: "🇸🇲"
  },
  {
    name: "Somalia",
    countryCode2Letter: "SO",
    phoneCode: "+252",
    flag: "🇸🇴"
  },
  {
    name: "Saint Pierre and Miquelon",
    countryCode2Letter: "PM",
    phoneCode: "+508",
    flag: "🇵🇲"
  },
  {
    name: "Serbia",
    countryCode2Letter: "RS",
    phoneCode: "+381",
    flag: "🇷🇸"
  },
  {
    name: "South Sudan",
    countryCode2Letter: "SS",
    phoneCode: "+211",
    flag: "🇸🇸"
  },
  {
    name: "Sao Tome and Principe",
    countryCode2Letter: "ST",
    phoneCode: "+239",
    flag: "🇸🇹"
  },
  {
    name: "Suriname",
    countryCode2Letter: "SR",
    phoneCode: "+597",
    flag: "🇸🇷"
  },
  {
    name: "Slovakia",
    countryCode2Letter: "SK",
    phoneCode: "+421",
    flag: "🇸🇰"
  },
  {
    name: "Slovenia",
    countryCode2Letter: "SI",
    phoneCode: "+386",
    flag: "🇸🇮"
  },
  {
    name: "Sweden",
    countryCode2Letter: "SE",
    phoneCode: "+46",
    flag: "🇸🇪"
  },
  {
    name: "Swaziland",
    countryCode2Letter: "SZ",
    phoneCode: "+268",
    flag: "🇸🇿"
  },
  {
    name: "Sint Maarten (Dutch part)",
    countryCode2Letter: "SX",
    phoneCode: "+1",
    flag: "🇸🇽"
  },
  {
    name: "Seychelles",
    countryCode2Letter: "SC",
    phoneCode: "+248",
    flag: "🇸🇨"
  },
  {
    name: "Syrian Arab Republic",
    countryCode2Letter: "SY",
    phoneCode: "+963",
    flag: "🇸🇾"
  },
  {
    name: "Turks and Caicos Islands",
    countryCode2Letter: "TC",
    phoneCode: "+1",
    flag: "🇹🇨"
  },
  {
    name: "Chad",
    countryCode2Letter: "TD",
    phoneCode: "+235",
    flag: "🇹🇩"
  },
  {
    name: "Togo",
    countryCode2Letter: "TG",
    phoneCode: "+228",
    flag: "🇹🇬"
  },
  {
    name: "Thailand",
    countryCode2Letter: "TH",
    phoneCode: "+66",
    flag: "🇹🇭"
  },
  {
    name: "Tajikistan",
    countryCode2Letter: "TJ",
    phoneCode: "+992",
    flag: "🇹🇯"
  },
  {
    name: "Tokelau",
    countryCode2Letter: "TK",
    phoneCode: "+690",
    flag: "🇹🇰"
  },
  {
    name: "Turkmenistan",
    countryCode2Letter: "TM",
    phoneCode: "+993",
    flag: "🇹🇲"
  },
  {
    name: "Timor-Leste",
    countryCode2Letter: "TL",
    phoneCode: "+670",
    flag: "🇹🇱"
  },
  {
    name: "Tonga",
    countryCode2Letter: "TO",
    phoneCode: "+676",
    flag: "🇹🇴"
  },
  {
    name: "Trinidad and Tobago",
    countryCode2Letter: "TT",
    phoneCode: "+1",
    flag: "🇹🇹"
  },
  {
    name: "Tunisia",
    countryCode2Letter: "TN",
    phoneCode: "+216",
    flag: "🇹🇳"
  },
  {
    name: "Turkey",
    countryCode2Letter: "TR",
    phoneCode: "+90",
    flag: "🇹🇷"
  },
  {
    name: "Tuvalu",
    countryCode2Letter: "TV",
    phoneCode: "+688",
    flag: "🇹🇻"
  },
  {
    name: "Taiwan, Province of China",
    countryCode2Letter: "TW",
    phoneCode: "+886",
    flag: "🇹🇼"
  },
  {
    name: "Tanzania, United Republic of",
    countryCode2Letter: "TZ",
    phoneCode: "+255",
    flag: "🇹🇿"
  },
  {
    name: "Uganda",
    countryCode2Letter: "UG",
    phoneCode: "+256",
    flag: "🇺🇬"
  },
  {
    name: "Ukraine",
    countryCode2Letter: "UA",
    phoneCode: "+380",
    flag: "🇺🇦"
  },
  {
    name: "United States Minor Outlying Islands",
    countryCode2Letter: "UM",
    phoneCode: "+1",
    flag: "🇺🇲"
  },
  {
    name: "Uruguay",
    countryCode2Letter: "UY",
    phoneCode: "+598",
    flag: "🇺🇾"
  },
  {
    name: "Uzbekistan",
    countryCode2Letter: "UZ",
    phoneCode: "+998",
    flag: "🇺🇿"
  },
  {
    name: "Holy See (Vatican City State)",
    countryCode2Letter: "VA",
    phoneCode: "+379",
    flag: "🇻🇦"
  },
  {
    name: "Saint Vincent and the Grenadines",
    countryCode2Letter: "VC",
    phoneCode: "+1",
    flag: "🇻🇨"
  },
  {
    name: "Venezuela, Bolivarian Republic of",
    countryCode2Letter: "VE",
    phoneCode: "+58",
    flag: "🇻🇪"
  },
  {
    name: "Virgin Islands, British",
    countryCode2Letter: "VG",
    phoneCode: "+1",
    flag: "🇻🇬"
  },
  {
    name: "Virgin Islands, U.S.",
    countryCode2Letter: "VI",
    phoneCode: "+1",
    flag: "🇻🇮"
  },
  {
    name: "Viet Nam",
    countryCode2Letter: "VN",
    phoneCode: "+84",
    flag: "🇻🇳"
  },
  {
    name: "Vanuatu",
    countryCode2Letter: "VU",
    phoneCode: "+678",
    flag: "🇻🇺"
  },
  {
    name: "Wallis and Futuna",
    countryCode2Letter: "WF",
    phoneCode: "+681",
    flag: "🇼🇫"
  },
  {
    name: "Samoa",
    countryCode2Letter: "WS",
    phoneCode: "+685",
    flag: "🇼🇸"
  },
  {
    name: "Yemen",
    countryCode2Letter: "YE",
    phoneCode: "+967",
    flag: "🇾🇪"
  },
  {
    name: "South Africa",
    countryCode2Letter: "ZA",
    phoneCode: "+27",
    flag: "🇿🇦"
  },
  {
    name: "Zambia",
    countryCode2Letter: "ZM",
    phoneCode: "+260",
    flag: "🇿🇲"
  },
  {
    name: "Zimbabwe",
    countryCode2Letter: "ZW",
    phoneCode: "+263",
    flag: "🇿🇼"
  }
], cs = /(\+1|1\.|\D)/gim, ss = (e) => e && bn(e).replace(cs, ""), wt = (e) => {
  const o = e.replace(/\D/g, "").slice(0, 10), n = "(___) ___-____";
  if (o.length === 0)
    return n;
  let a = "", r = 0;
  for (let i = 0; i < n.length; i++) {
    const s = n[i];
    s === "_" && r < o.length ? (a += o[r], r++) : s === "_" ? a += "_" : a += s;
  }
  return a;
}, Fn = (e, o) => e ? o ? /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)?/.test(e) : /[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)?/.test(e) : void 0, gn = (e) => e && !Fn(e, !0) ? `${ls}${e}` : e, ds = (e) => {
  if (e)
    return /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
      e
    );
}, us = Ce((e, o) => {
  const {
    onChange: n = () => {
    },
    value: a,
    error: r,
    label: i = "Email",
    placeholder: s = "example@gmail.com",
    helperText: l
  } = e, c = !!a && typeof a == "string" && !ds(a), d = (_) => {
    n(typeof _ == "string" ? _ : _.target.value);
  }, g = r !== void 0 ? r : c;
  return /* @__PURE__ */ t(
    Qe,
    {
      ...e,
      error: g,
      helperText: l || (r === void 0 && g ? "Invalid Email" : ""),
      label: i,
      onChange: d,
      placeholder: s,
      ref: o,
      type: _e.EMAIL,
      value: a
    }
  );
}), ms = "_iconButton_t3x40_1", fs = {
  iconButton: ms
}, hs = ({
  showPassword: e,
  setShowPassword: o
}) => /* @__PURE__ */ t(ko, { position: "end", children: /* @__PURE__ */ t(
  ge,
  {
    placement: "top",
    title: e ? "Hide Password" : "Show Password",
    children: /* @__PURE__ */ t(
      Wt,
      {
        "aria-label": e ? "Hide Password" : "Show Password",
        className: fs.iconButton,
        onClick: () => o(!e),
        children: /* @__PURE__ */ t(
          E,
          {
            color: "contentSecondary",
            icon: e ? vo : wo
          }
        )
      }
    )
  }
) }), gs = Ce(
  (e, o) => {
    var r;
    const [n, a] = ke(!1);
    return /* @__PURE__ */ t(
      Qe,
      {
        ...e,
        ref: o,
        endAdornment: /* @__PURE__ */ x(Se, { children: [
          /* @__PURE__ */ t(
            hs,
            {
              showPassword: n,
              setShowPassword: a
            }
          ),
          (r = e.InputProps) == null ? void 0 : r.endAdornment
        ] }),
        type: n ? _e.TEXT : _e.PASSWORD
      }
    );
  }
), ps = "_menuContainer_1vifh_1", _s = "_countryContainer_1vifh_6", Cs = "_smallContainer_1vifh_15", bs = "_disabledContainer_1vifh_20", ut = {
  menuContainer: ps,
  countryContainer: _s,
  smallContainer: Cs,
  disabledContainer: bs
}, ys = Ce(
  ({
    onChange: e,
    value: o,
    label: n,
    country: a,
    setCountry: r,
    size: i,
    id: s,
    disabled: l,
    ...c
  }, d) => {
    const [g, p] = ke(
      wt(bn(o))
    ), [_, C] = ke(
      a || hn[0]
    ), h = (S) => {
      if (typeof S == "string")
        return;
      const M = S.target.value.replace(/\D/g, ""), R = g.replace(/\D/g, "");
      if (M.length === R.length) {
        const X = R.slice(0, -1), U = wt(X);
        p(U);
        const G = {
          ...S,
          target: { ...S.target, value: X }
        };
        e && e(G);
        return;
      }
      if (M.length > 10)
        return;
      const B = wt(M);
      p(B);
      const H = {
        ...S,
        target: { ...S.target, value: ss(M) }
      };
      e && e(H);
    }, u = a || r, v = i === rt.SMALL;
    return /* @__PURE__ */ x(Se, { children: [
      u && /* @__PURE__ */ t(
        z,
        {
          component: "label",
          "data-testid": "phone-input-label",
          htmlFor: s || "phone-input",
          variant: v ? "captionReg500" : "bodySm500",
          children: n || "Phone number"
        }
      ),
      /* @__PURE__ */ x(k, { alignItems: "center", gap: 0.75, children: [
        u && /* @__PURE__ */ t(
          Et,
          {
            anchorButtonTestId: "country-code-anchor",
            anchorContent: ({ open: S }) => /* @__PURE__ */ x(
              k,
              {
                alignItems: "center",
                className: L(ut.countryContainer, {
                  [ut.smallContainer]: v,
                  [ut.disabledContainer]: l
                }),
                justifyContent: "space-between",
                children: [
                  /* @__PURE__ */ x(
                    z,
                    {
                      color: l ? "contentDisabledOnDisabledSurface" : void 0,
                      variant: v ? "bodySm400" : "bodyReg400",
                      children: [
                        _.flag,
                        " ",
                        _.phoneCode
                      ]
                    }
                  ),
                  /* @__PURE__ */ t(
                    E,
                    {
                      icon: Mo,
                      rotation: S ? 180 : void 0
                    }
                  )
                ]
              }
            ),
            "data-testid": "country-code-menu",
            disabled: l,
            menuProps: {
              items: hn.map((S) => ({
                id: S.name,
                onClick: () => {
                  r && (r(S), C(S));
                },
                textContent: () => /* @__PURE__ */ t(k, { alignItems: "center", children: /* @__PURE__ */ x(z, { variant: v ? "bodySm400" : "bodyReg400", children: [
                  S.flag,
                  " ",
                  S.name
                ] }) })
              })),
              selectedId: _.name
            },
            paperClass: ut.menuContainer
          }
        ),
        /* @__PURE__ */ t(
          Qe,
          {
            ...c,
            disabled: l,
            id: s || "phone-input",
            label: u ? void 0 : n,
            onChange: h,
            ref: d,
            size: i,
            type: _e.PHONE,
            value: g
          }
        )
      ] })
    ] });
  }
), Ls = "_searchInputRoot_ny3di_1", Ss = "_searchInputLabel_ny3di_6", xs = "_smallSearchInputLabel_ny3di_16", vs = "_shrinkLabel_ny3di_24", ws = "_icon_ny3di_28", ks = "_smallIcon_ny3di_32", Ee = {
  searchInputRoot: Ls,
  searchInputLabel: Ss,
  smallSearchInputLabel: xs,
  shrinkLabel: vs,
  icon: ws,
  smallIcon: ks
}, Ms = Ce((e, o) => {
  const [n, a] = ke(!1), { floatingLabel: r, label: i, onBlur: s, onFocus: l, onChange: c, size: d, value: g } = e, p = r || i, _ = it(null), C = d === rt.SMALL, h = /* @__PURE__ */ t(
    E,
    {
      className: L(Ee.icon, { [Ee.smallIcon]: C }),
      icon: Io
    }
  ), v = /* @__PURE__ */ t(
    Wt,
    {
      "data-testid": "clear-search-button",
      removePadding: !0,
      onClick: () => {
        if (!c)
          return;
        c({
          target: {
            value: ""
          }
        });
      },
      children: /* @__PURE__ */ t(
        E,
        {
          className: L(Ee.icon, { [Ee.smallIcon]: C }),
          icon: pt
        }
      )
    }
  );
  return gt(() => {
    var S, D, M, R, B, H, X, U;
    if (i) {
      (B = _ == null ? void 0 : _.current) == null || B.setAttribute(
        "size",
        String(((R = (M = (D = (S = _ == null ? void 0 : _.current) == null ? void 0 : S.labels) == null ? void 0 : D[0]) == null ? void 0 : M.textContent) == null ? void 0 : R.length) ?? "")
      );
      return;
    }
    (U = _ == null ? void 0 : _.current) == null || U.setAttribute(
      "size",
      String(((X = (H = _.current) == null ? void 0 : H.getAttribute("placeholder")) == null ? void 0 : X.length) ?? "")
    );
  }, [i]), /* @__PURE__ */ t(
    Qe,
    {
      "data-testid": "search-input",
      inputRef: _,
      ref: o,
      startAdornment: h,
      endAdornment: g ? v : void 0,
      useFloatingLabel: !0,
      inputRootClass: Ee.searchInputRoot,
      InputLabelProps: {
        shrink: !!g || n,
        classes: {
          root: L({
            [Ee.searchInputLabel]: !n && !g,
            [Ee.smallSearchInputLabel]: C
          }),
          shrink: Ee.shrinkLabel
        }
      },
      onBlur: (S) => {
        a(!1), s == null || s(S);
      },
      onFocus: (S) => {
        a(!0), l == null || l(S);
      },
      ...e,
      label: n || g ? p : i
    }
  );
}), $s = Ce((e, o) => {
  const {
    error: n,
    helperText: a,
    label: r = "URL",
    onChange: i = () => {
    },
    placeholder: s = "https://",
    value: l
  } = e, c = (C) => {
    i(typeof C == "string" ? C : C.target.value);
  }, d = (C) => {
    i(gn(C.currentTarget.value));
  }, g = (C) => {
    C.key === "Enter" && i(gn(C.currentTarget.value));
  }, p = !!l && typeof l == "string" && !Fn(l, !1) || n;
  return /* @__PURE__ */ t(
    Qe,
    {
      ...e,
      error: p,
      helperText: a || (p ? "Invalid URL format" : ""),
      label: r,
      onBlur: d,
      onChange: c,
      onKeyUp: g,
      placeholder: s,
      ref: o,
      type: _e.URL,
      value: l
    }
  );
}), Wu = Ce((e, o) => {
  const { type: n } = e;
  switch (n) {
    case _e.PASSWORD:
      return /* @__PURE__ */ t(gs, { ref: o, ...e });
    case _e.SEARCH:
      return /* @__PURE__ */ t(Ms, { ref: o, ...e });
    case _e.PHONE:
      return /* @__PURE__ */ t(ys, { ref: o, ...e });
    case _e.URL:
      return /* @__PURE__ */ t($s, { ref: o, ...e });
    case _e.EMAIL:
      return /* @__PURE__ */ t(us, { ref: o, ...e });
    default:
      return /* @__PURE__ */ t(Qe, { ref: o, ...e });
  }
}), Ds = "_blueHover_1dzzk_6", Fs = "_underline_1dzzk_10", pn = {
  blueHover: Ds,
  underline: Fs
}, Is = (e) => {
  const {
    href: o = "#",
    color: n = "contentLinkDefault",
    children: a,
    className: r = "",
    forceUnderline: i = !1,
    forceDisableNewTab: s = !1
  } = e, l = Ye(o) ? "a" : lt, c = Ye(o) ? {
    href: o,
    target: s ? "_self" : "_blank",
    rel: s ? void 0 : "noreferrer noopener",
    "data-testid": "absolute-link"
  } : { to: o, "data-testid": "react-router-link" };
  return /* @__PURE__ */ t(
    z,
    {
      className: L("textLink", r, {
        [pn.blueHover]: n === "contentLinkDefault",
        [pn.underline]: i
      }),
      color: n,
      component: l,
      ...e,
      ...c,
      children: a
    }
  );
}, Bs = "_labelLeft_11ufj_5", Rs = "_label_11ufj_5", Ns = "_labelTop_11ufj_14", Ts = "_switchThumb_11ufj_22", Ws = "_switchTrack_11ufj_26", As = "_switchChecked_11ufj_32", zs = "_root_11ufj_37", Es = "_small_11ufj_37", Os = "_switchDisabled_11ufj_46", Hs = "_switchBase_11ufj_66", Gs = "_description_11ufj_92", js = "_medium_11ufj_96", Us = "_switchContainer_11ufj_97", se = {
  labelLeft: Bs,
  label: Rs,
  labelTop: Ns,
  switchThumb: Ts,
  switchTrack: Ws,
  switch: "_switch_11ufj_22",
  switchChecked: As,
  root: zs,
  small: Es,
  switchDisabled: Os,
  switchBase: Hs,
  description: Gs,
  medium: js,
  switchContainer: Us
};
var In = /* @__PURE__ */ ((e) => (e.Right = "right", e.Top = "top", e.Left = "left", e))(In || {}), Bn = /* @__PURE__ */ ((e) => (e.Small = "small", e.Medium = "medium", e))(Bn || {});
const Au = ({
  size: e = Bn.Medium,
  labelDirection: o = In.Right,
  name: n,
  checked: a,
  disabled: r,
  onChange: i,
  value: s,
  label: l,
  "data-testid": c,
  description: d,
  "aria-label": g,
  containerClass: p = "",
  classes: _,
  inputProps: C,
  ...h
}) => {
  const u = e === "small", v = e === "medium", S = u ? "captionReg500" : "bodyReg500", D = u ? "captionSm500" : "bodySm400", M = l || d;
  return /* @__PURE__ */ x(
    k,
    {
      alignItems: "start",
      columnGap: 1,
      rowGap: 1,
      className: L(se.root, p, {
        [se.small]: u,
        [se.medium]: v,
        [se.labelLeft]: o === "left" && l,
        [se.labelTop]: o === "top" && l
      }),
      children: [
        /* @__PURE__ */ t(k, { alignItems: "center", className: se.switchContainer, children: /* @__PURE__ */ t(
          $o,
          {
            id: n,
            name: n,
            size: e,
            value: s,
            checked: a,
            disabled: r,
            onChange: i,
            classes: {
              root: se.switch,
              thumb: se.switchThumb,
              track: se.switchTrack,
              checked: se.switchChecked,
              switchBase: se.switchBase,
              disabled: se.switchDisabled,
              ..._
            },
            inputProps: {
              // data-testid not part of Mui inputProps
              // @ts-ignore
              "data-testid": c,
              ...g ? { "aria-label": g } : {},
              ...C
            },
            ...h
          }
        ) }),
        M && /* @__PURE__ */ x(k, { flexDirection: "column", children: [
          l && /* @__PURE__ */ t(
            z,
            {
              className: se.label,
              variant: S,
              component: "label",
              htmlFor: n,
              children: l
            }
          ),
          d && /* @__PURE__ */ t(
            z,
            {
              className: se.description,
              variant: D,
              component: "label",
              htmlFor: n,
              children: d
            }
          )
        ] })
      ]
    }
  );
}, Xs = "_paper_10qwm_1", qs = "_popoverPaper_10qwm_9", Ys = "_menuPaper_10qwm_13", Zs = "_popoverContainer_10qwm_21", Ks = "_menuIconRight_10qwm_25", Vs = "_arrow_10qwm_30", Js = "_arrowBottom_10qwm_41", Qs = "_arrowTop_10qwm_48", Ps = "_arrowLeft_10qwm_55", ed = "_arrowRight_10qwm_62", td = "_anchorButton_10qwm_68", nd = "_bottom_10qwm_75", od = "_top_10qwm_76", ad = "_left_10qwm_80", rd = "_right_10qwm_81", id = "_noArrow_10qwm_85", ld = "_hoverable_10qwm_90", cd = "_disabled_10qwm_91", de = {
  paper: Xs,
  popoverPaper: qs,
  menuPaper: Ys,
  popoverContainer: Zs,
  menuIconRight: Ks,
  arrow: Vs,
  arrowBottom: Js,
  arrowTop: Qs,
  arrowLeft: Ps,
  arrowRight: ed,
  anchorButton: td,
  bottom: nd,
  top: od,
  left: ad,
  right: rd,
  noArrow: id,
  hoverable: ld,
  disabled: cd
}, sd = "_root_156cw_1", dd = "_disabled_156cw_5", ud = "_textContent_156cw_24", md = "_menuIconRight_156cw_28", fd = "_wrapper_156cw_33", et = {
  root: sd,
  disabled: dd,
  textContent: ud,
  menuIconRight: md,
  wrapper: fd
}, hd = ({
  children: e,
  href: o = "",
  className: n,
  disabled: a = !1
}) => {
  if (!o || a)
    return /* @__PURE__ */ t("span", { className: n, children: e });
  const r = (i) => {
    i.preventDefault();
  };
  return Ye(o) ? /* @__PURE__ */ t(
    "a",
    {
      className: n,
      href: o,
      onClick: r,
      rel: "noreferrer noopener",
      target: "_blank",
      children: e
    }
  ) : /* @__PURE__ */ t(lt, { className: n, onClick: r, to: o, children: e });
}, gd = je.forwardRef(
  ({
    item: e,
    index: o,
    menuClasses: n,
    menuProps: a,
    handleClose: r,
    ...i
  }) => {
    const s = ro(), l = it(null), { selectedId: c, items: d, withDivider: g } = a || {}, {
      textContent: p,
      onClick: _ = () => {
      },
      iconLeft: C,
      iconRight: h,
      tooltipProps: u,
      disabled: v = !1,
      id: S,
      href: D
    } = e || {}, M = c && S && c === S, R = h !== !1 && (h || M || u), B = (d == null ? void 0 : d.length) || 0, H = o < B - 1 && g, X = () => h === !1 ? null : h || (M ? /* @__PURE__ */ t(E, { "data-testid": "selected-check", icon: Fo }) : u ? /* @__PURE__ */ t(E, { icon: Do }) : null), { title: U = "", placement: G = "right" } = u || {}, T = (ue) => {
      v || (ue.preventDefault(), ue.stopPropagation(), r(), _(S || o), D && setTimeout(() => {
        Ye(D) ? window.open(D, "_blank", "noopener noreferrer") : s(D);
      }, 10));
    }, N = () => p ? typeof p == "string" ? /* @__PURE__ */ t(
      z,
      {
        className: et.textContent,
        color: v ? "contentDisabledDefault" : "contentDefault",
        noWrap: !0,
        variant: (a == null ? void 0 : a.textVariant) || "bodySm500",
        children: p
      }
    ) : p({ onClose: r }) : null;
    return gt(() => {
      !M || !(l != null && l.current) || l == null || l.current.scrollIntoView({
        block: "center"
      });
    }, [M]), /* @__PURE__ */ x(Se, { children: [
      /* @__PURE__ */ t(
        ge,
        {
          placement: G,
          title: U,
          ...u,
          children: /* @__PURE__ */ t(
            Un,
            {
              ref: l,
              ...i,
              classes: {
                root: L(et.root, n == null ? void 0 : n.item, { [et.disabled]: v })
              },
              "data-testid": `menu-item-${S || o}`,
              onClick: T,
              children: /* @__PURE__ */ x(hd, { className: et.wrapper, disabled: v, href: D, children: [
                C && /* @__PURE__ */ t(
                  Xt,
                  {
                    classes: {
                      root: n == null ? void 0 : n.iconLeft
                    },
                    children: C
                  }
                ),
                N(),
                R && /* @__PURE__ */ t(
                  Xt,
                  {
                    classes: {
                      root: L(et.menuIconRight, n == null ? void 0 : n.iconRight)
                    },
                    children: X()
                  }
                )
              ] })
            }
          )
        },
        (a == null ? void 0 : a.selectedId) || o
      ),
      H && /* @__PURE__ */ t(Xn, { component: "li", "data-testid": "divider" })
    ] });
  }
), Et = ({
  anchorButtonClass: e,
  anchorButtonTestId: o = "popover-anchor-button",
  anchorContent: n = () => /* @__PURE__ */ t("button", { type: "button", children: "Anchor" }),
  "aria-label": a,
  disabled: r = !1,
  disabledMessage: i = "Disabled",
  hideArrow: s = !1,
  hoverable: l = !1,
  messagePlacement: c = "top",
  onAnchorClick: d = () => null,
  onCloseCallback: g = () => null,
  paperClass: p,
  placement: _ = "bottom",
  popoverContent: C = () => /* @__PURE__ */ t("div", {}),
  tooltipProps: h,
  menuProps: u,
  menuClasses: v,
  withCustomAnchor: S,
  wrapperClass: D,
  ...M
}) => {
  const [R, B] = ke(null), H = it(null), X = u ? qn : Yn, U = {
    bottom: {
      anchorOrigin: { vertical: "bottom", horizontal: "center" },
      transformOrigin: { vertical: "top", horizontal: "center" }
    },
    top: {
      anchorOrigin: { vertical: "top", horizontal: "center" },
      transformOrigin: { vertical: "bottom", horizontal: "center" }
    },
    left: {
      anchorOrigin: { vertical: "center", horizontal: "left" },
      transformOrigin: { vertical: "center", horizontal: "right" }
    },
    right: {
      anchorOrigin: { vertical: "center", horizontal: "right" },
      transformOrigin: { vertical: "center", horizontal: "left" }
    }
  }, G = (b) => {
    d(), B(R ? null : b.currentTarget);
  }, T = () => {
    B(null), g();
  }, N = (b) => {
    l && B(b.currentTarget);
  }, ue = () => {
    l && (B(null), g());
  }, Me = () => !r && !(h != null && h.title) ? "" : (h == null ? void 0 : h.title) || i, F = !!R, y = {
    "aria-expanded": F,
    "aria-label": a,
    "aria-owns": l && F ? "mouse-over-popover" : void 0,
    "aria-haspopup": "true",
    "data-testid": o,
    disabled: r,
    type: "button",
    onClick: G,
    onMouseEnter: N,
    onMouseLeave: ue,
    className: L(
      de.anchorButton,
      de[_],
      {
        [de.hoverable]: l,
        [de.noArrow]: s,
        [de.disabled]: r
      },
      e
    )
  };
  return /* @__PURE__ */ x(Se, { children: [
    /* @__PURE__ */ t(
      ge,
      {
        title: Me(),
        placement: c,
        ...h,
        children: S ? n({ disabled: r, open: F, anchorElementProps: y }) : /* @__PURE__ */ t("button", { ...y, children: n({ disabled: r, open: F, anchorElementProps: y }) })
      }
    ),
    /* @__PURE__ */ t(
      X,
      {
        sx: l ? { pointerEvents: "none" } : void 0,
        ...U[_],
        ...M,
        id: l ? "mouse-over-popover" : void 0,
        open: F,
        anchorEl: R,
        anchorReference: "anchorEl",
        onClose: T,
        disableRestoreFocus: l,
        disableEnforceFocus: l,
        classes: {
          root: D,
          paper: L(de.paper, p, {
            [de.popoverPaper]: !u,
            [de.menuPaper]: u
          })
        },
        children: Array.isArray(u == null ? void 0 : u.items) ? u.items.map((b, $) => /* @__PURE__ */ t(
          gd,
          {
            item: b,
            index: $,
            menuClasses: v,
            menuProps: u,
            handleClose: T
          },
          b.id || $
        )) : /* @__PURE__ */ x("div", { className: de.popoverContainer, children: [
          !s && /* @__PURE__ */ t(
            "span",
            {
              ref: H,
              className: L(de.arrow, {
                [de.arrowBottom]: _ === "bottom",
                [de.arrowTop]: _ === "top",
                [de.arrowLeft]: _ === "left",
                [de.arrowRight]: _ === "right"
              })
            }
          ),
          C({ setAnchor: B })
        ] })
      }
    )
  ] });
};
export {
  Oo as Avatar,
  Je as Badge,
  he as Button,
  wu as Calendar,
  Tt as Card,
  Tr as CardCap,
  ri as Checkbox,
  Sn as ClickableComponent,
  ku as Divider,
  Ai as Drawer,
  Mu as EmojiEmptyState,
  k as Flexbox,
  E as FontAwesomeIcon,
  Wt as IconButton,
  Gi as InfoNote,
  $u as LoadingOverlay,
  ml as Modal,
  Du as MuiThemeProvider,
  gl as OverflowText,
  Fu as ProgressBar,
  Iu as SegmentedControl,
  Bu as Skeleton,
  Ru as StatusLozenge,
  Nu as StatusVisualizationFilter,
  zc as Tab,
  Tu as Tabs,
  z as Text,
  Wu as TextInput,
  Is as TextLink,
  Au as Toggle,
  ge as Tooltip,
  Su as UserBlock,
  Et as WithPopover,
  xu as camelCase,
  f as cssVars,
  bn as ensureString,
  vu as generateCssVarsPlugin,
  na as kebabCase,
  la as theme,
  Nt as useMediaInfo
};
